// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.8.1/css/all.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #0255A5;
  --primary-color-rgb:2, 85, 165;
  --primary-color-hover:#0F3B66;
  --primary-color-opacity: rgba(2, 85, 165, 0.1);
  --light-grey:#F9F9F9;
  --light-grey-rgb:249, 249, 249;
  --dark-grey:#9A9C9F;
  --dark-grey-rgb:154, 156, 159;
  --darkGrey:#1b232c;
  --hover-bg-color:#E4E8EF;
  --white-bg-hover:#e8eff2;
  --light-blue:#6A80A9;
  --purple:#675081;
  --purple-rgb:103, 80, 129;
  --textHighlightBgColor:rgba(191, 219, 253, 0.90);
  --textHighlightFontColor:var(--primary-font-color);
  --primary-font-color: var(--surface-500);
  --primary-font-color-rgb: var(--surface-500-rgb);
  --secondary-font-color: var(--surface-700);
  --disabled-font-color:#828b97;
  --font:"Open Sans", Arial, sans-serif;
  --h1:24px;
  --h2:18px;
  --h3:16px;
  --h4:13px;
  --bodyFontSize:14px;
  --tableFontSize:12px;
  --pageTitleSize:var(--h1);
  --sectionTitleSize:var(--h2);
  --sectionSubTitleSize:var(--tableFontSize);
  --sectionTitleLabel:var(--h3);
  --accordionTitleSize:var(--sectionTitleSize);
  --border-color: var(--surface-100);
  --darkBorderColor: var(--textHighlightFontColor);
  --table-border-color:#E8EFF2;
  --table-border-style:1px solid var(--table-border-color);
  --border-style:1px solid var(--border-color);
  --border-lg-radius:8px;
  --border-m-radius:4px;
  --border-m-radius-top:4px 4px 0px 0px;
  --border-m-radius-bottom:0px 0px 4px 4px;
  --border-sm-radius:2px;
  --border-radius-tab:2px 2px 0px 0px;
  --selected-text:#E4E8EF;
  --selected-bg:#E4E8EF;
  --table-alt-row-color: var(--light-grey);
  --alert-warning:#D6BA17;
  --alert-warning-rgb:214, 186, 23;
  --alert-warning-opacity: rgba(214, 186, 23, 0.10);
  --alert-success:#02a570;
  --alert-success-rgb:2, 165, 112;
  --alert-success-opacity: rgba(2, 165, 112, 0.10);
  --alert-info: var(--primary-color);
  --alert-info-rgb: var(--primary-color-rgb);
  --alert-info-opacity: rgba(2, 85, 165, 0.11);
  --alert-danger:#E02222;
  --alert-danger-rgb:224, 34, 34;
  --alert-danger-opacity: rgba(224, 34, 34, 0.10);
  --alert-danger-hover: #871a1a;
  --alert-medium:#F97031;
  --alert-medium-rgb:249, 112, 49;
  --brown:#5b4434;
  --notification-warning-bg:#FAF8E7;
  --notification-info-bg:#E5EEF6;
  --notification-error-bg:#FBE8E8;
  --notification-success-bg:#E5F6F0;
  --shadow-color:rgba(89,101,118,0.32);
  --shadow-sm: 0 2px 5px 0 var(--shadow-color);
  --shadow-md: 0 0px 10px 0 var(--shadow-color);
  --shadow-md-top: 0 -5px 10px 5px var(--shadow-color);
  --accent: \$primary-color !important;
  --primary: \$primary-color!important;
  --series-a: \$primary-color !important;
  --primary-0:#ebf7ff;
  --primary-0-rgb:235, 247, 255;
  --primary-50:#a9d3ef;
  --primary-100:#6fb2de;
  --primary-100-rgb:111, 178, 222;
  --primary-200:#4093cd;
  --primary-300:#1c74ba;
  --primary-300-rgb:28, 116, 186;
  --primary-400:#0255A5;
  --primary-500:#0046aa;
  --primary-600:#0b399c;
  --primary-700:#102669;
  --primary-800:#08112d;
  --primary-900:#070a16;
  --white:#ffffff;
  --white-rgb:255, 255, 255;
  --surface-0: #fefefe;
  --surface-50: #d7dfe5;
  --surface-50-rgb:215, 223, 229;
  --surface-100: #bac4cb;
  --surface-100-rgb:186, 196, 203;
  --surface-200: #9ea8b1;
  --surface-200-rgb:158, 168, 177;
  --surface-300: #828b97;
  --surface-400: #666f7d;
  --surface-500: #4B5363;
  --surface-500-rgb:75, 83, 99;
  --surface-600: #373d4f;
  --surface-700: #25283a;
  --surface-700-rgb:37, 40, 58;
  --surface-800: #151726;
  --surface-800-rgb:21, 23, 38;
  --surface-900: #090912;
  --size-0: 2px;
  --size-50: 4px;
  --size-100: 6px;
  --size-200: 8px;
  --size-300: 10px;
  --size-400: 16px;
  --size-500: 32px;
  --size-600: 48px;
  --size-700: 54px;
  --size-800: 70px;
  --size-900: 86px;
  --media-tablet-pro: 992px;
  --media-tablet: var(--media-tablet-pro);
  --media-mobile: 480px;
  --media-min: 0px;
  --priority-pm:var(--primary-color);
  --priority-high:var(--alert-danger);
  --priority-hot-parts: #059ea5;
  --priority-warranty: #e035bf;
  --priority-overtime-approval:var(--alert-warning);
  --priority-normal:var(--alert-success);
  --priority-special-equipment:#675081;
  --priority-locked-scheduled:var(--secondary-font-color);
}
:root .zuggit-base {
  --primary-color: #323283;
  --primary-0: #f2f4ff;
  --primary-0-rgb:242, 244, 255;
  --primary-50: #c4c5f2;
  --primary-100: #9b9be6;
  --primary-100-rgb:155, 155, 230;
  --primary-200: #7b7cd9;
  --primary-300: #5a5acb;
  --primary-300-rgb:90, 90, 203;
  --primary-400: #323283;
  --primary-500: #2a2a95;
  --primary-600: #242484;
  --primary-700: #1d1d63;
  --primary-800: #141441;
  --primary-900: #0c0c22;
  --surface-0: #fbfaff;
  --surface-50: #dcd9e4;
  --surface-50-rgb:220, 217, 228;
  --surface-100: #c1beca;
  --surface-100-rgb:193, 190, 202;
  --surface-200: #a6a3b1;
  --surface-200-rgb:166, 163, 177;
  --surface-300: #8b8798;
  --surface-400: #716c80;
  --surface-500: #585166;
  --surface-500-rgb:88, 81, 102;
  --surface-600: #423b4f;
  --surface-700: #2e2938;
  --surface-700-rgb:46, 41, 56;
  --surface-800: #1c1824;
  --surface-800-rgb:28, 24, 36;
  --surface-900: #0d0a12;
}

.m-0 {
  margin: 0;
}
.m-1 {
  margin: var(--size-100);
}
.m-2 {
  margin: var(--size-200);
}
.m-3 {
  margin: var(--size-300);
}
.m-4 {
  margin: var(--size-400);
}
.m-5 {
  margin: var(--size-500);
}
.m-6 {
  margin: var(--size-600);
}
.m-7 {
  margin: var(--size-700);
}
.m-8 {
  margin: var(--size-800);
}
.m-9 {
  margin: var(--size-900);
}
.mt-0 {
  margin-top: 0;
}
.mt-1 {
  margin-top: var(--size-100);
}
.mt-2 {
  margin-top: var(--size-200);
}
.mt-3 {
  margin-top: var(--size-300);
}
.mt-4 {
  margin-top: var(--size-400);
}
.mt-5 {
  margin-top: var(--size-500);
}
.mt-6 {
  margin-top: var(--size-600);
}
.mt-7 {
  margin-top: var(--size-700);
}
.mt-8 {
  margin-top: var(--size-800);
}
.mt-9 {
  margin-top: var(--size-900);
}
.mr-0 {
  margin-right: 0;
}
.mr-1 {
  margin-right: var(--size-100);
}
.mr-2 {
  margin-right: var(--size-200);
}
.mr-3 {
  margin-right: var(--size-300);
}
.mr-4 {
  margin-right: var(--size-400);
}
.mr-5 {
  margin-right: var(--size-500);
}
.mr-6 {
  margin-right: var(--size-600);
}
.mr-7 {
  margin-right: var(--size-700);
}
.mr-8 {
  margin-right: var(--size-800);
}
.mr-9 {
  margin-right: var(--size-900);
}
.mb-0 {
  margin-bottom: 0;
}
.mb-1 {
  margin-bottom: var(--size-100);
}
.mb-2 {
  margin-bottom: var(--size-200);
}
.mb-3 {
  margin-bottom: var(--size-300);
}
.mb-4 {
  margin-bottom: var(--size-400);
}
.mb-5 {
  margin-bottom: var(--size-500);
}
.mb-6 {
  margin-bottom: var(--size-600);
}
.mb-7 {
  margin-bottom: var(--size-700);
}
.mb-8 {
  margin-bottom: var(--size-800);
}
.mb-9 {
  margin-bottom: var(--size-900);
}
.ml-0 {
  margin-left: 0;
}
.ml-1 {
  margin-left: var(--size-100);
}
.ml-2 {
  margin-left: var(--size-200);
}
.ml-3 {
  margin-left: var(--size-300);
}
.ml-4 {
  margin-left: var(--size-400);
}
.ml-5 {
  margin-left: var(--size-500);
}
.ml-6 {
  margin-left: var(--size-600);
}
.ml-7 {
  margin-left: var(--size-700);
}
.ml-8 {
  margin-left: var(--size-800);
}
.ml-9 {
  margin-left: var(--size-900);
}

.p-0 {
  padding: 0;
}
.p-1 {
  padding: var(--size-100);
}
.p-2 {
  padding: var(--size-200);
}
.p-3 {
  padding: var(--size-300);
}
.p-4 {
  padding: var(--size-400);
}
.p-5 {
  padding: var(--size-500);
}
.p-6 {
  padding: var(--size-600);
}
.p-7 {
  padding: var(--size-700);
}
.p-8 {
  padding: var(--size-800);
}
.p-9 {
  padding: var(--size-900);
}
.pt-0 {
  padding-top: 0;
}
.pt-1 {
  padding-top: var(--size-100);
}
.pt-2 {
  padding-top: var(--size-200);
}
.pt-3 {
  padding-top: var(--size-300);
}
.pt-4 {
  padding-top: var(--size-400);
}
.pt-5 {
  padding-top: var(--size-500);
}
.pt-6 {
  padding-top: var(--size-600);
}
.pt-7 {
  padding-top: var(--size-700);
}
.pt-8 {
  padding-top: var(--size-800);
}
.pt-9 {
  padding-top: var(--size-900);
}
.pr-0 {
  padding-right: 0;
}
.pr-1 {
  padding-right: var(--size-100);
}
.pr-2 {
  padding-right: var(--size-200);
}
.pr-3 {
  padding-right: var(--size-300);
}
.pr-4 {
  padding-right: var(--size-400);
}
.pr-5 {
  padding-right: var(--size-500);
}
.pr-6 {
  padding-right: var(--size-600);
}
.pr-7 {
  padding-right: var(--size-700);
}
.pr-8 {
  padding-right: var(--size-800);
}
.pr-9 {
  padding-right: var(--size-900);
}
.pb-0 {
  padding-bottom: 0;
}
.pb-1 {
  padding-bottom: var(--size-100);
}
.pb-2 {
  padding-bottom: var(--size-200);
}
.pb-3 {
  padding-bottom: var(--size-300);
}
.pb-4 {
  padding-bottom: var(--size-400);
}
.pb-5 {
  padding-bottom: var(--size-500);
}
.pb-6 {
  padding-bottom: var(--size-600);
}
.pb-7 {
  padding-bottom: var(--size-700);
}
.pb-8 {
  padding-bottom: var(--size-800);
}
.pb-9 {
  padding-bottom: var(--size-900);
}
.pl-0 {
  padding-left: 0;
}
.pl-1 {
  padding-left: var(--size-100);
}
.pl-2 {
  padding-left: var(--size-200);
}
.pl-3 {
  padding-left: var(--size-300);
}
.pl-4 {
  padding-left: var(--size-400);
}
.pl-5 {
  padding-left: var(--size-500);
}
.pl-6 {
  padding-left: var(--size-600);
}
.pl-7 {
  padding-left: var(--size-700);
}
.pl-8 {
  padding-left: var(--size-800);
}
.pl-9 {
  padding-left: var(--size-900);
}

/*%pageTitleFont{
    font-size:\$pageTitleSize;
    font-weight:800;
}
%sectionTitleFont{
    font-size:var(--sectionTitleSize);
    font-weight:800;
}
%sectionSubTitleFont{
    font-size:var(--sectionSubTitleSize);
    font-weight:400;
}*/
/* chart 
buttons
date input
dialogs
dropdowns
iputs
grid
label
layout
tab strip
bound bar
menues
popup
scroll view
toolbar
tool tip
editor */
.k-animation-container .k-tooltip {
  box-shadow: var(--shadow-sm);
  color: #ffffff;
  border: var(--border-style);
  border-radius: var(--border-m-radius);
  border-width: 0px;
  background-color: var(--primary-color);
  padding: 10px;
  line-height: 1.6em;
}
.k-animation-container .k-tooltip:not(.k-tooltip-closable) {
  font-size: 12px;
}
.k-animation-container .k-tooltip .k-tooltip-content {
  max-width: 800px;
}
.k-animation-container .k-tooltip .k-callout {
  position: absolute;
  width: 16px;
  height: 8px;
  overflow: hidden;
  border-width: 0px;
}
.k-animation-container .k-tooltip .k-callout:after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  left: 50%;
  transform: translate(-50%, 50%) rotate(45deg);
  background-color: var(--primary-color);
  border: var(--border-style);
  box-shadow: var(--shadow-sm);
  border-width: 0px;
}
.k-animation-container .k-tooltip .k-callout.k-callout-n {
  top: -7px !important;
}
.k-animation-container .k-tooltip .k-callout.k-callout-s {
  bottom: -7px;
  transform: rotateX(180deg) !important;
}

.k-callout-n {
  margin-left: -8px;
  top: -8px !important;
  bottom: -8px !important;
}

.k-animation-container.cp-light-tooltip .k-tooltip, .k-animation-container.cp-light-tooltip-no-padding .k-tooltip {
  color: var(--primary-font-color);
  border: var(--border-style);
  border-width: 0px;
  background-color: #ffffff;
}
.k-animation-container.cp-light-tooltip .k-tooltip .k-callout, .k-animation-container.cp-light-tooltip-no-padding .k-tooltip .k-callout {
  border: none;
}
.k-animation-container.cp-light-tooltip .k-tooltip .k-callout:after, .k-animation-container.cp-light-tooltip-no-padding .k-tooltip .k-callout:after {
  background-color: #ffffff;
  border: var(--border-style);
  box-shadow: var(--shadow-sm);
  border-width: 0px;
}
.k-animation-container.cp-dark-tooltip .k-tooltip, .k-animation-container.cp-dark-tooltip-no-padding .k-tooltip {
  color: #ffffff;
  border: var(--border-style);
  border-width: 0px;
  background-color: var(--secondary-font-color);
}
.k-animation-container.cp-dark-tooltip .k-tooltip .k-callout, .k-animation-container.cp-dark-tooltip-no-padding .k-tooltip .k-callout {
  border: none;
}
.k-animation-container.cp-dark-tooltip .k-tooltip .k-callout:after, .k-animation-container.cp-dark-tooltip-no-padding .k-tooltip .k-callout:after {
  background-color: var(--secondary-font-color);
  border: var(--border-style);
  box-shadow: var(--shadow-sm);
  border-width: 0px;
}
.k-animation-container.cp-alert-tooltip .k-tooltip, .k-animation-container.cp-alert-tooltip-no-padding .k-tooltip {
  color: #ffffff;
  border-width: 0px;
  background-color: var(--alert-danger);
}
.k-animation-container.cp-alert-tooltip .k-tooltip .k-callout, .k-animation-container.cp-alert-tooltip-no-padding .k-tooltip .k-callout {
  border: none;
}
.k-animation-container.cp-alert-tooltip .k-tooltip .k-callout:after, .k-animation-container.cp-alert-tooltip-no-padding .k-tooltip .k-callout:after {
  background-color: var(--alert-danger);
  border: var(--alert-danger);
  box-shadow: var(--shadow-sm);
  border-width: 0px;
}

.cp-light-tooltip-no-padding .k-tooltip {
  padding: 0px;
}

.cp-dark-tooltip-no-padding .k-tooltip {
  padding: 0px;
}

.k-popup.cp-light-popup {
  border-color: #ffffff;
  background: #ffffff;
}
.k-popup.cp-light-popup.alert {
  border-color: var(--alert-danger);
  color: var(--alert-danger);
}
.k-popup.cp-dark-popup {
  border-color: var(--primary-400);
  background: var(--primary-400);
  color: var(--surface-0);
}
.k-popup.padding15 {
  padding: 15px;
}
.k-popup.width300 {
  width: 300px;
}
.k-popup.small {
  border-radius: 0.25rem;
  font-size: 0.625rem;
  padding: 0.25rem;
}
.k-popup.copyFieldPopUp {
  margin-top: 4px;
}

.k-item i {
  margin-right: 10px;
}

.cp-input-container {
  width: 100%;
}
.cp-input-container.withButton {
  width: 100%;
}
.cp-input-container.withButton .k-textbox, .cp-input-container.withButton .k-dropdown, .cp-input-container.withButton .k-combobox, .cp-input-container.withButton .k-numerictextbox, .cp-input-container.withButton .k-picker {
  width: calc(100% - 34px);
  height: 30px;
}
.cp-input-container.withButton .k-button {
  width: 34px;
  height: 30px;
}
.cp-input-container.dqoiItemSelection {
  flex-flow: row wrap;
}
.cp-input-container.dqoiItemSelection .cp-label {
  width: 100%;
}
.cp-input-container.dqoiItemSelection.twoButtons .k-textbox, .cp-input-container.dqoiItemSelection.twoButtons .k-dropdown {
  width: calc(100% - 69px);
  margin-right: -1px;
}
.cp-input-container.dqoiItemSelection .k-textbox, .cp-input-container.dqoiItemSelection .k-dropdown, .cp-input-container.dqoiItemSelection .k-combobox {
  width: calc(100% - 35px);
  margin-right: -1px;
}
.cp-input-container.dqoiItemSelection .k-button {
  width: 34px;
  height: 30px;
}
.cp-input-container.dqoiItemSelection.multiItem .cp-list-button-dropdown {
  transform: scale(1);
  background: var(--primary-color);
  box-shadow: 0 0 0 0 var(--primary-color);
  animation: pulse-blue 2s 10;
}
.cp-input-container.excededValue input {
  color: var(--alert-danger) !important;
}

.k-input.ng-invalid:not(form), .k-input:required, .k-picker-wrap.ng-invalid:not(form), .k-picker-wrap:required, .k-numeric-wrap.ng-invalid:not(form), .k-numeric-wrap:required, .k-dropdown-wrap.ng-invalid:not(form), .k-dropdown-wrap:required, .k-textbox.ng-invalid:not(form), .k-textbox:required, .k-textarea.ng-invalid:not(form), .k-textarea:required, .k-popup.ng-invalid:not(form), .k-popup:required, .k-combobox.ng-invalid:not(form), .k-combobox:required, .k-datepicker.ng-invalid:not(form), .k-datepicker:required, .k-multiselect.ng-invalid:not(form), .k-multiselect:required, .k-numerictextbox.ng-invalid:not(form), .k-numerictextbox:required, .k-picker.ng-invalid:not(form), .k-picker:required, .k-dropdownlist.ng-invalid:not(form), .k-dropdownlist:required {
  border-color: var(--alert-danger) !important;
}
.k-input.ng-invalid:not(form) .k-dropdown-wrap, .k-input:required .k-dropdown-wrap, .k-picker-wrap.ng-invalid:not(form) .k-dropdown-wrap, .k-picker-wrap:required .k-dropdown-wrap, .k-numeric-wrap.ng-invalid:not(form) .k-dropdown-wrap, .k-numeric-wrap:required .k-dropdown-wrap, .k-dropdown-wrap.ng-invalid:not(form) .k-dropdown-wrap, .k-dropdown-wrap:required .k-dropdown-wrap, .k-textbox.ng-invalid:not(form) .k-dropdown-wrap, .k-textbox:required .k-dropdown-wrap, .k-textarea.ng-invalid:not(form) .k-dropdown-wrap, .k-textarea:required .k-dropdown-wrap, .k-popup.ng-invalid:not(form) .k-dropdown-wrap, .k-popup:required .k-dropdown-wrap, .k-combobox.ng-invalid:not(form) .k-dropdown-wrap, .k-combobox:required .k-dropdown-wrap, .k-datepicker.ng-invalid:not(form) .k-dropdown-wrap, .k-datepicker:required .k-dropdown-wrap, .k-multiselect.ng-invalid:not(form) .k-dropdown-wrap, .k-multiselect:required .k-dropdown-wrap, .k-numerictextbox.ng-invalid:not(form) .k-dropdown-wrap, .k-numerictextbox:required .k-dropdown-wrap, .k-picker.ng-invalid:not(form) .k-dropdown-wrap, .k-picker:required .k-dropdown-wrap, .k-dropdownlist.ng-invalid:not(form) .k-dropdown-wrap, .k-dropdownlist:required .k-dropdown-wrap {
  border-color: var(--alert-danger) !important;
}
.k-input.ng-valid:not(form), .k-picker-wrap.ng-valid:not(form), .k-numeric-wrap.ng-valid:not(form), .k-dropdown-wrap.ng-valid:not(form), .k-textbox.ng-valid:not(form), .k-textarea.ng-valid:not(form), .k-popup.ng-valid:not(form), .k-combobox.ng-valid:not(form), .k-datepicker.ng-valid:not(form), .k-multiselect.ng-valid:not(form), .k-numerictextbox.ng-valid:not(form), .k-picker.ng-valid:not(form), .k-dropdownlist.ng-valid:not(form) {
  border-color: var(--border-color) !important;
}
.k-input.ng-valid:not(form).k-datetimepicker.required, .k-picker-wrap.ng-valid:not(form).k-datetimepicker.required, .k-numeric-wrap.ng-valid:not(form).k-datetimepicker.required, .k-dropdown-wrap.ng-valid:not(form).k-datetimepicker.required, .k-textbox.ng-valid:not(form).k-datetimepicker.required, .k-textarea.ng-valid:not(form).k-datetimepicker.required, .k-popup.ng-valid:not(form).k-datetimepicker.required, .k-combobox.ng-valid:not(form).k-datetimepicker.required, .k-datepicker.ng-valid:not(form).k-datetimepicker.required, .k-multiselect.ng-valid:not(form).k-datetimepicker.required, .k-numerictextbox.ng-valid:not(form).k-datetimepicker.required, .k-picker.ng-valid:not(form).k-datetimepicker.required, .k-dropdownlist.ng-valid:not(form).k-datetimepicker.required {
  border-color: var(--alert-danger) !important;
}
.k-input.k-readonly, .k-picker-wrap.k-readonly, .k-numeric-wrap.k-readonly, .k-dropdown-wrap.k-readonly, .k-textbox.k-readonly, .k-textarea.k-readonly, .k-popup.k-readonly, .k-combobox.k-readonly, .k-datepicker.k-readonly, .k-multiselect.k-readonly, .k-numerictextbox.k-readonly, .k-picker.k-readonly, .k-dropdownlist.k-readonly {
  color: var(--surface-400);
}
.k-input.k-readonly .k-input-inner, .k-picker-wrap.k-readonly .k-input-inner, .k-numeric-wrap.k-readonly .k-input-inner, .k-dropdown-wrap.k-readonly .k-input-inner, .k-textbox.k-readonly .k-input-inner, .k-textarea.k-readonly .k-input-inner, .k-popup.k-readonly .k-input-inner, .k-combobox.k-readonly .k-input-inner, .k-datepicker.k-readonly .k-input-inner, .k-multiselect.k-readonly .k-input-inner, .k-numerictextbox.k-readonly .k-input-inner, .k-picker.k-readonly .k-input-inner, .k-dropdownlist.k-readonly .k-input-inner {
  background: rgba(var(--surface-50-rgb), 0.4) !important;
}

.requiredInput .cp-label, .requiredInput .p-search-window-launcher .cp-label {
  color: var(--alert-danger) !important;
}
.requiredInput.validInput .cp-label, .requiredInput .p-search-window-launcher.validInput .cp-label {
  color: var(--secondary-font-color) !important;
}

.in-finance .k-input, .in-finance .k-dropdownlist, .in-finance .k-picker, .in-finance .k-combobox, .in-finance .k-checkbox {
  border-color: var(--alert-success);
  box-shadow: 0px 0px 0 1px rgba(2, 165, 112, 0.2);
}

.cp-label {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--secondary-font-color);
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: -0.3em;
  position: relative;
}
.cp-label .characterCount {
  font-size: 0.75rem;
  color: var(--alert-danger);
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  top: 0;
  height: 100%;
  right: 1rem;
  padding: 0;
  outline: none;
  border: none;
  background: transparent;
}
.cp-label .additionalLabelInfo {
  font-size: 0.75rem;
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  top: 0;
  height: 100%;
  right: 0;
  padding: 0;
  outline: none;
  border: none;
  background: transparent;
}
.cp-label .additionalLabelInfo i {
  margin-left: 0.5rem;
}

.k-input, .k-dropdownlist, .k-picker, .k-combobox {
  border: 1px solid var(--surface-100);
  color: var(--primary-font-color);
}
.k-input .k-input-button, .k-dropdownlist .k-input-button, .k-picker .k-input-button, .k-combobox .k-input-button, .k-input .k-input-spinner, .k-dropdownlist .k-input-spinner, .k-picker .k-input-spinner, .k-combobox .k-input-spinner {
  border-width: 0 !important;
  border: none !important;
  background: var(--white);
}
.k-input .k-input-inner, .k-dropdownlist .k-input-inner, .k-picker .k-input-inner, .k-combobox .k-input-inner {
  background: var(--white);
}
.k-input:focus-within, .k-dropdownlist:focus-within, .k-picker:focus-within, .k-combobox:focus-within, .k-input:focus, .k-dropdownlist:focus, .k-picker:focus, .k-combobox:focus, .k-input .k-focus, .k-dropdownlist .k-focus, .k-picker .k-focus, .k-combobox .k-focus {
  border-color: var(--surface-200);
  box-shadow: none;
  color: var(--primary-font-color);
}
.k-input:hover, .k-dropdownlist:hover, .k-picker:hover, .k-combobox:hover {
  border-color: var(--surface-200);
  box-shadow: none;
  color: var(--primary-font-color);
}
.k-input .k-input-values, .k-dropdownlist .k-input-values, .k-picker .k-input-values, .k-combobox .k-input-values {
  flex-flow: row nowrap;
}

.read-only.k-input, .read-only.k-dropdownlist, .read-only.k-picker, .read-only.k-combobox {
  color: var(--surface-400);
  background: rgba(var(--surface-50-rgb), 0.4) !important;
  cursor: default;
}
.read-only.k-input:focus, .read-only.k-dropdownlist:focus, .read-only.k-picker:focus, .read-only.k-combobox:focus, .read-only.k-input:focus-within, .read-only.k-dropdownlist:focus-within, .read-only.k-picker:focus-within, .read-only.k-combobox:focus-within, .read-only.k-state-focus.k-input, .read-only.k-state-focus.k-dropdownlist, .read-only.k-state-focus.k-picker, .read-only.k-state-focus.k-combobox, .read-only.k-state-focused.k-input, .read-only.k-state-focused.k-dropdownlist, .read-only.k-state-focused.k-picker, .read-only.k-state-focused.k-combobox {
  color: var(--surface-400);
  background: rgba(var(--surface-50-rgb), 0.4);
  cursor: default;
}
.read-only.k-input:hover, .read-only.k-dropdownlist:hover, .read-only.k-picker:hover, .read-only.k-combobox:hover {
  border: 1px solid var(--surface-100);
}
.read-only.k-input .k-searchbar .k-input-inner, .read-only.k-dropdownlist .k-searchbar .k-input-inner, .read-only.k-picker .k-searchbar .k-input-inner, .read-only.k-combobox .k-searchbar .k-input-inner {
  color: var(--surface-400);
  background: rgba(var(--surface-50-rgb), 0.4) !important;
}
.read-only.k-input .k-button.k-button-outline, .read-only.k-dropdownlist .k-button.k-button-outline, .read-only.k-picker .k-button.k-button-outline, .read-only.k-combobox .k-button.k-button-outline, .read-only.k-input .k-button:hover, .read-only.k-dropdownlist .k-button:hover, .read-only.k-picker .k-button:hover, .read-only.k-combobox .k-button:hover {
  background: rgba(var(--surface-50-rgb), 0.4) !important;
}

input.k-input, textarea.k-textarea, .k-input-md .k-input-inner, .k-picker-md .k-input-inner {
  padding-inline: 0.4em;
}

.k-input.k-input-outline:hover, .k-input.k-picker-outline:hover, .k-dropdownlist.k-input-outline:hover, .k-dropdownlist.k-picker-outline:hover, .k-picker.k-input-outline:hover, .k-picker.k-picker-outline:hover, .k-combobox.k-input-outline:hover, .k-combobox.k-picker-outline:hover {
  background: transparent;
}
.k-input.cp-list-button-dropdown, .k-dropdownlist.cp-list-button-dropdown, .k-picker.cp-list-button-dropdown, .k-combobox.cp-list-button-dropdown {
  width: 36px !important;
  height: 30px;
}
.k-input.cp-list-button-dropdown .k-input-inner, .k-dropdownlist.cp-list-button-dropdown .k-input-inner, .k-picker.cp-list-button-dropdown .k-input-inner, .k-combobox.cp-list-button-dropdown .k-input-inner {
  display: none;
}
.k-input.cp-list-button-dropdown .k-input-button, .k-dropdownlist.cp-list-button-dropdown .k-input-button, .k-picker.cp-list-button-dropdown .k-input-button, .k-combobox.cp-list-button-dropdown .k-input-button {
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  border-radius: var(--border-sm-radius);
  border-color: var(--border-color);
}
.k-input.cp-list-button-dropdown .k-input-button:hover, .k-dropdownlist.cp-list-button-dropdown .k-input-button:hover, .k-picker.cp-list-button-dropdown .k-input-button:hover, .k-combobox.cp-list-button-dropdown .k-input-button:hover {
  background-color: var(--table-border-color);
}
.k-input.cp-list-button-dropdown .k-input-button .k-icon, .k-dropdownlist.cp-list-button-dropdown .k-input-button .k-icon, .k-picker.cp-list-button-dropdown .k-input-button .k-icon, .k-combobox.cp-list-button-dropdown .k-input-button .k-icon {
  width: auto;
  height: auto;
  line-height: auto;
}
.k-input.cp-list-button-dropdown .k-input-button .k-icon:before, .k-dropdownlist.cp-list-button-dropdown .k-input-button .k-icon:before, .k-picker.cp-list-button-dropdown .k-input-button .k-icon:before, .k-combobox.cp-list-button-dropdown .k-input-button .k-icon:before {
  content: "\\f03a";
  font-family: FontAwesome;
  font-size: 1.75em;
}

.k-picker {
  height: 30px;
}

.k-popup {
  border-color: var(--surface-100);
  color: var(--primary-font-color);
  background-color: var(--white);
  box-shadow: 0 2px 4px 0 rgba(var(--surface-700-rgb), 0.03), 0 4px 5px 0 rgba(var(--surface-700-rgb), 0.04);
  margin: 0;
  padding: 0;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  font-size: 1em;
  line-height: 1.4285714286;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.k-popup .k-menu-group .k-item > .k-link:active {
  background-color: var(--primary-color);
}
.k-popup .k-list-item {
  color: var(--primary-font-color);
}
.k-popup .k-list-item:hover {
  background: var(--primary-0);
}
.k-popup .k-list-item:hover.k-selected {
  background: var(--surface-100);
  color: var(--surface-900);
}
.k-popup .k-list-item.k-selected {
  background: var(--surface-50);
}
.k-popup .k-list-item.k-focused {
  background: var(--surface-50);
  box-shadow: none;
}
.tableLegend .k-popup {
  padding: 15px;
  background-color: var(--white);
  border: var(--border-style);
  border-radius: var(--border-sm-radius);
  display: flex;
  flex-flow: row wrap;
  margin: 10px 30px;
  z-index: 100;
  box-shadow: var(--shadow-md);
}
.filters-popup .k-popup {
  border-radius: var(--border-m-radius);
  box-shadow: var(--shadow-md);
  border-bottom: var(--border-style);
  background-color: #ffffff;
  padding: 16px;
  width: 320px;
}
.two-columns.filters-popup .k-popup {
  width: 480px;
}

.k-timeselector {
  border-color: none;
  color: var(--primary-font-color);
}
.k-timeselector .k-time-header .k-time-now:hover, .k-timeselector .k-time-selector-header .k-time-now:hover {
  background: var(--surface-50);
  color: var(--primary-font-color);
}
.k-timeselector .k-time-highlight {
  background: var(--white);
}
.k-timeselector .k-time-list-wrapper.k-focus {
  background: var(--surface-0);
}
.k-timeselector .k-time-list-wrapper .k-title {
  color: var(--primary-font-color);
}
.k-timeselector .k-time-list-wrapper .k-time-list .k-item {
  cursor: pointer;
}
.k-timeselector .k-time-list-wrapper .k-time-list .k-item:hover {
  color: var(--primary-600);
}

.k-calendar .k-content .k-state-selected.k-today .k-link, .k-calendar .k-state-selected .k-link {
  border-color: var(--primary-color);
  color: var(--white);
  background-color: var(--primary-color);
}

.dqoi-search-input .k-animation-container .k-popup #mainGrid:has(.k-loading-mask) .k-grid-norecords, .dqoi-search-input .k-animation-container .k-popup #mainGrid:has(.k-loading-mask) .k-grid-container, .dqoi-search-input .k-animation-container .cpdiSearch #mainGrid:has(.k-loading-mask) .k-grid-norecords, .dqoi-search-input .k-animation-container .cpdiSearch #mainGrid:has(.k-loading-mask) .k-grid-container {
  min-height: 40px;
}
.dqoi-search-input .k-animation-container .k-popup #mainGrid .noRecords, .dqoi-search-input .k-animation-container .cpdiSearch #mainGrid .noRecords {
  min-height: 100px;
  display: flex;
  font-size: 1rem;
  justify-content: center;
  align-items: center;
}
.dqoi-search-input .k-animation-container .k-popup .k-list, .dqoi-search-input .k-animation-container .cpdiSearch .k-list {
  display: none;
}
.dqoi-search-input .k-animation-container .k-popup .k-no-data, .dqoi-search-input .k-animation-container .cpdiSearch .k-no-data {
  display: none;
}

.k-editor .k-button, .k-button {
  font-weight: 400;
  color: var(--primary-font-color);
  transition: background 0.1s ease-in-out;
  box-shadow: none;
}

.k-button.k-button-outline.k-loading, .k-button.k-button-flat.k-loading, .k-button.k-button-solid.k-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: default;
}
.k-button.k-button-outline.k-loading:before, .k-button.k-button-flat.k-loading:before, .k-button.k-button-solid.k-loading:before {
  content: "";
  display: block;
  box-sizing: border-box;
  position: relative;
  background-color: transparent;
  width: 1.125em;
  height: 1.125em;
  margin-right: 0.4em;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  border: 2px solid var(--surface-0);
  border-radius: 50%;
  border-right-color: transparent;
  border-top-color: transparent;
  animation: spin-animation 400ms infinite linear;
}

.cp-input-container .k-button:is(:only-child) {
  width: 100%;
}

.k-button.k-button-solid {
  color: var(--surface-0);
  background: var(--primary-color);
  border-color: var(--primary-color);
}
.k-button.k-button-solid .k-icon {
  color: var(--surface-0);
}
.k-button.k-button-solid:hover, .k-button.k-button-solid.k-hover, .k-button.k-button-solid:focus, .k-button.k-button-solid.k-focus {
  background: var(--primary-600);
}
.k-button.k-button-solid:active, .k-button.k-button-solid.k-active {
  background: var(--primary-300);
}
.k-button.k-button-solid:focus {
  box-shadow: 0 0 0 2px rgba(var(--primary-300), 0.5);
}
.k-button.k-button-solid.k-disabled {
  color: var(--disabled-font-color);
  background: var(--surface-50);
  font-style: italic;
  cursor: default;
  border-color: var(--surface-50);
}
.k-button.k-button-solid.k-disabled:hover {
  background: var(--surface-100) !important;
}
.k-button.k-button-solid.k-loading:hover {
  background: var(--primary-color) !important;
}
.k-button.k-button-flat {
  color: var(--primary-font-color);
  background: none;
}
.k-button.k-button-flat .k-icon {
  color: var(--primary-font-color);
}
.k-button.k-button-flat:hover, .k-button.k-button-flat.k-hover, .k-button.k-button-flat:focus, .k-button.k-button-flat.k-focus {
  background: var(--surface-50);
}
.k-button.k-button-flat:active, .k-button.k-button-flat.k-active {
  color: var(--secondary-font-color);
  background: var(--surface-50);
}
.k-button.k-button-flat.k-disabled {
  color: var(--disabled-font-color);
  font-style: italic;
  cursor: default;
}
.k-button.k-button-flat.k-disabled:hover {
  background: none !important;
}
.k-button.k-button-flat.k-loading:before {
  border-left-color: var(--surface-500);
  border-bottom-color: var(--surface-500);
}
.k-button.k-button-flat-inverse {
  color: var(--surface-0);
}
.k-button.k-button-outline {
  color: var(--primary-font-color);
  background: var(--white);
  border: 1px solid var(--surface-100);
}
.k-button.k-button-outline .k-icon {
  color: var(--primary-font-color);
}
.k-button.k-button-outline:hover, .k-button.k-button-outline.k-hover, .k-button.k-button-outline:focus, .k-button.k-button-outline.k-focus {
  background: var(--surface-50);
}
.k-button.k-button-outline:active, .k-button.k-button-outline.k-active {
  color: var(--primary-font-color);
  background: var(--surface-50);
  border-color: var(--surface-100);
}
.k-button.k-button-outline:focus {
  box-shadow: 0 0 0 2px rgba(var(--primary-0-rgb), 0.5);
}
.k-button.k-button-outline.k-selected {
  background: var(--primary-color);
  color: var(--white);
}
.k-button.k-button-outline.k-disabled {
  background: none;
  color: var(--disabled-font-color);
  font-style: italic;
  cursor: default;
}
.k-button.k-button-outline.k-disabled:hover {
  background: none !important;
}
.k-button.k-button-outline.k-loading:before {
  border-left-color: var(--surface-500);
  border-bottom-color: var(--surface-500);
}
.k-button.k-button-outline-light {
  color: var(--surface-0);
  background: transparent;
  border: var(--border-style);
}
.k-button.k-button-outline-light:hover, .k-button.k-button-outline-light.k-hover, .k-button.k-button-outline-light:focus, .k-button.k-button-outline-light.k-focus {
  background: var(--border-color);
  color: var(--primary-font-color);
}
.k-button.k-button-outline.buttonError {
  border: 1px solid var(--alert-danger);
  position: relative;
}
.k-button.k-button-outline.buttonError .k-icon {
  color: var(--alert-danger);
}
.k-button.k-button-outline.buttonError::after {
  content: "";
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 100%;
  position: absolute;
  z-index: 100;
  left: unset;
  opacity: 100;
  background: var(--alert-danger);
  top: -0.375rem;
  right: -0.375rem;
}
.k-spin-button .k-button, .k-picker-outline .k-button {
  background: var(--white);
  border-color: var(--surface-100);
}
.k-spin-button .k-button:hover, .k-spin-button .k-button.k-hover, .k-spin-button .k-button:focus, .k-spin-button .k-button.k-focus, .k-picker-outline .k-button:hover, .k-picker-outline .k-button.k-hover, .k-picker-outline .k-button:focus, .k-picker-outline .k-button.k-focus {
  background: var(--surface-50);
}
.k-spin-button .k-button:active, .k-spin-button .k-button.k-active, .k-picker-outline .k-button:active, .k-picker-outline .k-button.k-active {
  color: var(--surface-0);
  background: var(--surface-50);
  border-color: var(--surface-100);
}
.k-spin-button .k-button.k-disabled, .k-picker-outline .k-button.k-disabled {
  background: none;
  color: var(--disabled-font-color);
  font-style: italic;
  cursor: default;
}
.k-spin-button .k-button.k-disabled:hover, .k-picker-outline .k-button.k-disabled:hover {
  background: none !important;
}
.k-spin-button .k-button .k-icon, .k-picker-outline .k-button .k-icon {
  color: var(--primary-font-color);
}
.k-button .k-button-text {
  /*&:first-child{margin-left:0.4em;}
  &:only-child{margin:0;}*/
}
.k-button .k-button-text:not(:only-child) {
  margin-left: 0.4em;
}
.k-button .k-button-text:not(:only-child):empty {
  margin-left: 0em;
}
.k-button.k-button-sm {
  font-size: 1em;
}
.k-button.k-button-md {
  font-size: 0.75rem;
  line-height: 1.667;
}
.k-button.k-button-lg {
  font-size: 0.875rem;
}

.cp-input-container .k-button-group {
  width: 100%;
}
.cp-input-container .k-button-group .k-button {
  flex-grow: 1;
}

@keyframes spin-animation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.k-grid {
  color: var(--primary-font-color);
  font-size: 0.75rem;
  border-color: var(--surface-50);
}
.k-grid a {
  color: var(--primary-color);
}
.k-grid a:focus {
  outline: 1px solid var(--surface-50);
}
.k-grid a:focus .k-icon {
  margin-top: -1px;
}
.k-grid .k-grid-header, .k-grid .k-grouping-header, .k-grid .k-grid-add-row, .k-grid .k-grid-footer, .k-grid .k-table-thead, .k-grid .k-grid-toolbar {
  color: var(--primary-font-color);
  font-size: 0.75rem;
  background-color: var(--surface-0);
  border-color: var(--surface-50);
}
.k-grid .k-grid-header th, .k-grid .k-grid-header .k-table-th, .k-grid .k-grouping-header th, .k-grid .k-grouping-header .k-table-th, .k-grid .k-grid-add-row th, .k-grid .k-grid-add-row .k-table-th, .k-grid .k-grid-footer th, .k-grid .k-grid-footer .k-table-th, .k-grid .k-table-thead th, .k-grid .k-table-thead .k-table-th, .k-grid .k-grid-toolbar th, .k-grid .k-grid-toolbar .k-table-th {
  color: var(--primary-color);
  font-size: 0.75rem;
  border-color: var(--surface-50);
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 28px;
}
.k-grid .k-grid-header th .k-link, .k-grid .k-grid-header .k-table-th .k-link, .k-grid .k-grouping-header th .k-link, .k-grid .k-grouping-header .k-table-th .k-link, .k-grid .k-grid-add-row th .k-link, .k-grid .k-grid-add-row .k-table-th .k-link, .k-grid .k-grid-footer th .k-link, .k-grid .k-grid-footer .k-table-th .k-link, .k-grid .k-table-thead th .k-link, .k-grid .k-table-thead .k-table-th .k-link, .k-grid .k-grid-toolbar th .k-link, .k-grid .k-grid-toolbar .k-table-th .k-link {
  padding-block: 4px;
  padding-inline: 5px;
}
.k-grid .k-grid-header th .k-grid-header-menu, .k-grid .k-grid-header .k-table-th .k-grid-header-menu, .k-grid .k-grouping-header th .k-grid-header-menu, .k-grid .k-grouping-header .k-table-th .k-grid-header-menu, .k-grid .k-grid-add-row th .k-grid-header-menu, .k-grid .k-grid-add-row .k-table-th .k-grid-header-menu, .k-grid .k-grid-footer th .k-grid-header-menu, .k-grid .k-grid-footer .k-table-th .k-grid-header-menu, .k-grid .k-table-thead th .k-grid-header-menu, .k-grid .k-table-thead .k-table-th .k-grid-header-menu, .k-grid .k-grid-toolbar th .k-grid-header-menu, .k-grid .k-grid-toolbar .k-table-th .k-grid-header-menu {
  opacity: 0;
}
.k-grid .k-grid-header th:hover .k-grid-header-menu, .k-grid .k-grid-header .k-table-th:hover .k-grid-header-menu, .k-grid .k-grouping-header th:hover .k-grid-header-menu, .k-grid .k-grouping-header .k-table-th:hover .k-grid-header-menu, .k-grid .k-grid-add-row th:hover .k-grid-header-menu, .k-grid .k-grid-add-row .k-table-th:hover .k-grid-header-menu, .k-grid .k-grid-footer th:hover .k-grid-header-menu, .k-grid .k-grid-footer .k-table-th:hover .k-grid-header-menu, .k-grid .k-table-thead th:hover .k-grid-header-menu, .k-grid .k-table-thead .k-table-th:hover .k-grid-header-menu, .k-grid .k-grid-toolbar th:hover .k-grid-header-menu, .k-grid .k-grid-toolbar .k-table-th:hover .k-grid-header-menu {
  opacity: 1;
  max-width: 40px;
}
.k-grid .k-grid-header th .k-sort-icon, .k-grid .k-grid-header .k-table-th .k-sort-icon, .k-grid .k-grouping-header th .k-sort-icon, .k-grid .k-grouping-header .k-table-th .k-sort-icon, .k-grid .k-grid-add-row th .k-sort-icon, .k-grid .k-grid-add-row .k-table-th .k-sort-icon, .k-grid .k-grid-footer th .k-sort-icon, .k-grid .k-grid-footer .k-table-th .k-sort-icon, .k-grid .k-table-thead th .k-sort-icon, .k-grid .k-table-thead .k-table-th .k-sort-icon, .k-grid .k-grid-toolbar th .k-sort-icon, .k-grid .k-grid-toolbar .k-table-th .k-sort-icon {
  color: var(--primary-color);
}
.k-grid .k-grid-header tr .grid-footer-title, .k-grid .k-grouping-header tr .grid-footer-title, .k-grid .k-grid-add-row tr .grid-footer-title, .k-grid .k-grid-footer tr .grid-footer-title, .k-grid .k-table-thead tr .grid-footer-title, .k-grid .k-grid-toolbar tr .grid-footer-title {
  font-size: 10px;
  font-weight: 600;
  color: var(--primary-font-color);
}
.k-grid .k-grid-header tr .grid-footer-total, .k-grid .k-grouping-header tr .grid-footer-total, .k-grid .k-grid-add-row tr .grid-footer-total, .k-grid .k-grid-footer tr .grid-footer-total, .k-grid .k-table-thead tr .grid-footer-total, .k-grid .k-grid-toolbar tr .grid-footer-total {
  font-size: 12px;
  font-weight: 900;
  color: var(--secondary-font-color);
  margin-bottom: 2px;
}
.k-grid .k-grid-header .k-cell-inner > .k-link > .k-grid-column-menu, .k-grid .k-grouping-header .k-cell-inner > .k-link > .k-grid-column-menu, .k-grid .k-grid-add-row .k-cell-inner > .k-link > .k-grid-column-menu, .k-grid .k-grid-footer .k-cell-inner > .k-link > .k-grid-column-menu, .k-grid .k-table-thead .k-cell-inner > .k-link > .k-grid-column-menu, .k-grid .k-grid-toolbar .k-cell-inner > .k-link > .k-grid-column-menu {
  margin: 0;
}
.k-grid .k-grid-header .k-cell-inner > .k-link > .k-grid-column-menu .k-icon, .k-grid .k-grouping-header .k-cell-inner > .k-link > .k-grid-column-menu .k-icon, .k-grid .k-grid-add-row .k-cell-inner > .k-link > .k-grid-column-menu .k-icon, .k-grid .k-grid-footer .k-cell-inner > .k-link > .k-grid-column-menu .k-icon, .k-grid .k-table-thead .k-cell-inner > .k-link > .k-grid-column-menu .k-icon, .k-grid .k-grid-toolbar .k-cell-inner > .k-link > .k-grid-column-menu .k-icon {
  margin-left: 0.5rem;
  background-color: var(--primary-color);
}
.k-grid .k-grid-header .k-filterable .k-grid-filter-menu, .k-grid .k-grouping-header .k-filterable .k-grid-filter-menu, .k-grid .k-grid-add-row .k-filterable .k-grid-filter-menu, .k-grid .k-grid-footer .k-filterable .k-grid-filter-menu, .k-grid .k-table-thead .k-filterable .k-grid-filter-menu, .k-grid .k-grid-toolbar .k-filterable .k-grid-filter-menu {
  opacity: 0;
  color: var(--primary-font-color);
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
}
.k-grid .k-grid-header .k-filterable .k-grid-filter-menu:hover, .k-grid .k-grouping-header .k-filterable .k-grid-filter-menu:hover, .k-grid .k-grid-add-row .k-filterable .k-grid-filter-menu:hover, .k-grid .k-grid-footer .k-filterable .k-grid-filter-menu:hover, .k-grid .k-table-thead .k-filterable .k-grid-filter-menu:hover, .k-grid .k-grid-toolbar .k-filterable .k-grid-filter-menu:hover {
  background-color: var(--surface-100);
  color: var(--primary-font-color);
}
.k-grid .k-grid-header .k-filterable .k-grid-filter-menu:focus, .k-grid .k-grouping-header .k-filterable .k-grid-filter-menu:focus, .k-grid .k-grid-add-row .k-filterable .k-grid-filter-menu:focus, .k-grid .k-grid-footer .k-filterable .k-grid-filter-menu:focus, .k-grid .k-table-thead .k-filterable .k-grid-filter-menu:focus, .k-grid .k-grid-toolbar .k-filterable .k-grid-filter-menu:focus {
  box-shadow: none;
}
.k-grid .k-grid-header .k-filterable .k-grid-filter-menu.k-active, .k-grid .k-grouping-header .k-filterable .k-grid-filter-menu.k-active, .k-grid .k-grid-add-row .k-filterable .k-grid-filter-menu.k-active, .k-grid .k-grid-footer .k-filterable .k-grid-filter-menu.k-active, .k-grid .k-table-thead .k-filterable .k-grid-filter-menu.k-active, .k-grid .k-grid-toolbar .k-filterable .k-grid-filter-menu.k-active {
  opacity: 1;
  background-color: var(--primary-color);
  position: relative;
}
.k-grid .k-grid-header .k-filterable .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grouping-header .k-filterable .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grid-add-row .k-filterable .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grid-footer .k-filterable .k-grid-filter-menu.k-active .k-icon, .k-grid .k-table-thead .k-filterable .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grid-toolbar .k-filterable .k-grid-filter-menu.k-active .k-icon {
  color: var(--white);
}
.k-grid .k-grid-header .k-filterable:hover .k-grid-filter-menu, .k-grid .k-grouping-header .k-filterable:hover .k-grid-filter-menu, .k-grid .k-grid-add-row .k-filterable:hover .k-grid-filter-menu, .k-grid .k-grid-footer .k-filterable:hover .k-grid-filter-menu, .k-grid .k-table-thead .k-filterable:hover .k-grid-filter-menu, .k-grid .k-grid-toolbar .k-filterable:hover .k-grid-filter-menu {
  opacity: 1;
}
.k-grid .k-grid-header .k-filterable:hover .k-grid-filter-menu.k-active, .k-grid .k-grouping-header .k-filterable:hover .k-grid-filter-menu.k-active, .k-grid .k-grid-add-row .k-filterable:hover .k-grid-filter-menu.k-active, .k-grid .k-grid-footer .k-filterable:hover .k-grid-filter-menu.k-active, .k-grid .k-table-thead .k-filterable:hover .k-grid-filter-menu.k-active, .k-grid .k-grid-toolbar .k-filterable:hover .k-grid-filter-menu.k-active {
  opacity: 1;
  background-color: var(--primary-color);
  position: relative;
}
.k-grid .k-grid-header .k-filterable:hover .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grouping-header .k-filterable:hover .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grid-add-row .k-filterable:hover .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grid-footer .k-filterable:hover .k-grid-filter-menu.k-active .k-icon, .k-grid .k-table-thead .k-filterable:hover .k-grid-filter-menu.k-active .k-icon, .k-grid .k-grid-toolbar .k-filterable:hover .k-grid-filter-menu.k-active .k-icon {
  color: var(--white);
}
.k-grid .k-table, .k-grid .k-data-table {
  color: var(--primary-font-color);
  font-size: 0.75rem;
}
.k-grid td, .k-grid .k-table-td, .k-grid .k-grid-md .k-grid-edit td {
  border-color: var(--surface-50);
  border-width: 0 0 1px 1px;
  padding-block: 2px;
  padding-inline: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.k-grid td.k-grid-edit-row, .k-grid .k-table-td.k-grid-edit-row, .k-grid .k-grid-md .k-grid-edit td.k-grid-edit-row {
  padding-block: 4px;
  padding-inline: 5px;
}
.k-grid.gridHeaderTextWrap .k-column-title {
  vertical-align: middle;
  white-space: pre-line;
  text-overflow: clip;
}
.k-grid.gridHeaderTextWrap .k-header {
  vertical-align: middle;
}
.k-grid.gridHeaderTextWrap .k-table-th > .k-link {
  white-space: pre-line;
}
.k-grid .k-column-title {
  width: calc(100% - 6px);
}
.k-grid .k-table-row.k-state-selected, .k-grid .k-table-row.k-selected > .k-table-td {
  color: var(--primary-font-color);
  background-color: var(--surface-50) !important;
  box-shadow: inset 0 0 4px 0 var(--light-blue);
}
.k-grid .k-table-row.mgrApprovedCol .approveCol {
  background: var(--alert-success-opacity);
}
.k-grid .k-table-row.isPartiallyApprovedCol .approveCol {
  background-color: var(--alert-warning-opacity);
}
.k-grid .k-table-row.zeroHourHighlight {
  background: var(--alert-danger-opacity);
}
.k-grid .k-table-row.inFinanceCol .approveCol {
  background: var(--alert-success-opacity);
}
.k-grid .k-table-row.isBeingApprovedCol .approveCol {
  background: var(--alert-warning-opacity);
}
.k-grid .k-table-row.k-table-alt-row {
  background: var(--surface-0);
}
.k-grid .k-table-row.readonly {
  background: rgba(var(--surface-200-rgb), 0.4) !important;
  cursor: default;
}
.k-grid .k-table-row.readonly:focus, .k-grid .k-table-row.readonly:focus-within, .k-grid .k-table-row.readonly.k-state-focus, .k-grid .k-table-row.readonly.k-state-focused {
  background: rgba(var(--surface-200-rgb), 0.4);
  cursor: default;
}
.k-grid .k-table-row.readonly:hover {
  border: 1px solid var(--surface-300);
}
.k-grid tr:hover, .k-grid tr.k-state-hover {
  color: var(--primary-font-color);
  background-color: var(--surface-50) !important;
}
.k-grid tr.k-state-selected > td {
  color: var(--primary-font-color);
  background-color: transparent !important;
}
.k-grid tr.k-state-selected, .k-grid tr.k-selected > .k-table-td {
  color: var(--primary-font-color);
  background-color: var(--surface-50) !important;
  box-shadow: inset 0 0 4px 0 var(--light-blue);
}
.k-grid tr.k-alt, .k-grid tr .k-alt:hover {
  background-color: #ffffff;
}
.k-grid tr.drover {
  box-shadow: inset 0px 2px 0px 0px var(--primary-color) !important;
}
.k-grid tr.drover.inFinance {
  box-shadow: inset 0px 2px 0px 0px blue, inset 0px 0px 0px 1px green, inset 0px 0px 0px 1px green, inset 0px 0px 0px 1px green !important;
}
.k-grid .k-hierarchy-cell .k-i-plus {
  font-size: 14px;
}
.k-grid .k-hierarchy-cell .k-i-plus::before {
  content: "\\f067";
}
.k-grid .k-hierarchy-cell .k-iminus {
  font-size: 14px;
}
.k-grid .k-hierarchy-cell .k-iminus::before {
  content: "\\f068";
}
.k-grid .k-hierarchy-cell + td {
  border-left-width: 1px;
}
.k-grid .k-detail-row .k-hierarchy-cell {
  background-color: var(--light-grey);
}
.k-grid .k-detail-row .k-hierarchy-cell + td {
  border-left-width: 0px;
}
.k-grid .k-detail-row .k-hierarchy-cell:hover {
  background-color: #ffffff;
}
.k-grid .k-detail-row:hover {
  background-color: #ffffff !important;
}
.k-grid .k-detail-row .k-state-hover {
  background-color: #ffffff !important;
}
.k-grid .k-detail-row .k-detail-cell {
  padding: 0px;
}
.k-grid .k-detail-row .k-detail-cell:hover {
  background-color: #ffffff;
}
.k-grid .col-checkbox {
  min-width: 40px;
  max-width: 40px;
  width: 40px;
  text-align: center !important;
  align-items: center;
  justify-content: center;
}
.k-grid .col-i-button {
  min-width: 40px;
  max-width: 40px;
  width: 40px;
  text-align: center !important;
  align-items: center;
  justify-content: center;
}
.k-grid .col-i-button .k-button {
  line-height: 0;
}
.k-grid .col-i-double-button {
  min-width: 90px;
  max-width: 90px;
  width: 90px;
  text-align: center !important;
  align-items: center;
  justify-content: center;
}
.k-grid .col-i-double-button .dataWrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.k-grid .col-i-double-button .dataWrap.gridButtons .k-button {
  margin: 0 5px;
}
.k-grid .col-i-double-button .dataWrap.gridButtons .k-button:first-child {
  margin: 0;
}
.k-grid.forceGridWrap .k-table-td {
  white-space: normal !important;
  overflow: auto !important;
  text-overflow: revert !important;
}
.k-grid.forceGridWrap .k-table-td .k-input .k-input-values {
  flex-flow: row wrap !important;
}
.k-grid.forceGridWrap .k-table-td {
  white-space: normal !important;
  overflow: auto !important;
  text-overflow: revert !important;
}

.color-label.green, .k-grid tr.green, .k-item span.green {
  background-color: rgba(var(--alert-success-rgb), 0.3) !important;
}
.color-label.green.k-state-selected > td, .color-label.green:hover, .k-grid tr.green.k-state-selected > td, .k-grid tr.green:hover, .k-item span.green.k-state-selected > td, .k-item span.green:hover {
  background-color: rgba(var(--alert-success-rgb), 0.5) !important;
  color: var(--secondary-font-color);
}
.color-label.yellow, .k-grid tr.yellow, .k-item span.yellow {
  background-color: rgba(var(--alert-warning-rgb), 0.35) !important;
}
.color-label.yellow.k-state-selected > td, .color-label.yellow:hover, .k-grid tr.yellow.k-state-selected > td, .k-grid tr.yellow:hover, .k-item span.yellow.k-state-selected > td, .k-item span.yellow:hover {
  background-color: rgba(var(--alert-warning-rgb), 0.6) !important;
  color: var(--secondary-font-color);
}
.color-label.blue, .k-grid tr.blue, .k-item span.blue {
  background-color: rgba(var(--alert-info-rgb), 0.3) !important;
}
.color-label.blue.k-state-selected > td, .color-label.blue:hover, .k-grid tr.blue.k-state-selected > td, .k-grid tr.blue:hover, .k-item span.blue.k-state-selected > td, .k-item span.blue:hover {
  background-color: rgba(var(--alert-info-rgb), 0.6) !important;
  color: var(--white);
}
.color-label.grey, .k-grid tr.grey, .k-item span.grey {
  background-color: rgba(var(--dark-grey-rgb), 0.35) !important;
}
.color-label.grey.k-state-selected > td, .color-label.grey:hover, .k-grid tr.grey.k-state-selected > td, .k-grid tr.grey:hover, .k-item span.grey.k-state-selected > td, .k-item span.grey:hover {
  background-color: rgba(var(--dark-grey-rgb), 0.5) !important;
  color: var(--secondary-font-color);
}
.color-label.red, .k-grid tr.red, .k-item span.red {
  background-color: rgba(var(--alert-danger-rgb), 0.3) !important;
}
.color-label.red.k-state-selected > td, .color-label.red:hover, .k-grid tr.red.k-state-selected > td, .k-grid tr.red:hover, .k-item span.red.k-state-selected > td, .k-item span.red:hover {
  background-color: rgba(var(--alert-danger-rgb), 0.5) !important;
  color: var(--secondary-font-color);
}

.gridDetailReasonWrap {
  left: 0;
  width: 100%;
  padding: 10px 5px;
}
.gridDetailReasonWrap .gridDetailReason {
  width: 100%;
  padding: 5px 5px 5px 0;
  white-space: pre-line;
  font-size: 11px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
          hyphens: auto;
  background-color: var(--light-grey);
}

.gridToolBarWrap {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.gridToolBarWrap > * {
  margin-right: 10px;
}
.gridToolBarWrap > *:last-child {
  margin-right: 0 !important;
}
.gridToolBarWrap h1 {
  flex-grow: 1;
  font-size: 1rem;
  font-weight: 800;
  margin: 0;
  padding: 0;
  color: var(--primary-font-color);
}
.gridToolBarWrap h1.requiredGrid {
  color: var(--alert-danger);
}
.gridToolBarWrap .gridToolbarSubtitle {
  flex-grow: 1;
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0 0 0 10px;
  padding: 0;
  color: var(--primary-font-color);
}
.gridToolBarWrap .buttons {
  flex-grow: 2;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
}
.gridToolBarWrap .buttons > * {
  margin-right: 10px;
}
.gridToolBarWrap .buttons > *:last-child {
  margin-right: 0 !important;
}
.gridToolBarWrap .buttons .left {
  margin-right: auto !important;
}
.gridToolBarWrap .buttons .k-button:is(:only-child) {
  width: auto !important;
}
.gridToolBarWrap .separator {
  width: 1px;
  height: 30px;
  background-color: #d5dde2;
}
@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet)) {
  .gridToolBarWrap {
    flex-flow: row wrap;
  }
}

.k-grid .k-upload .k-actions {
  display: none;
}
.k-grid .k-upload-files {
  display: none !important;
}
.k-grid .k-dropzone-hint {
  display: none !important;
}
.k-grid .dropZoneElement {
  width: 1px !important;
  height: 1px !important;
  text-align: center !important;
}

.k-grids .k-loading-mask .k-loading-color {
  background-color: var(--surface-50);
  opacity: 0.3;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.newGridStyles .k-grid .k-grid-edit-row .k-table-td {
  position: relative;
  padding-block: 0;
  padding-inline: 0;
}
.newGridStyles .k-grid .k-grid-edit-row .k-table-td .k-input {
  border-radius: 0;
}
.newGridStyles .k-grid .k-grid-edit-row .k-table-td input {
  padding-block: 0;
  padding-inline: 0;
}
.newGridStyles .k-grid .k-grid-edit-row .k-table-td .dateOverlap {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 20px;
  right: 20px;
  top: 1px;
  color: #E02222 !important;
  z-index: 2;
  background: var(--white);
  cursor: pointer;
}

.grid-link {
  font-size: 0.625rem;
  font-style: italic;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}
.grid-link i {
  font-size: 0.5rem;
}

.k-calendar {
  border-color: var(--surface-200);
}
.k-calendar .k-calendar-navigation {
  background: var(--surface-50);
  color: var(--primary-font-color);
  box-shadow: inset -1px 0 var(--surface-200);
}
.k-calendar .k-calendar-navigation li:hover {
  color: var(--primary-color);
}
.k-calendar .k-calendar-navigation .k-calendar-navigation-highlight {
  border-color: var(--surface-200);
  color: var(--primary-color);
}
.k-calendar .k-calendar-infinite .k-calendar-header .k-button {
  color: var(--primary-color);
}
.k-calendar .k-calendar-infinite .k-calendar-weekdays {
  color: var(--primary-font-color);
}
.k-calendar .k-calendar-td {
  color: var(--primary-color);
}
.k-calendar .k-calendar-td:hover, .k-calendar .k-calendar-td.k-hover, .k-calendar .k-calendar-td:focus, .k-calendar .k-calendar-td.k-focus {
  background: var(--surface-50);
}
.k-calendar .k-calendar-td .k-link {
  color: var(--primary-font-color);
}
.k-calendar .k-calendar-td.k-today {
  color: var(--primary-color);
}
.k-calendar .k-calendar-td.k-selected .k-link {
  background: var(--primary-color);
  color: var(--surface-0);
}
.k-calendar .k-calendar-td.k-selected .k-link:hover, .k-calendar .k-calendar-td.k-selected .k-link.k-hover, .k-calendar .k-calendar-td.k-selected .k-link:focus, .k-calendar .k-calendar-td.k-selected .k-link.k-focus {
  background: var(--primary-600);
}
.k-calendar .k-calendar-td.k-range-mid {
  background: var(--primary-0);
}

.tech-panel-calendar .k-calendar .k-calendar-view, .tech-panel-calendar k-calendar-infinite .k-calendar-view {
  padding-inline: 6px;
}

.k-window {
  position: fixed !important;
  top: 5% !important;
  max-width: 90% !important;
  background-color: #ffffff;
  border-radius: var(--border-m-radius);
  max-height: 90vh;
  left: calc(-50vw + 50%) !important;
  right: calc(-50vw + 50%) !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.k-window.k-window-maximized {
  max-width: 100vw !important;
  max-height: 100vh !important;
  box-shadow: none !important;
  top: 0% !important;
}
.k-window.k-window-maximized .k-window-titlebar {
  height: 40px;
}
.k-window.k-window-maximized .k-window-titlebar .k-icon {
  font-size: 14px;
  height: 34px;
  width: 34px;
}
.k-window .k-dialog-titlebar, .k-window .k-window-titlebar {
  background-color: #ffffff;
  padding: 0px;
  border-color: var(--border-color);
  border-width: 0px 0px 1px 0px;
  border-radius: var(--border-m-radius-top);
  color: var(--primary-font-color);
  padding-left: 20px;
  height: 60px;
}
.k-window .k-dialog-titlebar .k-window-title, .k-window .k-dialog-titlebar .k-dialog-title, .k-window .k-window-titlebar .k-window-title, .k-window .k-window-titlebar .k-dialog-title {
  line-height: 2;
}
.k-window .k-dialog-titlebar h1, .k-window .k-window-titlebar h1 {
  width: 100%;
  letter-spacing: -1px;
  font-size: 24px;
  margin: 10px 0;
  font-weight: 300;
}
.k-window .k-dialog-titlebar .k-icon, .k-window .k-window-titlebar .k-icon {
  font-size: 18px;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  color: var(--primary-font-color);
}
.k-window .k-dialog-titlebar i, .k-window .k-window-titlebar i {
  position: relative;
  height: 60px;
  width: 60px;
  font-size: 18px;
  color: var(--primary-font-color);
  text-align: center;
  line-height: 60px;
}
.k-window .k-dialog-titlebar .cp-lightox-search, .k-window .k-window-titlebar .cp-lightox-search {
  position: relative;
  width: calc(100% - 120px);
  height: 59px;
  font-size: 18px;
  border-radius: 0px;
  border-color: #ffffff;
}
.k-window .k-dialog-titlebar .cp-lightox-search.ng-valid, .k-window .k-window-titlebar .cp-lightox-search.ng-valid {
  border-color: #ffffff !important;
}
.k-window .k-dialog-titlebar .cp-lightox-search:focus, .k-window .k-window-titlebar .cp-lightox-search:focus {
  border-color: #ffffff;
}
.k-window .k-dialog-titlebar .windowActionBtn, .k-window .k-window-titlebar .windowActionBtn {
  max-height: 32px !important;
}
.k-window .k-dialog-titlebar .k-button, .k-window .k-window-titlebar .k-button {
  height: 60px;
  width: 60px;
  color: var(--primary-font-color);
  text-align: center;
  line-height: 60px;
  max-height: 60px;
}
.k-window .k-dialog-titlebar .k-button:hover, .k-window .k-dialog-titlebar .k-button:active, .k-window .k-window-titlebar .k-button:hover, .k-window .k-window-titlebar .k-button:active {
  background-color: var(--surface-50) !important;
  background: var(--surface-50) !important;
  color: var(--primary-font-color);
}
.k-window .k-dialog-titlebar .k-button.k-toggle-button.k-selected, .k-window .k-window-titlebar .k-button.k-toggle-button.k-selected {
  color: var(--white) !important;
}
.k-window .k-dialog-titlebar .k-button.k-toggle-button.k-selected:hover, .k-window .k-dialog-titlebar .k-button.k-toggle-button.k-selected:active, .k-window .k-window-titlebar .k-button.k-toggle-button.k-selected:hover, .k-window .k-window-titlebar .k-button.k-toggle-button.k-selected:active {
  background-color: var(--primary-color) -hover;
  background: var(--primary-color) -hover;
}
.k-window .k-window-content {
  padding: 0px !important;
}
.k-window .k-window-content .k-dialog-actions {
  border: none;
  margin-top: 1rem;
}
.k-window .k-window-content .attachmentWrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.k-window .k-window-content .attachmentWrap iframe {
  overflow: hidden;
  height: 100%;
  min-height: 79vh;
  width: 100%;
  flex-grow: 1;
}
.k-window .k-window-content .attachmentWrap img {
  padding: 30px;
  max-width: 100%;
  width: auto;
  margin: 0 auto;
}
.k-window .k-window-content .attachmentWrap .imageControls {
  position: sticky;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;
  bottom: 30px;
}
.k-window .k-window-content .attachmentWrap .imageControls .wrap {
  box-shadow: var(--shadow-sm);
}
.k-window .k-window-content .attachmentWrap .imageControls .wrap button {
  width: 50px;
  height: 50px;
  border: none;
  background-color: var(--white);
  color: var(--primary-font-color);
  border: var(--border-style);
}
.k-window .k-window-content .attachmentWrap .imageControls .wrap button:hover {
  background-color: var(--light-grey);
}
.k-window .k-window-content .attachmentWrap .imageControls .wrap button:first-child {
  border-radius: 4px 0 0 4px;
}
.k-window .k-window-content .attachmentWrap .imageControls .wrap button > * {
  border-right: none;
}
.k-window .k-window-content .attachmentWrap .imageControls .wrap button:last-child {
  border-top-right-radius: 0 4px 4px 0;
  border: var(--border-style);
}
.k-window .cp-window-content {
  padding: 0px;
  width: 100%;
  position: relative;
}
.k-window .cp-content-wrap {
  padding: 0px;
  display: block;
}

.overflow-reset.k-window .k-window-content {
  overflow: unset;
}

.k-dialog-buttongroup {
  padding: 0;
  gap: 0;
  border-color: var(--border-color);
}
.k-dialog-buttongroup .k-button {
  max-height: 45px;
  height: 45px;
  flex-grow: 1;
  margin: -1px;
  border: var(--border-style);
  color: var(--primary-font-color);
  background-color: var(--white);
  background: var(--white);
}
.k-dialog-buttongroup .k-button:hover {
  color: var(--primary-font-color);
  background-color: var(--surface-50);
  background: var(--surface-50);
  border: var(--border-style);
}
.k-dialog-buttongroup .k-button:focus::after {
  border-color: var(--border-color);
  box-shadow: none;
}
.k-dialog-buttongroup .k-button.k-primary:hover {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--white);
}

.k-overlay {
  background-color: var(--secondary-font-color);
  opacity: 0.6;
  pointer-events: none;
}

.assign-tech-window .k-window {
  max-width: 900px !important;
}

.dispatch-add-note-window {
  max-width: 720px !important;
}
.dispatch-add-note-window .cp-content-wrap {
  padding: 30px;
}

.change-status-window {
  max-width: 400px !important;
}

.schedule-dispatches, .schedule-invoices {
  max-width: 90% !important;
}

.save-quote-template {
  max-width: 500px !important;
}

.receiving-window, .bills-window, .vendor-credits-window, .vendor-returns-window {
  max-width: 1080px !important;
}

.invoice-checklist-window {
  max-width: 720px !important;
}

.new-widget-window {
  max-width: 500px !important;
}

.save-dashboard-window {
  max-width: 500px !important;
}

.assignTechDialog {
  z-index: 99999;
}
.assignTechDialog .k-dialog {
  max-width: 400px !important;
}
@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet)), only screen and (min-width: var(--media-min)) and (max-device-width: var(--media-tablet-pro)) {
  .assignTechDialog .k-dialog {
    max-width: 100% !important;
  }
}

.confirmDialog {
  z-index: 199999;
}

.deleteAssignmentWindow .k-window, .changeStatusWindow .k-window {
  max-width: 600px !important;
}
@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet)), only screen and (min-width: var(--media-min)) and (max-device-width: var(--media-tablet-pro)) {
  .deleteAssignmentWindow .k-window, .changeStatusWindow .k-window {
    max-width: 100% !important;
  }
}

@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet)), only screen and (min-width: var(--media-min)) and (max-device-width: var(--media-tablet-pro)) {
  .k-window {
    top: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
    background-color: #ffffff;
    border-radius: 0;
    height: 100%;
    max-height: 100%;
    left: 0 !important;
    right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.cp-primary-tabs .k-tabstrip-items-wrapper {
  border-bottom-width: 0;
}
.cp-primary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items {
  gap: 4px;
}
.cp-primary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item {
  color: var(--surface-0);
  border-width: 1px;
  background: var(--primary-color);
}
.cp-primary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item:hover {
  background: var(--primary-600);
}
.cp-primary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item.k-active {
  border-color: var(--surface-100);
  border-width: 1px;
  border-bottom-color: var(--white);
  color: var(--primary-color);
  background: var(--white);
}
.cp-primary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item.k-active:hover {
  background: var(--white);
  color: var(--primary-font-color);
}
.cp-primary-tabs.hideTabs .k-tabstrip-items-wrapper {
  display: none;
}
.cp-primary-tabs.hideTabs .cp-secondary-tabs .k-tabstrip-items-wrapper {
  display: flex;
}

.cp-secondary-tabs .k-tabstrip-items-wrapper, .cp-small-tabs .k-tabstrip-items-wrapper {
  border-bottom-width: 1px;
  border-color: var(--surface-100);
}
.cp-secondary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items, .cp-small-tabs .k-tabstrip-items-wrapper .k-tabstrip-items {
  gap: 4px;
}
.cp-secondary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item, .cp-small-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item {
  border-radius: var(--border-m-radius-top);
  border-width: 0 0 1px 0;
  color: var(--primary-font-color);
  border-color: var(--surface-100);
  background-color: var(--surface-0);
  border-style: solid;
  margin-bottom: -1px;
}
.cp-secondary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item.k-active, .cp-secondary-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item:hover, .cp-small-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item.k-active, .cp-small-tabs .k-tabstrip-items-wrapper .k-tabstrip-items .k-tabstrip-item:hover {
  border-width: 0 0 2px 0;
  background: var(--white);
  border-color: var(--primary-color);
  border-bottom-color: var(--primary-color) !important;
  color: var(--primary-color);
}
.cp-secondary-tabs .k-tabstrip-content, .cp-small-tabs .k-tabstrip-content {
  padding-block: 1rem 0;
  padding-inline: 0;
}

.k-tabstrip-content {
  border-width: 0;
}

.k-editor {
  border: var(--border-style);
  border-radius: var(--border-m-radius);
}
.k-editor .k-toolbar, .k-editor .k-editor-toolbar {
  border: 0px;
  border-bottom: var(--border-style);
  color: var(--primary-font-color);
  background-color: var(--light-grey);
  border-radius: var(--border-m-radius-top);
}
.k-editor .k-button {
  border: var(--border-style);
  background-color: #ffffff;
  padding: 0px;
  width: 30px;
  height: 30px;
}
.k-editor .k-button:hover {
  color: var(--primary-font-color);
  background-color: var(--surface-50);
  background: var(--surface-50);
}
.k-editor .k-button .k-button-icon {
  font-size: 10px;
  color: var(--primary-font-color);
}
.k-editor .k-dropdown .k-dropdown-wrap {
  color: var(--primary-font-color);
  border: var(--border-style);
  background: #ffffff;
}
.k-editor .k-editor-content {
  font-family: var(--font);
}

.k-editor-dialog .k-edit-form-container {
  padding: 30px !important;
}
.k-editor-dialog .k-edit-form-container .k-edit-label {
  width: 100%;
  text-align: left;
  margin: 0px;
  padding: 0px;
}
.k-editor-dialog .k-edit-form-container .k-edit-label label {
  margin: 0px;
  font-size: 12px;
  font-weight: 500;
  color: var(--secondary-font-color);
}
.k-editor-dialog .k-edit-form-container .k-edit-field {
  width: 100%;
}
.k-editor-dialog .k-edit-form-container .k-edit-field .k-input {
  border: var(--border-style);
  border-radius: var(--border-sm-radius);
  color: var(--primary-font-color);
  transition: none;
  background-color: var(--white);
}
.k-editor-dialog .k-edit-form-container .k-edit-field .k-input:focus, .k-editor-dialog .k-edit-form-container .k-edit-field .k-input:focus-within, .k-editor-dialog .k-edit-form-container .k-edit-field .k-input.k-state-focus, .k-editor-dialog .k-edit-form-container .k-edit-field .k-input.k-state-focused {
  background-color: #ffffff;
  box-shadow: none;
}

:root {
  --checkbox-size: 2em;
  --radio-size-sm: calc(var(--checkbox-size) * 0.5);
  --radio-size: calc(var(--checkbox-size) * 0.825);
  --radio-size-lg: calc(var(--checkbox-size) * 1.125);
}

.k-checkbox {
  border-color: var(--surface-100);
  background-color: var(--white);
  height: var(--checkbox-size);
  width: var(--checkbox-size);
  position: relative;
}
.k-checkbox:checked {
  border-color: var(--primary-color);
  color: white;
  background-color: var(--white);
  background-image: none;
}
.k-checkbox:checked:focus {
  box-shadow: none;
  outline: none;
  background: var(--surface-50);
}
.k-checkbox:checked:before {
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  content: "\\f00c";
  width: calc(var(--checkbox-size) - 2px);
  height: calc(var(--checkbox-size) - 2px);
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  position: absolute;
}
.k-checkbox:indeterminate, .k-checkbox .k-checkbox.k-indeterminate {
  color: var(--primary-color);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%230255A5' stroke-linecap='square' stroke-linejoin='square' stroke-width='2' d='M4,8 h8'/%3e%3c/svg%3e");
}
.gridCheckBox .k-checkbox {
  width: calc(var(--checkbox-size) * 0.65);
  min-width: calc(var(--checkbox-size) * 0.65);
  height: calc(var(--checkbox-size) * 0.65);
  margin: 0;
}
.gridCheckBox .k-checkbox:before {
  width: calc(var(--checkbox-size) * 0.85 - 2px);
  height: calc(var(--checkbox-size) * 0.85 - 2px);
  font-size: 0.8em;
}

.k-checkbox-label {
  line-height: 1;
}

input[type=checkbox]:focus, input[type=file]:focus, input[type=radio]:focus {
  box-shadow: none;
  outline: none;
  background: var(--surface-50);
}

.cp-checkbox {
  display: inline-flex;
  flex-flow: row;
  align-items: center;
  align-self: center;
}
.cp-checkbox label {
  font-weight: 400;
}
.cp-checkbox.cp-input-container {
  margin: 13px 0 0 0;
}
.cp-checkbox.gridCheckBox {
  width: 100%;
  justify-content: center;
}
.cp-checkbox.rightAlignCheckbox {
  gap: 1rem;
}

.gridToolBarWrap .cp-checkbox.gridCheckBox {
  width: auto;
}

.k-radio {
  border-color: var(--surface-100);
  background-color: var(--white);
  position: relative;
}
.k-radio:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-mask-size: calc(var(--current-size) + 6px) calc(var(--current-size) + 6px);
          mask-size: calc(var(--current-size) + 6px) calc(var(--current-size) + 6px);
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
}
.k-radio-sm {
  --current-size: var(--radio-size-sm);
  height: var(--current-size);
  width: var(--current-size);
}
.k-radio-md {
  --current-size: var(--radio-size);
  height: var(--current-size);
  width: var(--current-size);
}
.k-radio-lg {
  --current-size: var(--radio-size-lg);
  height: var(--current-size);
  width: var(--current-size);
}
.k-radio:checked, .k-radio.k-checked {
  border-color: var(--primary-color);
  color: var(--primary-color);
  background-color: var(--surface-0);
}
.k-radio:focus, .k-radio:checked:focus, .k-radio.k-checked:focus {
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--primary-color) 10%, transparent);
}
input[type=checkbox], input[type=radio] {
  margin: 0 !important;
}

.k-icon {
  font-size: 0.875rem;
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free", "WebComponentsIcons" !important;
}
.k-icon:before {
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free", "WebComponentsIcons" !important;
}
.k-icon.lg-icon {
  font-size: 20px;
}
.k-icon.md-icon {
  font-size: 16px;
}
.k-icon.sm-icon {
  font-size: 8px;
}
.k-input-button .k-icon, .k-input .k-icon, .k-combobox .k-icon {
  font-size: 0.625rem !important;
}

.k-i-arrow-60-up::before, .k-i-arrow-n::before, .k-i-sarrow-n::before, .k-i-expand-n::before, .k-i-caret-alt-up:before {
  content: "\\f077";
}

.k-i-arrow-60-down::before, .k-i-arrow-s::before, .k-i-sarrow-s::before, .k-i-collapse::before, .k-i-expand-s::before, .k-i-caret-alt-down:before {
  content: "\\f078";
}

.k-i-arrow-60-left::before, .k-i-arrow-w::before, .k-i-sarrow-w::before, .k-i-expand-w::before, .k-i-arrow-chevron-left::before, .k-i-arrowhead-w::before, .k-i-caret-alt-left:before {
  content: "\\f104";
}

.k-i-arrow-60-right::before, .k-i-arrow-e::before, .k-i-sarrow-e::before, .k-i-expand::before, .k-i-expand-e::before, .k-i-arrow-chevron-right::before, .k-i-arrowhead-e::before, .k-i-caret-alt-right:before {
  content: "\\f105";
}

.k-i-close::before, .k-i-group-delete::before, .k-i-x::before {
  content: "\\f00d";
}

.k-i-x-circle::before {
  content: "\\f057";
}

.k-i-calendar::before {
  content: "\\f073";
  font-weight: 500;
}

.k-i-bold::before {
  content: "\\f032";
}

.k-i-italic::before {
  content: "\\f033";
}

.k-i-underline::before {
  content: "\\f0cd";
}

.k-i-align-left::before {
  content: "\\f036";
}

.k-i-align-center::before {
  content: "\\f037";
}

.k-i-align-right::before {
  content: "\\f038";
}

.k-i-align-justify::before {
  content: "\\f039";
}

.k-i-link-horizontal::before {
  content: "\\f0c1";
}

.k-i-unlink-horizontal::before {
  content: "\\f127";
}

.k-i-image::before {
  content: "\\f03e";
}

.k-i-list-unordered::before, .k-i-insert-unordered-list::before {
  content: "\\f03a";
}

.k-i-list-ordered::before, .k-i-insert-ordered-list::before {
  content: "\\f0cb";
}

.k-i-indent-increase::before {
  content: "\\f03c";
}

.k-i-indent-decrease::before {
  content: "\\f03c";
  transform: scale(1, -1);
}

.k-i-save::before {
  content: "\\f0c7";
}

.k-i-edit::before {
  content: "\\f044";
}

.k-i-plus::before, .k-plus::before, .k-i-add::before {
  content: "\\f0fe";
}

.k-i-minus::before, .k-minus::before, .k-i-subtract::before {
  content: "\\f146";
}

.k-i-cancel::before {
  content: "\\f05e";
}

.k-i-reset::before {
  content: "\\f2f1";
}

.k-i-clock::before {
  content: "\\f017";
  font-weight: 500;
}

.k-i-play::before {
  content: "\\f144";
  font-weight: 500;
}

.k-i-stop::before {
  content: "\\f28d";
  font-weight: 500;
}

.k-i-window-minimize::before, .k-i-minimize::before {
  content: "\\f2d1";
}

.k-i-window-maximize::before, .k-i-maximize::before {
  content: "\\f2d0";
}

.k-i-window-restore::before, .k-i-restore::before {
  content: "\\f2d2";
}

.k-i-download::before {
  content: "\\f019";
}

.k-i-arrow-end-left::before, .k-i-seek-w::before, .k-i-caret-alt-to-left:before {
  content: "\\f100";
}

.k-i-arrow-end-right::before, .k-i-seek-e::before, .k-i-caret-alt-to-right:before {
  content: "\\f101";
}

.k-i-search::before {
  content: "\\f002";
}

.k-i-arrows-alt::before {
  content: "\\f0b2";
}

.k-i-eye::before {
  content: "\\f06e";
}

.k-i-eye-slash::before {
  content: "\\f070";
}

.k-i-th::before {
  content: "\\f00a";
}

.k-i-user-plus::before {
  content: "\\f234";
}

.k-i-exchange::before {
  content: "\\f362";
}

.k-i-global::before {
  content: "\\f0ac";
}

.k-i-star::before {
  content: "\\f058";
}

.k-i-success::before {
  content: "\\f058";
  color: var(--alert-success) !important;
}

.k-i-error::before {
  content: "\\f057";
  color: var(--alert-danger) !important;
}

.k-i-warning::before {
  content: "\\f071";
  color: var(--alert-warning) !important;
}

.k-i-info::before {
  content: "\\f05a";
}

.k-i-filter::before {
  content: "\\f0b0";
}

.k-i-sort-asc-sm {
  color: var(--primary-color) !important;
}
.k-i-sort-asc-sm::before {
  content: "\\f161";
}

.k-i-sort-desc-sm {
  color: var(--primary-color) !important;
}
.k-i-sort-desc-sm::before {
  content: "\\f160";
}

.k-i-more-vertical {
  color: var(--primary-color) !important;
  text-align: center;
}
.k-i-more-vertical::before {
  content: "\\f142";
}

.k-i-columns {
  color: var(--primary-color) !important;
  text-align: center;
}
.k-i-columns::before {
  content: "\\f0db";
}

.k-i-file-image::before {
  content: "\\f03e";
}

.k-i-file-txt::before {
  content: "\\f15c";
}

.k-i-file-pdf::before, .k-i-pdf::before {
  content: "\\f1c1";
}

.k-i-excel::before {
  content: "\\f1c3";
}

.k-i-paste-plain-text::before, .k-i-paste::before {
  content: "\\f0ea";
}

.k-i-copy::before {
  content: "\\f0c5";
}

.k-i-briefcase::before {
  content: "\\f0b1";
}

.k-i-hard-hat::before {
  content: "\\f807";
  font-family: "Font Awesome 5 Free" !important;
  font-weight: 900;
}

.k-i-quote::before {
  content: "\\f10e";
}

.k-i-cart::before {
  content: "\\f07a";
}

.k-i-invoice::before {
  content: "\\f571";
}

.k-i-sync::before {
  content: "\\f021";
}

.iconStack {
  display: grid;
  grid-template: 1fr;
  place-items: center;
}
.iconStack i {
  grid-column: 1;
  grid-row: 1;
  z-index: 1;
  font-size: 8px;
}
.iconStack i:last-child {
  font-size: 16px;
  z-index: 2;
}

.k-splitter {
  background-color: transparent;
  border-width: 0px;
}
.k-splitter .k-splitbar {
  color: var(--primary-font-color);
  background-color: #D8D8D8;
}
.k-splitter .k-splitbar.k-ghost-splitbar-vertical, .k-splitter .k-splitbar.k-splitbar-vertical {
  height: 8px;
}
.k-splitter .k-splitbar:active, .k-splitter .k-splitbar.k-state-focused {
  color: var(--primary-color);
  background-color: #D8D8D8;
}

.k-upload .k-action-buttons {
  padding: 8px;
  border: none;
}
.k-upload .k-action-buttons .k-button.k-clear-selected {
  color: var(--primary-font-color);
  background-color: var(--white);
  border: var(--border-style);
}
.k-upload .k-action-buttons .k-button.k-clear-selected:hover {
  background-color: var(--surface-50);
}
.k-upload.gridUpload .k-dropzone, .k-upload.gridUpload .k-upload-dropzone {
  border-color: transparent;
  color: var(--primary-font-color);
  background-color: transparent;
  padding: 0;
  margin: 0;
  border-width: 0;
}
.k-upload.gridUpload .k-dropzone .k-dropzone-hint, .k-upload.gridUpload .k-upload-dropzone .k-dropzone-hint {
  display: none;
}
.k-upload.gridUpload:has(.k-upload-files) .k-dropzone, .k-upload.gridUpload:has(.k-upload-files) .k-upload-dropzone {
  display: none;
}
.k-upload.gridUpload:has(.k-upload-files) .k-upload-files {
  border-width: 0;
}
.k-upload.gridUpload:has(.k-upload-files) .k-upload-files li {
  font-size: 0.75rem;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
}
.k-upload.gridUpload .k-actions {
  display: none;
}

.imageUpload {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.imageUpload .k-widget, .imageUpload .k-upload {
  border: none;
  background-color: transparent;
  height: 100%;
}
.imageUpload .k-widget .k-dropzone, .imageUpload .k-upload .k-dropzone {
  background: transparent;
}
.imageUpload .k-widget .k-dropzone .k-dropzone-hint, .imageUpload .k-upload .k-dropzone .k-dropzone-hint {
  display: none;
}
.imageUpload .k-widget .k-dropzone .k-button.k-upload-button, .imageUpload .k-upload .k-dropzone .k-button.k-upload-button {
  border: var(--border-style);
  color: var(--primary-font-color);
  background-color: #ffffff;
  min-width: initial;
  margin: 0px;
}
.imageUpload .k-widget .k-dropzone .k-button.k-upload-button span, .imageUpload .k-upload .k-dropzone .k-button.k-upload-button span {
  font-family: "Font Awesome 5 Pro" !important;
  font-size: 12px;
  font-weight: 900;
  line-height: 12px;
}
.imageUpload .k-widget .k-dropzone .k-button.k-upload-button span:after, .imageUpload .k-upload .k-dropzone .k-button.k-upload-button span:after {
  content: "\\f093";
}
.imageUpload .k-widget .k-dropzone .k-button.k-upload-button:hover, .imageUpload .k-upload .k-dropzone .k-button.k-upload-button:hover {
  color: var(--primary-font-color);
  background-color: var(--surface-50);
  background: var(--surface-50);
  border: var(--border-style);
}
.imageUpload .k-widget .k-dropzone .k-button.k-upload-button:focus::after, .imageUpload .k-upload .k-dropzone .k-button.k-upload-button:focus::after {
  border-color: var(--primary-color);
  box-shadow: none;
}
.imageUpload .k-widget .k-action-buttons, .imageUpload .k-upload .k-action-buttons {
  padding: 0;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  border: none;
}
.imageUpload .k-widget .k-action-buttons .k-button, .imageUpload .k-upload .k-action-buttons .k-button {
  flex-grow: 1;
}
.imageUpload .k-widget .k-action-buttons .k-button.k-clear-selected, .imageUpload .k-upload .k-action-buttons .k-button.k-clear-selected {
  color: var(--primary-font-color);
  background-color: var(--white);
  border: var(--border-style);
}
.imageUpload .k-widget .k-action-buttons .k-button.k-clear-selected:hover, .imageUpload .k-upload .k-action-buttons .k-button.k-clear-selected:hover {
  background-color: var(--surface-50);
}

.upload-icon-btn .k-upload {
  border-width: 0px;
  background-color: transparent;
}
.upload-icon-btn .k-upload .k-dropzone .k-dropzone-hint {
  display: none;
  color: red;
}
.upload-icon-btn .k-upload .k-dropzone .k-button.k-upload-button {
  border: var(--border-style);
  color: var(--primary-font-color);
  background-color: #ffffff;
  min-width: initial;
  margin: 0px;
}
.upload-icon-btn .k-upload .k-dropzone .k-button.k-upload-button input {
  width: auto;
}
.upload-icon-btn .k-upload .k-dropzone .k-button.k-upload-button span {
  font-family: "Font Awesome 5 Pro" !important;
  font-size: 12px;
  font-weight: 900;
  line-height: 12px;
  cursor: pointer;
}
.upload-icon-btn .k-upload .k-dropzone .k-button.k-upload-button span:after {
  content: "\\f093";
}
.upload-icon-btn .k-upload .k-dropzone .k-button.k-upload-button:hover {
  color: var(--primary-font-color);
  background-color: var(--surface-50);
  background: var(--surface-50);
  border: var(--border-style);
}
.upload-icon-btn .k-upload .k-dropzone .k-button.k-upload-button:focus::after {
  border-color: var(--primary-color);
  box-shadow: none;
}

#image-upload.hideFile .k-upload .k-upload-files {
  display: none;
}

.customUploads .upload {
  flex-grow: 1;
  margin: 15px;
  cursor: pointer;
}
.customUploads .upload .k-upload .k-dropzone {
  border: none;
  padding: 0px;
  cursor: pointer;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap {
  width: 100%;
  height: 40px;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-button {
  cursor: pointer;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-button.k-upload-button {
  position: relative;
  width: 100%;
  height: 100%;
  color: var(--white);
  min-width: initial;
  margin: 0px;
  cursor: pointer;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-button.k-upload-button span {
  font-family: var(--font) !important;
  font-size: 12px;
  font-weight: 900;
  line-height: 12px;
  cursor: pointer;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-button.k-upload-button span:after {
  content: "Upload";
  cursor: pointer;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-button.k-upload-button:hover {
  background-color: var(--primary-color) -hover;
  background: var(--primary-color) -hover;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-button.k-upload-button:focus::after {
  border-color: var(--primary-color) -hover;
  box-shadow: none;
}
.customUploads .upload .k-upload .k-dropzone .k-upload-button-wrap .k-dropzone-hint {
  display: none;
}

.k-notification-group {
  z-index: 9999999;
  padding: 1rem;
  gap: 1rem;
}
.k-notification-group .k-notification {
  border-radius: var(--border-m-radius);
  padding: 1rem;
  border-width: 1px;
  border-style: solid;
  font-size: 1rem;
  line-height: 1.4285714286rem;
  position: relative;
  gap: 0.625rem;
  box-shadow: var(--shadow-md);
}
.k-notification-group .k-notification .k-notification-status {
  font-size: 1.5rem;
  width: 1.5rem;
}
.k-notification-group .k-notification .k-notification-actions .k-notification-action .k-icon {
  font-size: 1.25rem;
}
.k-notification-group .k-notification .k-notification-wrap {
  /* display: flex;
   flex-direction: row;
   flex-wrap: nowrap;
   font-size: 16px;
   line-height: 20px;
   padding: 10px 5px;
   min-width: 220px;*/
}
.k-notification-group .k-notification .k-notification-wrap .k-notification-content {
  margin-right: 1rem;
  flex: 1 1 auto;
}
.k-notification-group .k-notification .k-notification-content {
  flex: 1 1 fit-content;
}
.k-notification-group .k-notification-success {
  border-color: var(--alert-success);
  color: var(--primary-font-color);
  background-color: var(--notification-success-bg);
}
.k-notification-group .k-notification-warning {
  border-color: var(--alert-warning);
  color: var(--primary-font-color);
  background-color: var(--notification-warning-bg);
}
.k-notification-group .k-notification-error {
  border-color: var(--alert-danger);
  color: var(--primary-font-color);
  background-color: var(--notification-error-bg);
}
.k-notification-group .k-notification-info {
  border-color: var(--border-color);
  color: var(--primary-font-color);
  background-color: #ffffff;
}

.k-scrollview .k-scrollview-wrap li {
  display: flex;
  min-height: 100%;
  width: 100% !important;
  background-color: rgba(var(--surface-800-rgb), 0.5);
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}
.k-scrollview .k-scrollview-wrap li img {
  object-fit: contain;
  min-width: 100%;
  min-height: 100%;
  width: 100%;
}
.k-scrollview .k-scrollview-wrap li .placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  text-align: center;
  color: transparent;
}
.k-scrollview .k-scrollview-wrap li .placeholder:before {
  text-indent: auto;
  content: "\\f03e";
  margin: 4rem 0 0 0;
  font-size: 8rem;
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free" !important;
  color: #ffffff;
  height: 50%;
  justify-content: center;
  align-items: flex-end;
  display: flex;
}
.k-scrollview .k-scrollview-wrap li .placeholder:after {
  text-indent: auto;
  margin: 1rem 0;
  content: "There was an error loading the image. Contact support if this issue persists.";
  color: #ffffff;
}
.k-scrollview .k-scrollview-wrap li .placeholder i {
  margin: 4rem 0;
  font-size: 8rem;
}
.k-scrollview .k-scrollview-wrap li .placeholder p {
  margin: 1rem 0;
}
.k-scrollview .k-scrollview-wrap li .header {
  background-color: rgba(var(--surface-800-rgb), 0.8);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0;
  padding: 15px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-content: center;
}
.k-scrollview .k-scrollview-wrap li .header .title {
  color: #ffffff;
  text-align: left;
  font-size: 24px;
  font-weight: 500;
  margin: 0;
}
.k-scrollview .k-scrollview-wrap li .header .removeBtn {
  color: #ffffff;
}
.k-scrollview .k-scrollview-elements .k-scrollview-next,
.k-scrollview .k-scrollview-elements .k-scrollview-prev {
  text-shadow: rgb(0, 0, 0) 0 0 5px;
  height: calc(100% - 60px);
  top: 60px;
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(var(--surface-700-rgb), 0.2);
  transition: all 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.k-scrollview .k-scrollview-elements .k-scrollview-next .k-icon,
.k-scrollview .k-scrollview-elements .k-scrollview-prev .k-icon {
  font-size: 2.2rem;
}
.k-scrollview .k-scrollview-elements .k-scrollview-next:hover,
.k-scrollview .k-scrollview-elements .k-scrollview-prev:hover {
  width: 4rem;
  background-color: rgba(var(--surface-700-rgb), 0.6);
}
.k-scrollview .k-scrollview-elements .k-scrollview-nav-wrap .k-scrollview-pageable .k-button,
.k-scrollview .k-scrollview-elements .k-scrollview-nav-wrap .k-scrollview-nav .k-button {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.08);
  background: var(--surface-0);
  border: var(--surface-0);
}
.k-scrollview .k-scrollview-elements .k-scrollview-nav-wrap .k-scrollview-pageable .k-button.k-primary,
.k-scrollview .k-scrollview-elements .k-scrollview-nav-wrap .k-scrollview-nav .k-button.k-primary {
  background: var(--primary-color);
  border: var(--primary-color);
}

.partImage .k-scrollview {
  min-height: 220px;
  max-height: 220px;
}
.partImage .k-scrollview .k-scrollview-wrap li {
  background-color: var(--white);
}

.myClass {
  width: 150px;
}

.timeText {
  font-size: 0.75rem;
  color: var(--primary-font-color);
  opacity: 0.5;
  margin: -6px 0 0 -6px;
}

.k-event-drag-hint {
  opacity: 0.8;
  z-index: 9999999;
}

.k-event {
  min-height: 34px !important;
}
.k-event .k-event-actions {
  display: none;
}
.k-event.k-selected {
  box-shadow: none;
}

.k-scheduler {
  border-color: var(--surface-100);
  color: var(--primary-font-color);
  background-color: var(--white);
  border-width: 0;
  outline: none;
  font-size: 0.875rem;
}
.k-scheduler .k-scheduler-toolbar {
  padding: 4px;
  border-color: var(--surface-100);
  flex-flow: row;
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  position: fixed;
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation {
  margin-right: 0.75rem;
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-today, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-prev, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-next {
  font-size: 0.75rem;
  color: var(--primary-font-color);
  border: 1px solid;
  border-color: var(--surface-100);
  background-color: var(--white);
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-today .k-button-icon, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-prev .k-button-icon, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-next .k-button-icon {
  color: var(--primary-font-color);
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-today:hover, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-prev:hover, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-next:hover {
  color: var(--primary-font-color);
  background-color: var(--surface-50);
  background: var(--surface-50);
  border: 1px solid;
  border-color: var(--surface-100);
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-today:hover .k-button-icon, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-prev:hover .k-button-icon, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-next:hover .k-button-icon {
  color: var(--primary-font-color);
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-today:focus::after, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-prev:focus::after, .k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-navigation .k-nav-next:focus::after {
  border-color: var(--surface-100);
  box-shadow: none;
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .k-scheduler-views {
  background: green;
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .viewChangeWrap {
  display: flex;
  flex-flow: row nowrap;
  margin: 0 1rem 0 0;
}
.k-scheduler .k-scheduler-toolbar .dispatchSchedulerHeader .viewChangeWrap .viewChange {
  margin-left: 1rem;
}
.k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-scheduler-header-wrap .k-event, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-event, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-scheduler-header-wrap .k-event, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-event {
  margin: 0;
  height: 36px !important;
  background-color: var(--white);
  box-shadow: none;
  overflow: default;
}
.k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-scheduler-header-wrap .k-event:hover .dispatch, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-event:hover .dispatch, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-scheduler-header-wrap .k-event:hover .dispatch, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-event:hover .dispatch {
  box-shadow: var(--shadow-sm);
  transform: scale(1.02);
  transition-duration: 0.2s;
}
.k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-scheduler-header-wrap .k-event.k-selected .dispatch, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-event.k-selected .dispatch, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-scheduler-header-wrap .k-event.k-selected .dispatch, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-event.k-selected .dispatch {
  box-shadow: var(--shadow-sm);
  transform: scale(1.02);
  transition-duration: 0.2s;
}
.k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-scheduler-header-wrap .k-event .k-event-delete, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-header .k-event .k-event-delete, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-scheduler-header-wrap .k-event .k-event-delete, .k-scheduler .k-scheduler-layout .k-scheduler-pane .k-scheduler-content .k-event .k-event-delete {
  display: none;
}
.k-scheduler .k-scheduler-footer .k-scheduler-navigation {
  position: fixed;
}
.cp-widget .k-tilelayout-item-body {
  padding-top: 0;
}

.k-tilelayout {
  grid-template-columns: repeat(2, 1fr) !important;
  background: transparent;
}
.k-tilelayout .k-tilelayout-item {
  border-width: 0;
  color: var(--primary-font-color);
  z-index: unset;
}
.k-tilelayout .k-tilelayout-item .k-tilelayout-item-header {
  display: inherit;
  font-size: 14px;
  font-weight: 400;
  border-width: 0;
  color: var(--primary-font-color);
}
.k-tilelayout .k-tilelayout-item .k-tilelayout-item-body {
  display: inherit;
  color: var(--primary-font-color);
}
.k-tilelayout .k-tilelayout-item .k-tilelayout-item-body:has(.maximized) {
  display: block;
}
.k-tilelayout .k-tilelayout-item .k-tilelayout-item-body:has(.minimized) {
  display: block;
}
.k-tilelayout .k-tilelayout-item:has(.fullscreen-widget) {
  position: fixed;
  background: #ffffff;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 999;
}
.k-tilelayout .k-tilelayout-item:has(.minimized) {
  height: 54px;
}
.k-tilelayout .k-tilelayout-item:has(.maximized) {
  height: auto;
}
.k-tilelayout .dispatchStatusGauge-widget, .k-tilelayout .dispatchRefTrack-widget {
  background: var(--primary-color);
}
.k-tilelayout .dispatchStatusGauge-widget .k-tilelayout-item-header, .k-tilelayout .dispatchStatusGauge-widget .k-tilelayout-item-body, .k-tilelayout .dispatchRefTrack-widget .k-tilelayout-item-header, .k-tilelayout .dispatchRefTrack-widget .k-tilelayout-item-body {
  background: var(--primary-color);
}
@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet-pro)) {
  .k-tilelayout {
    grid-template-columns: repeat(1, 1fr) !important;
  }
  .k-tilelayout .k-tilelayout-item {
    grid-column: 1/span 1;
  }
}

@keyframes scale-in-ver-top {
  0% {
    transform: scaleY(0);
    transform-origin: 100% 0%;
    opacity: 1;
  }
  100% {
    transform: scaleY(1);
    transform-origin: 100% 0%;
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes heightChange {
  0% {
    height: auto;
  }
  100% {
    height: 54px;
  }
}
.k-chip {
  color: var(--secondary-font-color);
}
.k-chip.k-chip-sm {
  padding-block: 0.2rem;
  padding-inline: 0.2rem;
  font-size: 0.75rem;
  line-height: 1;
}

.k-switch.k-switch-on .k-switch-track {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
}
.k-switch.k-switch-on:focus .k-switch-track, .k-switch.k-switch-on.k-focus .k-switch-track {
  outline: 2px solid var(--primary-100);
}
kendo-label .k-switch {
  margin-left: 0.5rem;
}

.k-textbox::selection, .k-input::selection, .k-textarea::selection, .k-widget ::selection, .k-block ::selection, .k-panel ::selection {
  background-color: var(--textHighlightBgColor) !important;
  color: var(--textHighlightFontColor) !important;
}

.k-state-disabled, .k-widget[disabled] {
  outline: none;
  cursor: default;
  opacity: 1;
  filter: grayscale(0);
  pointer-events: none;
  box-shadow: none;
  background-color: var(--light-grey) !important;
  color: var(--disabled-font-color);
}

.k-content > .ProseMirror {
  padding: 20px;
}

.cp-search-lightbox .k-dialog-titlebar, .cp-search-lightbox .k-window-titlebar {
  padding: 0px;
}

.chart-center {
  width: 140%;
  height: 140%;
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
}

.k-chart, .k-stockchart {
  font-size: 12px;
  min-height: 450px;
}
.k-chart .k-chart-overlay, .k-stockchart .k-chart-overlay {
  z-index: 1;
}

.k-var--chart-inactive {
  background-color: rgba(101, 101, 101, 0);
}

.k-var--chart-major-lines {
  background-color: rgba(0, 0, 0, 0);
}

.k-var--chart-minor-lines {
  background-color: rgba(0, 0, 0, 0);
}

.k-var--chart-area-opacity {
  opacity: 0.8;
}

.k-var--chart-notes-background {
  background-color: rgba(0, 0, 0, 0);
}

.k-var--chart-notes-border {
  background-color: rgba(0, 0, 0, 0);
}

.k-var--chart-notes-lines {
  background-color: rgba(0, 0, 0, 0);
}

.k-var--chart-crosshair-background {
  background-color: rgba(0, 0, 0, 0);
}

.k-var--chart-error-bars-background {
  background-color: rgba(0, 0, 0, 0);
}

.k-chart,
.k-sparkline,
.k-stockchart {
  background-color: transparent;
}

.k-chart .k-popup,
.k-sparkline .k-popup,
.k-stockchart .k-popup {
  background: transparent;
}

.k-chart-tooltip-wrapper {
  z-index: 900;
}

.k-chart-tooltip {
  border-radius: 2px;
  color: #fff;
}

.k-chart-tooltip-inverse {
  color: #000;
}

.k-chart-crosshair-tooltip,
.k-chart-shared-tooltip {
  color: pink;
  border-color: rgba(0, 0, 0, 0.08);
}

.cp-list-button-dropdown {
  width: auto;
}
.cp-list-button-dropdown .k-dropdown-wrap {
  border-width: 0px;
  color: var(--primary-font-color);
  background-image: none;
  background-clip: unset;
  width: 0px;
}
.cp-list-button-dropdown .k-dropdown-wrap .k-input {
  display: none;
}
.cp-list-button-dropdown .k-dropdown-wrap .k-select {
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  background-color: #ffffff;
  border-radius: var(--border-sm-radius);
  border-color: var(--border-color);
}
.cp-list-button-dropdown .k-dropdown-wrap .k-select:hover {
  background-color: var(--table-border-color);
}
.cp-list-button-dropdown .k-dropdown-wrap .k-select .k-icon {
  width: auto;
  height: auto;
  line-height: auto;
}
.cp-list-button-dropdown .k-dropdown-wrap .k-select .k-icon:before {
  content: "\\f03a";
  font-family: FontAwesome;
  font-size: 1.75em;
}

.kendo-ddlist .k-dropdown-wrap .k-icon:before {
  content: "\\f03a";
  font-family: FontAwesome;
  font-size: 1.75em;
}

.cp-row {
  margin: 0px;
  display: flex;
  flex-wrap: wrap;
}

.has-secondary-tabs .cp-no-padding .k-content {
  padding: 0px;
}

.highLightSave {
  border-width: 3px !important;
  border-color: var(--alert-danger);
  border-style: solid;
  border-radius: var(--border-m-radius);
}

.mat-expansion-panel {
  background-color: #ffffff;
}
.mat-expansion-panel .cp-primary-tabs .k-content {
  border: 0px;
}

.dqoi-transaction-btn {
  width: 100%;
}

.dqoi-ribbon {
  background-color: var(--light-grey);
  border-bottom: var(--border-style);
  width: 100%;
  margin: 0px;
  height: 60px;
  padding: 12px;
  flex-direction: row;
  justify-content: flex-start;
  margin: 0 -1px;
}
.dqoi-ribbon .dqoi-search-wrap .dqoi-search .dqoi-search-bar {
  margin-right: -13px;
}
.dqoi-accordion {
  margin-bottom: 30px;
}

.dqoi-expansion-panel {
  margin-bottom: 0px !important;
  border-bottom-width: 0px !important;
}
.dqoi-expansion-panel .dqoi-logo {
  min-height: 50px;
  min-width: 50px;
  height: 50px;
  width: 50px;
  overflow: hidden;
  margin-left: 30px;
  border-radius: var(--border-m-radius);
}
.dqoi-expansion-panel .dqoi-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #ffffff;
}
.dqoi-expansion-panel .dqoi-logo .no-logo {
  background-color: var(--light-grey);
  box-shadow: inset 0px 0px 0px 1px var(--surface-100);
}
.dqoi-expansion-panel .dqoi-panel-customer-info {
  max-width: 326px;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-right: 20px;
  margin: 0px 13px 0px 20px;
  border-right: var(--border-style);
  align-self: center;
}
.dqoi-expansion-panel .dqoi-panel-customer-info #customer-name {
  font-size: 16px;
  font-weight: 700;
  max-width: 326px;
  height: 20px;
  line-height: 20px;
  color: var(--primary-font-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dqoi-expansion-panel .dqoi-panel-customer-info #customer-location {
  font-size: 14px;
  font-weight: 400;
  max-width: 326px;
  height: 20px;
  line-height: 20px;
  color: var(--primary-font-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap .dqoi-panel-dqoi-info {
  flex-grow: 1;
  margin: 0px 13px;
  max-width: 200px;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap .dqoi-panel-dqoi-info .dqoi-label {
  font-weight: 600;
  font-size: 13px;
  width: 100%;
  height: 18px;
  line-height: 18px;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap .dqoi-panel-dqoi-info .dqoi-label .dqoi-panel-priority {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  line-height: 18px;
  top: -13px;
  position: relative;
  left: 50px;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap .dqoi-panel-dqoi-info .dqoi-info {
  color: var(--primary-font-color);
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap .dqoi-panel-dqoi-info .dqoi-info span {
  width: 100%;
  display: block;
}
.dqoi-expansion-panel .dqoi-panel-dqoi-info-wrap .dqoi-panel-dqoi-info .dqoi-info span:first-child {
  font-weight: 600;
}
.dqoi-expansion-panel .mat-expansion-panel-body {
  padding: 0px !important;
}
.dqoi-expansion-panel .mat-expansion-panel-header-title {
  width: 95%;
  display: flex;
}
.dqoi-expansion-panel .dqoi-panel-controls {
  display: flex;
  flex-flow: row nowrap;
}
.dqoi-expansion-panel .dqoi-panel-controls cp-loader {
  margin-right: 20px;
}

/*.dqoi-expansion-panel{
	margin-bottom:0px !important;

	.dqoi-logo{
		height:40px;
		width:40px;
		position: relative;
		margin-left:20px;
		border-radius:var(--border-m-radius);

		img {
			object-fit: cover;
			width: 40px;
			height: 40px;
		}
	}

	.mat-expansion-panel-body{
		padding:0px !important;
	}
}*/
.dispatch-notes .k-grid {
  /*height: 300px;
     max-height: 300px;*/
}

@media only screen and (max-width: 1200px) {
  .cp-dqoi-sidebar {
    border-bottom: var(--border-style);
    border-right: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/cp-variables.scss","webpack://./src/app/cp/construction/construction-main/cboi.component.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-tooltip.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-input.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-buttons.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-grid.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-calendar.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-window.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-tabstrip.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-editor.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-checkRadio.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-icons.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-splitpanel.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-upload.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-toasts.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-scrollView.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-scheduler.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-tileLayout.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-chips.scss","webpack://./src/assets/scss/cpi-kendo/cp-kendo-switch.scss","webpack://./src/assets/scss/cp-kendo.scss"],"names":[],"mappings":"AAIA;EACI,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8CAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gDAAA;EACA,kDAAA;EAIA,wCAAA;EACA,gDAAA;EACA,0CAAA;EACA,6BAAA;EACA,qCAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,0CAAA;EACA,6BAAA;EACA,4CAAA;EAGA,kCAAA;EACA,gDAAA;EACA,4BAAA;EACA,wDAAA;EACA,4CAAA;EACA,sBAAA;EACA,qBAAA;EACA,qCAAA;EACA,wCAAA;EACA,sBAAA;EACA,mCAAA;EAGA,uBAAA;EACA,qBAAA;EAEA,wCAAA;EAGA,uBAAA;EACA,gCAAA;EACA,iDAAA;EACA,uBAAA;EACA,+BAAA;EACA,gDAAA;EACA,kCAAA;EACA,0CAAA;EACA,4CAAA;EACA,sBAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EAGA,oCAAA;EACA,4CAAA;EACA,6CAAA;EACA,oDAAA;EAIA,mCAAA;EACA,mCAAA;EACA,qCAAA;EAGA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EAEA,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAIA,yBAAA;EACA,uCAAA;EACA,qBAAA;EACA,gBAAA;EAGA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,4BAAA;EACA,iDAAA;EACA,sCAAA;EACA,oCAAA;EACA,uDAAA;AC1BJ;AD4BI;EACI,wBAAA;EAEA,oBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;AC5BR;;ADqCI;EAAI,SAAA;ACjCR;ADkCI;EAAI,uBAAA;AC/BR;ADgCI;EAAI,uBAAA;AC7BR;AD8BI;EAAI,uBAAA;AC3BR;AD4BI;EAAI,uBAAA;ACzBR;AD0BI;EAAI,uBAAA;ACvBR;ADwBI;EAAI,uBAAA;ACrBR;ADsBI;EAAI,uBAAA;ACnBR;ADoBI;EAAI,uBAAA;ACjBR;ADkBI;EAAI,uBAAA;ACfR;ADiBQ;EAAI,aAAA;ACdZ;ADeQ;EAAI,2BAAA;ACZZ;ADaQ;EAAI,2BAAA;ACVZ;ADWQ;EAAI,2BAAA;ACRZ;ADSQ;EAAI,2BAAA;ACNZ;ADOQ;EAAI,2BAAA;ACJZ;ADKQ;EAAI,2BAAA;ACFZ;ADGQ;EAAI,2BAAA;ACAZ;ADCQ;EAAI,2BAAA;ACEZ;ADDQ;EAAI,2BAAA;ACIZ;ADDQ;EAAI,eAAA;ACIZ;ADHQ;EAAI,6BAAA;ACMZ;ADLQ;EAAI,6BAAA;ACQZ;ADPQ;EAAI,6BAAA;ACUZ;ADTQ;EAAI,6BAAA;ACYZ;ADXQ;EAAI,6BAAA;ACcZ;ADbQ;EAAI,6BAAA;ACgBZ;ADfQ;EAAI,6BAAA;ACkBZ;ADjBQ;EAAI,6BAAA;ACoBZ;ADnBQ;EAAI,6BAAA;ACsBZ;ADnBQ;EAAI,gBAAA;ACsBZ;ADrBQ;EAAI,8BAAA;ACwBZ;ADvBQ;EAAI,8BAAA;AC0BZ;ADzBQ;EAAI,8BAAA;AC4BZ;AD3BQ;EAAI,8BAAA;AC8BZ;AD7BQ;EAAI,8BAAA;ACgCZ;AD/BQ;EAAI,8BAAA;ACkCZ;ADjCQ;EAAI,8BAAA;ACoCZ;ADnCQ;EAAI,8BAAA;ACsCZ;ADrCQ;EAAI,8BAAA;ACwCZ;ADrCI;EAAI,cAAA;ACwCR;ADvCI;EAAI,4BAAA;AC0CR;ADzCI;EAAI,4BAAA;AC4CR;AD3CI;EAAI,4BAAA;AC8CR;AD7CI;EAAI,4BAAA;ACgDR;AD/CI;EAAI,4BAAA;ACkDR;ADjDI;EAAI,4BAAA;ACoDR;ADnDI;EAAI,4BAAA;ACsDR;ADrDI;EAAI,4BAAA;ACwDR;ADvDI;EAAI,4BAAA;AC0DR;;ADtDI;EAAI,UAAA;AC0DR;ADzDI;EAAI,wBAAA;AC4DR;AD3DI;EAAI,wBAAA;AC8DR;AD7DI;EAAI,wBAAA;ACgER;AD/DI;EAAI,wBAAA;ACkER;ADjEI;EAAI,wBAAA;ACoER;ADnEI;EAAI,wBAAA;ACsER;ADrEI;EAAI,wBAAA;ACwER;ADvEI;EAAI,wBAAA;AC0ER;ADzEI;EAAI,wBAAA;AC4ER;AD1EQ;EAAI,cAAA;AC6EZ;AD5EQ;EAAI,4BAAA;AC+EZ;AD9EQ;EAAI,4BAAA;ACiFZ;ADhFQ;EAAI,4BAAA;ACmFZ;ADlFQ;EAAI,4BAAA;ACqFZ;ADpFQ;EAAI,4BAAA;ACuFZ;ADtFQ;EAAI,4BAAA;ACyFZ;ADxFQ;EAAI,4BAAA;AC2FZ;AD1FQ;EAAI,4BAAA;AC6FZ;AD5FQ;EAAI,4BAAA;AC+FZ;AD5FQ;EAAI,gBAAA;AC+FZ;AD9FQ;EAAI,8BAAA;ACiGZ;ADhGQ;EAAI,8BAAA;ACmGZ;ADlGQ;EAAI,8BAAA;ACqGZ;ADpGQ;EAAI,8BAAA;ACuGZ;ADtGQ;EAAI,8BAAA;ACyGZ;ADxGQ;EAAI,8BAAA;AC2GZ;AD1GQ;EAAI,8BAAA;AC6GZ;AD5GQ;EAAI,8BAAA;AC+GZ;AD9GQ;EAAI,8BAAA;ACiHZ;AD9GQ;EAAI,iBAAA;ACiHZ;ADhHQ;EAAI,+BAAA;ACmHZ;ADlHQ;EAAI,+BAAA;ACqHZ;ADpHQ;EAAI,+BAAA;ACuHZ;ADtHQ;EAAI,+BAAA;ACyHZ;ADxHQ;EAAI,+BAAA;AC2HZ;AD1HQ;EAAI,+BAAA;AC6HZ;AD5HQ;EAAI,+BAAA;AC+HZ;AD9HQ;EAAI,+BAAA;ACiIZ;ADhIQ;EAAI,+BAAA;ACmIZ;ADhIQ;EAAI,eAAA;ACmIZ;ADlIQ;EAAI,6BAAA;ACqIZ;ADpIQ;EAAI,6BAAA;ACuIZ;ADtIQ;EAAI,6BAAA;ACyIZ;ADxIQ;EAAI,6BAAA;AC2IZ;AD1IQ;EAAI,6BAAA;AC6IZ;AD5IQ;EAAI,6BAAA;AC+IZ;AD9IQ;EAAI,6BAAA;ACiJZ;ADhJQ;EAAI,6BAAA;ACmJZ;ADlJQ;EAAI,6BAAA;ACqJZ;;ADiBA;;;;;;;;;;;EAAA;AAoCA;;;;;;;;;;;;;;;;QAAA;AErgBC;EACC,4BAAA;EACA,cAAA;EACA,2BAAA;EACA,qCAAA;EACA,iBAAA;EACA,sCAAA;EACA,aAAA;EACA,kBAAA;ADgfF;AC/eE;EACC,eAAA;ADifH;AC/eE;EACU,gBAAA;ADifZ;AC/eE;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;ADifH;AChfG;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,6CAAA;EACA,sCAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;ADkfJ;AChfY;EACI,oBAAA;ADkfhB;AChfY;EACI,YAAA;EACA,qCAAA;ADkfhB;;AC7eA;EACI,iBAAA;EACA,oBAAA;EACH,uBAAA;ADgfD;;AC1eE;EACA,gCAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;AD6eF;AC5eG;EACC,YAAA;AD8eJ;AC7eI;EACC,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;AD+eL;ACxeE;EACC,cAAA;EACA,2BAAA;EACA,iBAAA;EACA,6CAAA;AD0eH;ACzeG;EACC,YAAA;AD2eJ;AC1eI;EACC,6CAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;AD4eL;ACreQ;EACI,cAAA;EAEA,iBAAA;EACA,qCAAA;ADseZ;ACreY;EACI,YAAA;ADuehB;ACtegB;EACI,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;ADwepB;;ACleA;EAAwC,YAAA;ADsexC;;ACreA;EAAuC,YAAA;ADyevC;;ACveC;EACC,qBAAA;EACA,mBAAA;AD0eF;ACzeQ;EACI,iCAAA;EACA,0BAAA;AD2eZ;ACxeC;EACC,gCAAA;EACM,8BAAA;EACN,uBAAA;AD0eF;ACxeI;EAAY,aAAA;AD2ehB;AC1eI;EAAW,YAAA;AD6ef;AC5eI;EACI,sBAAA;EACA,mBAAA;EACA,gBAAA;AD8eR;AC5eI;EACI,eAAA;AD8eR;;AC1eA;EACI,kBAAA;AD6eJ;;AEpnBA;EACI,WAAA;AFunBJ;AEtnBI;EACI,WAAA;AFwnBR;AEvnBQ;EACI,wBAAA;EACA,YAAA;AFynBZ;AEvnBQ;EACI,WAAA;EACA,YAAA;AFynBZ;AEtnBI;EACI,mBAAA;AFwnBR;AEvnBQ;EAAU,WAAA;AF0nBlB;AExnBY;EACI,wBAAA;EACA,kBAAA;AF0nBhB;AEvnBQ;EACI,wBAAA;EACA,kBAAA;AFynBZ;AEvnBQ;EACI,WAAA;EACA,YAAA;AFynBZ;AEtnBY;EACI,mBAAA;EACA,gCAAA;EACA,wCAAA;EACA,2BAAA;AFwnBhB;AEnnBQ;EACI,qCAAA;AFqnBZ;;AE7mBI;EACI,4CAAA;AFgnBR;AE/mBQ;EACI,4CAAA;AFinBZ;AE5mBI;EACI,4CAAA;AF8mBR;AE7mBQ;EACI,4CAAA;AF+mBZ;AE5mBI;EACI,yBAAA;AF8mBR;AE7mBQ;EACI,uDAAA;AF+mBZ;;AEzmBI;EACI,qCAAA;AF4mBR;AExmBQ;EACI,6CAAA;AF0mBZ;;AEpmBI;EACI,kCAAA;EACA,gDAAA;AFumBR;;AEnmBA;EACI,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AFsmBJ;AErmBI;EACI,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;AFumBR;AErmBI;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,MAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;AFumBR;AEtmBQ;EACI,mBAAA;AFwmBZ;;AEnmBA;EACI,oCAAA;EACA,gCAAA;AFsmBJ;AErmBI;EACI,0BAAA;EACA,uBAAA;EACA,wBAAA;AFumBR;AErmBI;EAAe,wBAAA;AFwmBnB;AEvmBI;EACI,gCAAA;EACA,gBAAA;EACA,gCAAA;AFymBR;AEvmBI;EACI,gCAAA;EACA,gBAAA;EACA,gCAAA;AFymBR;AEvmBI;EACI,qBAAA;AFymBR;;AEpmBI;EACI,yBAAA;EACA,uDAAA;EACA,eAAA;AFumBR;AEtmBQ;EACI,yBAAA;EACA,4CAAA;EACA,eAAA;AFwmBZ;AEtmBQ;EACI,oCAAA;AFwmBZ;AEtmBQ;EACI,yBAAA;EACA,uDAAA;AFwmBZ;AErmBY;EACI,uDAAA;AFumBhB;;AElmBA;EACI,qBAAA;AFqmBJ;;AE5lBQ;EAAQ,uBAAA;AFgmBhB;AE9lBI;EACI,sBAAA;EACA,YAAA;AFgmBR;AE/lBQ;EACI,aAAA;AFimBZ;AE/lBQ;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sCAAA;EACA,iCAAA;AFimBZ;AEhmBY;EACI,2CAAA;AFkmBhB;AEhmBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AFkmBhB;AEjmBgB;EACI,gBAAA;EACA,wBAAA;EACA,iBAAA;AFmmBpB;;AE5lBA;EACI,YAAA;AF+lBJ;;AE5lBA;EACI,gCAAA;EACA,gCAAA;EACA,8BAAA;EACA,0GAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AF+lBJ;AE9lBI;EACI,sCAAA;AFgmBR;AE9lBI;EAGI,gCAAA;AF8lBR;AE7lBQ;EACI,4BAAA;AF+lBZ;AE9lBY;EACI,8BAAA;EACA,yBAAA;AFgmBhB;AE7lBQ;EACI,6BAAA;AF+lBZ;AE7lBQ;EACI,6BAAA;EACA,gBAAA;AF+lBZ;AE5lBI;EACI,aAAA;EACA,8BAAA;EACA,2BAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,4BAAA;AF8lBR;AE5lBI;EACI,qCAAA;EACA,4BAAA;EACA,kCAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;AF8lBR;AE5lBI;EACI,YAAA;AF8lBR;;AE3lBA;EACI,kBAAA;EACA,gCAAA;AF8lBJ;AE3lBY;EACI,6BAAA;EACA,gCAAA;AF6lBhB;AEzlBI;EACI,wBAAA;AF2lBR;AExlBQ;EACI,4BAAA;AF0lBZ;AExlBQ;EACI,gCAAA;AF0lBZ;AEvlBY;EACI,eAAA;AFylBhB;AExlBgB;EACI,yBAAA;AF0lBpB;;AEnlBA;EACI,kCAAA;EACA,mBAAA;EACA,sCAAA;AFslBJ;;AE1kBoB;EACI,gBAAA;AF6kBxB;AE1kBgB;EACI,iBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AF4kBpB;AEzkBY;EAAQ,aAAA;AF4kBpB;AE3kBY;EAAW,aAAA;AF8kBvB;;AG56BA;EACC,gBAAA;EACG,gCAAA;EACA,uCAAA;EACA,gBAAA;AH+6BJ;;AG56BA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AH+6BJ;AG96BI;EACI,WAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,+BAAA;EACA,6BAAA;EACA,+CAAA;AHg7BR;;AG36BI;EAA0B,WAAA;AH+6B9B;;AG16BI;EACI,uBAAA;EACA,gCAAA;EACA,kCAAA;AH66BR;AG56BQ;EAAQ,uBAAA;AH+6BhB;AG96BQ;EACI,8BAAA;AHg7BZ;AG56BQ;EACI,8BAAA;AH86BZ;AG16BQ;EACI,mDAAA;AH46BZ;AG16BQ;EACI,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;AH46BZ;AGz6BY;EACI,yCAAA;AH26BhB;AGt6BY;EACI,2CAAA;AHw6BhB;AGp6BI;EACI,gCAAA;EACA,gBAAA;AHs6BR;AGr6BQ;EAAQ,gCAAA;AHw6BhB;AGv6BQ;EACI,6BAAA;AHy6BZ;AGr6BQ;EACI,kCAAA;EACA,6BAAA;AHu6BZ;AGn6BQ;EACI,iCAAA;EACA,kBAAA;EACA,eAAA;AHq6BZ;AGl6BY;EACI,2BAAA;AHo6BhB;AG/5BY;EACI,qCAAA;EACA,uCAAA;AHi6BhB;AG95BQ;EACI,uBAAA;AHg6BZ;AG75BI;EACI,gCAAA;EACA,wBAAA;EACA,oCAAA;AH+5BR;AG95BQ;EAAQ,gCAAA;AHi6BhB;AGh6BQ;EACI,6BAAA;AHk6BZ;AG95BQ;EACI,gCAAA;EACA,6BAAA;EACA,gCAAA;AHg6BZ;AG55BQ;EACI,qDAAA;AH85BZ;AG55BQ;EACI,gCAAA;EACA,mBAAA;AH85BZ;AG55BQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AH85BZ;AG35BY;EACI,2BAAA;AH65BhB;AGx5BY;EACI,qCAAA;EACA,uCAAA;AH05BhB;AGv5BQ;EACI,uBAAA;EACA,uBAAA;EACA,2BAAA;AHy5BZ;AGx5BY;EACI,+BAAA;EACA,gCAAA;AH05BhB;AGr5BQ;EACI,qCAAA;EACA,kBAAA;AHu5BZ;AGt5BY;EAAQ,0BAAA;AHy5BpB;AGx5BY;EACI,WAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;EACA,gBAAA;AH05BhB;AGt5BI;EACI,wBAAA;EACA,gCAAA;AHw5BR;AGv5BQ;EACI,6BAAA;AHy5BZ;AGr5BQ;EACI,uBAAA;EACA,6BAAA;EACA,gCAAA;AHu5BZ;AGn5BQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AHq5BZ;AGl5BY;EACI,2BAAA;AHo5BhB;AGj5BQ;EACI,gCAAA;AHm5BZ;AGh5BI;EACI;0BAAA;AHm5BR;AGj5BQ;EACI,kBAAA;AHm5BZ;AGl5BY;EACI,gBAAA;AHo5BhB;AGh5BI;EAEI,cAAA;AHi5BR;AG/4BI;EACI,kBAAA;EACA,kBAAA;AHi5BR;AG/4BI;EAAc,mBAAA;AHk5BlB;;AG94BI;EACI,WAAA;AHi5BR;AGh5BQ;EAAU,YAAA;AHm5BlB;;AG/4BA;EACI;IAAM,uBAAA;EHm5BR;EGl5BE;IAAI,yBAAA;EHq5BN;AACF;AIzoCA;EACI,gCAAA;EACA,kBAAA;EACA,+BAAA;AJ2oCJ;AI1oCI;EACI,2BAAA;AJ4oCR;AI3oCQ;EACI,oCAAA;AJ6oCZ;AI5oCY;EACI,gBAAA;AJ8oChB;AI1oCI;EACI,gCAAA;EACA,kBAAA;EACA,kCAAA;EACA,+BAAA;AJ4oCR;AI3oCQ;EACI,2BAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AJ6oCZ;AI5oCY;EACI,kBAAA;EACA,mBAAA;AJ8oChB;AI5oCY;EACI,UAAA;AJ8oChB;AI5oCY;EACI,UAAA;EACA,eAAA;AJ8oChB;AI5oCY;EACI,2BAAA;AJ8oChB;AI1oCY;EACI,eAAA;EACA,gBAAA;EACA,gCAAA;AJ4oChB;AI1oCY;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;AJ4oChB;AIzoCQ;EACI,SAAA;AJ2oCZ;AI1oCY;EACI,mBAAA;EACA,sCAAA;AJ4oChB;AIxoCY;EACI,UAAA;EACA,gCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;AJ0oChB;AIzoCgB;EACI,oCAAA;EACA,gCAAA;AJ2oCpB;AIzoCgB;EACI,gBAAA;AJ2oCpB;AIzoCgB;EACI,UAAA;EACA,sCAAA;EACA,kBAAA;AJ2oCpB;AI1oCoB;EACI,mBAAA;AJ4oCxB;AIvoCgB;EACI,UAAA;AJyoCpB;AIxoCoB;EACI,UAAA;EACA,sCAAA;EACA,kBAAA;AJ0oCxB;AIzoCwB;EACI,mBAAA;AJ2oC5B;AIpoCI;EACI,gCAAA;EACA,kBAAA;AJsoCR;AIpoCI;EACI,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AJsoCR;AIroCQ;EACI,kBAAA;EACA,mBAAA;AJuoCZ;AIhoCQ;EACI,sBAAA;EACA,qBAAA;EACA,mBAAA;AJkoCZ;AIhoCQ;EACI,sBAAA;AJkoCZ;AIhoCQ;EACI,qBAAA;AJkoCZ;AI/nCI;EACI,uBAAA;AJioCR;AI9nCQ;EACI,gCAAA;EACA,8CAAA;EACA,6CAAA;AJgoCZ;AI9nCQ;EACI,wCAAA;AJgoCZ;AI9nCQ;EACI,8CAAA;AJgoCZ;AI9nCQ;EACI,uCAAA;AJgoCZ;AI9nCQ;EACI,wCAAA;AJgoCZ;AI9nCQ;EACI,wCAAA;AJgoCZ;AI9nCQ;EACI,4BAAA;AJgoCZ;AI9nCQ;EACI,wDAAA;EACA,eAAA;AJgoCZ;AI/nCY;EACI,6CAAA;EACA,eAAA;AJioChB;AI/nCY;EACI,oCAAA;AJioChB;AI3nCQ;EACI,gCAAA;EACA,8CAAA;AJ6nCZ;AI3nCQ;EACI,gCAAA;EACA,wCAAA;AJ6nCZ;AI3nCQ;EACI,gCAAA;EACA,8CAAA;EACA,6CAAA;AJ6nCZ;AI3nCQ;EACI,yBAAA;AJ6nCZ;AI3nCQ;EACI,iEAAA;AJ6nCZ;AI5nCY;EACI,wIACA;AJ6nChB;AIrnCQ;EACI,eAAA;AJunCZ;AItnCY;EACI,gBAAA;AJwnChB;AIrnCQ;EACI,eAAA;AJunCZ;AItnCY;EACI,gBAAA;AJwnChB;AIrnCQ;EACI,sBAAA;AJunCZ;AInnCQ;EACI,mCAAA;AJqnCZ;AIpnCY;EACI,sBAAA;AJsnChB;AIpnCY;EAAQ,yBAAA;AJunCpB;AIrnCQ;EAAQ,oCAAA;AJwnChB;AIvnCQ;EAAe,oCAAA;AJ0nCvB;AIznCQ;EACI,YAAA;AJ2nCZ;AI1nCY;EAAQ,yBAAA;AJ6nCpB;AI1nCI;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;AJ4nCR;AI1nCI;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;AJ4nCR;AI3nCQ;EACI,cAAA;AJ6nCZ;AI1nCI;EACI,eAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;AJ4nCR;AI3nCQ;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AJ6nCZ;AI3nCgB;EACI,aAAA;AJ6nCpB;AI5nCoB;EACI,SAAA;AJ8nCxB;AIvnCQ;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AJynCZ;AIvnCgB;EACI,8BAAA;AJynCpB;AInnCQ;EACI,8BAAA;EACA,yBAAA;EACA,gCAAA;AJqnCZ;;AI5mCI;EACI,gEAAA;AJ+mCR;AI7mCQ;EACI,gEAAA;EACA,kCAAA;AJ+mCZ;AI5mCI;EACI,iEAAA;AJ8mCR;AI5mCQ;EACI,gEAAA;EACA,kCAAA;AJ8mCZ;AI3mCI;EACI,6DAAA;AJ6mCR;AI5mCQ;EACI,6DAAA;EACA,mBAAA;AJ8mCZ;AI3mCI;EACI,6DAAA;AJ6mCR;AI3mCQ;EACI,4DAAA;EACA,kCAAA;AJ6mCZ;AI1mCI;EACI,+DAAA;AJ4mCR;AI1mCQ;EACI,+DAAA;EACA,kCAAA;AJ4mCZ;;AIvmCA;EACI,OAAA;EACA,WAAA;EACA,iBAAA;AJ0mCJ;AIzmCI;EACI,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;UAAA,aAAA;EACA,mCAAA;AJ2mCR;;AItmCA;EACI,WAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AJymCJ;AIxmCI;EACI,kBAAA;AJ0mCR;AIxmCI;EACI,0BAAA;AJ0mCR;AIxmCI;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;AJ0mCR;AIzmCQ;EACI,0BAAA;AJ2mCZ;AIxmCI;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AJ0mCR;AIxmCI;EACI,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;AJ0mCR;AIzmCQ;EACI,kBAAA;AJ2mCZ;AIzmCQ;EACI,0BAAA;AJ2mCZ;AIzmCQ;EACI,6BAAA;AJ2mCZ;AIzmCQ;EACI,sBAAA;AJ2mCZ;AIvmCI;EACI,UAAA;EACA,YAAA;EACA,yBAAA;AJymCR;AIvmCI;EAvDJ;IAwDQ,mBAAA;EJ0mCN;AACF;;AIrmCI;EACI,aAAA;AJwmCR;AIrmCI;EACI,wBAAA;AJumCR;AIpmCI;EACI,wBAAA;AJsmCR;AInmCI;EACI,qBAAA;EACA,sBAAA;EACA,6BAAA;AJqmCR;;AI5lCQ;EACI,mCAAA;EACA,YAAA;EACA,kCAAA;UAAA,0BAAA;AJ+lCZ;;AIvlCY;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;AJ0lChB;AIzlCgB;EACI,gBAAA;AJ2lCpB;AIzlCgB;EACI,gBAAA;EACA,iBAAA;AJ2lCpB;AIzlCgB;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,wBAAA;EACA,eAAA;AJ2lCpB;;AIrlCA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AJwlCJ;AIvlCI;EACI,iBAAA;AJylCR;;AKjkDA;EACI,gCAAA;ALokDJ;AKnkDI;EACI,6BAAA;EACA,gCAAA;EACA,2CAAA;ALqkDR;AKpkDQ;EAAS,2BAAA;ALukDjB;AKtkDQ;EACI,gCAAA;EACA,2BAAA;ALwkDZ;AKnkDW;EACI,2BAAA;ALqkDf;AKlkDQ;EACI,gCAAA;ALokDZ;AK9jDI;EACI,2BAAA;ALgkDR;AK/jDQ;EACI,6BAAA;ALikDZ;AK/jDQ;EACI,gCAAA;ALikDZ;AK/jDQ;EACI,2BAAA;ALikDZ;AK9jDY;EACI,gCAAA;EACA,uBAAA;ALgkDhB;AK/jDgB;EACI,8BAAA;ALikDpB;AK7jDQ;EACI,4BAAA;AL+jDZ;;AKvjDQ;EACI,mBAAA;AL0jDZ;;AMlnDA;EACI,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qCAAA;EACA,gBAAA;EACA,kCAAA;EACA,mCAAA;EACA,4BAAA;EACA,6BAAA;ANqnDJ;AMpnDI;EACI,2BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;ANsnDR;AMrnDQ;EACI,YAAA;ANunDZ;AMtnDY;EACI,eAAA;EACA,YAAA;EACA,WAAA;ANwnDhB;AMpnDI;EACI,yBAAA;EACA,YAAA;EACA,iCAAA;EACA,6BAAA;EACA,yCAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;ANsnDR;AMrnDQ;EACI,cAAA;ANunDZ;AMrnDQ;EACI,WAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ANunDZ;AMnnDQ;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;ANqnDZ;AMnnDQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;ANqnDZ;AMnnDQ;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;ANqnDZ;AMpnDY;EACI,gCAAA;ANsnDhB;AMnnDQ;EACI,qBAAA;ANqnDZ;AMnnDQ;EACI,2BAAA;ANqnDZ;AMnnDQ;EACI,YAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;ANqnDZ;AMpnDY;EACI,8CAAA;EACA,wCAAA;EACA,gCAAA;ANsnDhB;AMlnDY;EACI,8BAAA;ANonDhB;AMnnDgB;EACI,6CAAA;EACA,uCAAA;ANqnDpB;AMhnDI;EACI,uBAAA;ANknDR;AMjnDQ;EACI,YAAA;EACA,gBAAA;ANmnDZ;AMjnDQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;ANmnDZ;AMlnDY;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ANonDhB;AMlnDY;EACI,aAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;ANonDhB;AMlnDY;EACI,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;ANonDhB;AMnnDgB;EACI,4BAAA;ANqnDpB;AMpnDoB;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,2BAAA;ANsnDxB;AMrnDwB;EACI,mCAAA;ANunD5B;AMrnDwB;EACI,0BAAA;ANunD5B;AMrnDwB;EACI,kBAAA;ANunD5B;AMrnDwB;EACI,oCAAA;EACA,2BAAA;ANunD5B;AM9mDI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;ANgnDR;AM9mDI;EACI,YAAA;EACA,cAAA;ANgnDR;;AM3mDI;EACI,eAAA;AN8mDR;;AMvmDA;EACI,UAAA;EACA,MAAA;EACA,iCAAA;AN0mDJ;AMzmDI;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,8BAAA;EACA,wBAAA;AN2mDR;AM1mDQ;EACI,gCAAA;EACA,mCAAA;EACA,6BAAA;EACA,2BAAA;AN4mDZ;AM1mDQ;EACI,iCAAA;EACA,gBAAA;AN4mDZ;AMzmDY;EACI,sCAAA;EACA,kCAAA;EACA,mBAAA;AN2mDhB;;AMrmDA;EACI,6CAAA;EACA,YAAA;EACA,oBAAA;ANwmDJ;;AMpmDA;EACI,2BAAA;ANumDJ;;AMrmDA;EACI,2BAAA;ANwmDJ;AMvmDI;EACI,aAAA;ANymDR;;AMtmDA;EACI,2BAAA;ANymDJ;;AMvmDA;EACI,yBAAA;AN0mDJ;;AMxmDA;EACI,2BAAA;AN2mDJ;;AMzmDA;EACI,4BAAA;AN4mDJ;;AM1mDA;EACI,2BAAA;AN6mDJ;;AM3mDA;EACI,2BAAA;AN8mDJ;;AM5mDA;EACI,2BAAA;AN+mDJ;;AM7mDA;EACI,cAAA;ANgnDJ;AM/mDI;EACI,2BAAA;ANinDR;AMhnDQ;EAFJ;IAGQ,0BAAA;ENmnDV;AACF;;AMhnDA;EACI,eAAA;ANmnDJ;;AMhnDI;EACI,2BAAA;ANmnDR;AMlnDQ;EAFJ;IAGQ,0BAAA;ENqnDV;AACF;;AM/mDA;EACI;IACI,iBAAA;IACA,0BAAA;IACA,sBAAA;IACA,yBAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,yBAAA;IACA,0BAAA;ENknDN;AACF;AOn5DI;EACI,sBAAA;APq5DR;AOp5DQ;EACI,QAAA;APs5DZ;AOr5DY;EACI,uBAAA;EACA,iBAAA;EACA,gCAAA;APu5DhB;AOt5DgB;EACI,8BAAA;APw5DpB;AOt5DgB;EACI,gCAAA;EACA,iBAAA;EACA,iCAAA;EACA,2BAAA;EACA,wBAAA;APw5DpB;AOv5DoB;EACI,wBAAA;EACA,gCAAA;APy5DxB;AOl5DQ;EACI,aAAA;APo5DZ;AOj5DY;EACI,aAAA;APm5DhB;;AO74DI;EACI,wBAAA;EACA,gCAAA;APg5DR;AO/4DQ;EACI,QAAA;APi5DZ;AOh5DY;EACI,yCAAA;EACA,uBAAA;EACA,gCAAA;EACA,gCAAA;EACA,kCAAA;EACA,mBAAA;EACA,mBAAA;APk5DhB;AOj5DgB;EACI,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oDAAA;EACA,2BAAA;APm5DpB;AO94DI;EACI,qBAAA;EACA,iBAAA;APg5DR;;AO54DA;EACI,eAAA;AP+4DJ;;AQl9DA;EACI,2BAAA;EACH,qCAAA;ARq9DD;AQn9DC;EACC,WAAA;EACA,kCAAA;EACA,gCAAA;EACA,mCAAA;EACG,yCAAA;ARq9DL;AQn9DC;EAEC,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;ARo9DF;AQn9DE;EACC,gCAAA;EACA,mCAAA;EACA,6BAAA;ARq9DH;AQn9DE;EACU,eAAA;EACA,gCAAA;ARq9DZ;AQl9DC;EACC,gCAAA;EACA,2BAAA;EACA,mBAAA;ARo9DF;AQl9DI;EACI,wBAAA;ARo9DR;;AQ/8DI;EACI,wBAAA;ARk9DR;AQj9DQ;EACI,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ARm9DZ;AQl9DY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;ARo9DhB;AQj9DQ;EACI,WAAA;ARm9DZ;AQl9DY;EACI,2BAAA;EACA,sCAAA;EACA,gCAAA;EACA,gBAAA;EACA,8BAAA;ARo9DhB;AQn9DgB;EACI,yBAAA;EACA,gBAAA;ARq9DpB;;ASphEA;EACI,oBAAA;EACA,iDAAA;EACA,gDAAA;EACA,mDAAA;ATuhEJ;;ASphEA;EACI,gCAAA;EACA,8BAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;ATuhEJ;ASthEI;EACI,kCAAA;EACA,YAAA;EACA,8BAAA;EACA,sBAAA;ATwhER;ASvhEQ;EACI,gBAAA;EACA,aAAA;EACA,6BAAA;ATyhEZ;ASvhEQ;EACI,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;ATyhEZ;ASthEI;EACI,2BAAA;EACA,8OAAA;ATwhER;ASthEI;EACI,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,SAAA;ATwhER;ASvhEQ;EACI,8CAAA;EACA,+CAAA;EACA,gBAAA;ATyhEZ;;ASnhEA;EACI,cAAA;ATshEJ;;ASnhEA;EACI,gBAAA;EACA,aAAA;EACA,6BAAA;ATshEJ;;ASphEA;EACI,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;ATuhEJ;ASthEI;EACI,gBAAA;ATwhER;ASthEI;EACI,kBAAA;ATwhER;ASthEI;EACI,WAAA;EACA,uBAAA;ATwhER;ASthEI;EACI,SAAA;ATwhER;;ASnhEQ;EACI,WAAA;ATshEZ;;ASjhEA;EACI,gCAAA;EACA,8BAAA;EACA,kBAAA;ATohEJ;ASnhEI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kFAAA;UAAA,0EAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;ATqhER;ASnhEI;EACI,oCAAA;EACA,2BAAA;EACA,0BAAA;ATqhER;ASnhEI;EACI,iCAAA;EACA,2BAAA;EACA,0BAAA;ATqhER;ASnhEI;EACI,oCAAA;EACA,2BAAA;EACA,0BAAA;ATqhER;ASnhEI;EACI,kCAAA;EACA,2BAAA;EACA,kCAAA;ATqhER;ASnhEI;EACI,+EAAA;ATqhER;AS9gEA;EACI,oBAAA;ATghEJ;;AU1pEA;EACI,mBAAA;EACH,yFAAA;AV6pED;AU5pEC;EAEC,yFAAA;AV6pEF;AU3pEC;EACC,eAAA;AV6pEF;AU3pEC;EACC,eAAA;AV6pEF;AU3pEC;EACC,cAAA;AV6pEF;AU3pEI;EACI,8BAAA;AV6pER;;AUxpEA;EACI,gBAAA;AV2pEJ;;AUxpEA;EACI,gBAAA;AV2pEJ;;AUxpEA;EACI,gBAAA;AV2pEJ;;AUxpEA;EACI,gBAAA;AV2pEJ;;AUppEC;EACC,gBAAA;AVupEF;;AUnpEI;EACI,gBAAA;AVspER;;AUhpEA;EACI,gBAAA;EACH,gBAAA;AVmpED;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU/oEA;EACI,gBAAA;AVkpEJ;;AU9oEA;EACI,gBAAA;AVipEJ;;AU9oEA;EACI,gBAAA;EACH,uBAAA;AVipED;;AU7oEA;EACI,gBAAA;AVgpEJ;;AU7oEA;EACI,gBAAA;AVgpEJ;;AU5oEA;EACI,gBAAA;AV+oEJ;;AU3oEA;EACI,gBAAA;AV8oEJ;;AUzoEA;EACI,gBAAA;AV4oEJ;;AUxoEA;EACI,gBAAA;AV2oEJ;;AUtoEA;EACI,gBAAA;EACH,gBAAA;AVyoED;;AUroEA;EACI,gBAAA;EACH,gBAAA;AVwoED;;AUpoEA;EACI,gBAAA;EACH,gBAAA;AVuoED;;AUnoEA;EACI,gBAAA;AVsoEJ;;AUnoEA;EACI,gBAAA;AVsoEJ;;AUnoEA;EACI,gBAAA;AVsoEJ;;AUloEA;EACI,gBAAA;AVqoEJ;;AUjoEA;EACI,gBAAA;AVooEJ;;AUjoEA;EACI,gBAAA;AVooEJ;;AUhoEA;EACC,gBAAA;AVmoED;;AU/nEA;EACC,gBAAA;AVkoED;;AU9nEA;EACC,gBAAA;AVioED;;AU7nEA;EACC,gBAAA;AVgoED;;AU5nEA;EACC,gBAAA;AV+nED;;AU3nEA;EACC,gBAAA;AV8nED;;AU1nEA;EACC,gBAAA;AV6nED;;AUznEA;EACC,gBAAA;AV4nED;;AUxnEA;EACC,gBAAA;AV2nED;;AUvnEA;EACI,gBAAA;EACA,sCAAA;AV0nEJ;;AUvnEA;EACI,gBAAA;EACA,qCAAA;AV0nEJ;;AUvnEA;EACI,gBAAA;EACA,sCAAA;AV0nEJ;;AUvnEA;EACI,gBAAA;AV0nEJ;;AUxnEA;EACI,gBAAA;AV2nEJ;;AUxnEA;EACI,sCAAA;AV2nEJ;AU1nEI;EACA,gBAAA;AV4nEJ;;AUxnEA;EACI,sCAAA;AV2nEJ;AU1nEI;EACI,gBAAA;AV4nER;;AUxnEA;EACI,sCAAA;EACA,kBAAA;AV2nEJ;AU1nEI;EACI,gBAAA;AV4nER;;AUxnEA;EACI,sCAAA;EACA,kBAAA;AV2nEJ;AU1nEI;EACI,gBAAA;AV4nER;;AUtnEA;EACI,gBAAA;AVynEJ;;AUtnEA;EACI,gBAAA;AVynEJ;;AUtnEA;EACI,gBAAA;AVynEJ;;AUtnEA;EACI,gBAAA;AVynEJ;;AUrnEA;EACI,gBAAA;AVwnEJ;;AUpnEA;EACI,gBAAA;AVunEJ;;AUnnEA;EACI,gBAAA;AVsnEJ;;AUnnEA;EACI,gBAAA;EACA,6CAAA;EACA,gBAAA;AVsnEJ;;AUlnEA;EACI,gBAAA;AVqnEJ;;AUjnEA;EACI,gBAAA;AVonEJ;;AUhnEA;EACI,gBAAA;AVmnEJ;;AU/mEA;EACI,gBAAA;AVknEJ;;AUhnEA;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;AVmnEJ;AUjnEI;EACI,cAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AVmnER;AUjnEQ;EACI,eAAA;EACA,UAAA;AVmnEZ;;AW99EA;EACC,6BAAA;EACA,iBAAA;AXi+ED;AWh+EC;EACC,gCAAA;EACA,yBAAA;AXk+EF;AWj+EE;EACC,WAAA;AXm+EH;AWj+EE;EACC,2BAAA;EACA,yBAAA;AXm+EH;;AY7+EI;EACI,YAAA;EACA,YAAA;AZg/ER;AY5+EY;EACI,gCAAA;EACA,8BAAA;EACA,2BAAA;AZ8+EhB;AY7+EgB;EACI,mCAAA;AZ++EpB;AYz+EQ;EACI,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AZ2+EZ;AY1+EY;EACI,aAAA;AZ4+EhB;AYx+EY;EACI,aAAA;AZ0+EhB;AYx+EY;EACI,eAAA;AZ0+EhB;AYz+EgB;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AZ2+EpB;AYv+EQ;EACI,aAAA;AZy+EZ;;AYp+EA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AZu+EJ;AYt+EI;EACI,YAAA;EACA,6BAAA;EACA,YAAA;AZw+ER;AYv+EQ;EACI,uBAAA;AZy+EZ;AYx+EY;EACI,aAAA;AZ0+EhB;AYv+EgB;EACI,2BAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AZy+EpB;AYx+EoB;EACI,4CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AZ0+ExB;AYz+EwB;EACI,gBAAA;AZ2+E5B;AYx+EoB;EACI,gCAAA;EACA,mCAAA;EACA,6BAAA;EACA,2BAAA;AZ0+ExB;AYx+EoB;EACI,kCAAA;EACA,gBAAA;AZ0+ExB;AYr+EQ;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AZu+EZ;AYt+EY;EACI,YAAA;AZw+EhB;AYr+EgB;EACI,gCAAA;EACA,8BAAA;EACA,2BAAA;AZu+EpB;AYt+EoB;EACI,mCAAA;AZw+ExB;;AY99EI;EACI,iBAAA;EACA,6BAAA;AZi+ER;AY/9EY;EACI,aAAA;EACA,UAAA;AZi+EhB;AY99EgB;EACI,2BAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AZg+EpB;AY/9EoB;EACI,WAAA;AZi+ExB;AY/9EoB;EACI,4CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AZi+ExB;AYh+EwB;EACI,gBAAA;AZk+E5B;AY/9EoB;EACI,gCAAA;EACA,mCAAA;EACA,6BAAA;EACA,2BAAA;AZi+ExB;AY/9EoB;EACI,kCAAA;EACA,gBAAA;AZi+ExB;;AYx9EI;EACI,aAAA;AZ29ER;;AYt9EI;EACI,YAAA;EACA,YAAA;EACA,eAAA;AZy9ER;AYv9EY;EACI,YAAA;EACA,YAAA;EACA,eAAA;AZy9EhB;AYx9EgB;EACI,WAAA;EACA,YAAA;AZ09EpB;AYz9EoB;EACI,eAAA;AZ29ExB;AY19EwB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AZ49E5B;AY39E4B;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AZ69EhC;AY59EgC;EACI,iBAAA;EACA,eAAA;AZ89EpC;AY39E4B;EACI,6CAAA;EACA,uCAAA;AZ69EhC;AY39E4B;EACI,yCAAA;EACA,gBAAA;AZ69EhC;AYz9EoB;EAAiB,aAAA;AZ49ErC;;AalrFA;EACI,gBAAA;EACA,aAAA;EACA,SAAA;AbqrFJ;AaprFI;EACI,qCAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;AbsrFR;AarrFQ;EACI,iBAAA;EACA,aAAA;AburFZ;AanrFgB;EACI,kBAAA;AbqrFpB;AajrFQ;EACG;;;;;;qBAAA;AbyrFX;AalrFY;EACI,kBAAA;EACA,cAAA;AborFhB;AajrFQ;EACI,qBAAA;AbmrFZ;AajrFQ;EACI,kCAAA;EACA,gCAAA;EACA,gDAAA;AbmrFZ;AajrFQ;EACI,kCAAA;EACA,gCAAA;EACA,gDAAA;AbmrFZ;AajrFQ;EACI,iCAAA;EACA,gCAAA;EACA,8CAAA;AbmrFZ;AajrFQ;EACI,iCAAA;EACA,gCAAA;EACA,yBAAA;AbmrFZ;;Ac3uFI;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;Ad8uFN;Ac7uFM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;Ad+uFR;Ac7uFM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;Ad+uFR;Ac9uFQ;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mEAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;AdgvFV;Ac9uFQ;EACE,iBAAA;EACA,cAAA;EACA,wFAAA;EACA,cAAA;AdgvFV;Ac9uFQ;EACE,cAAA;EACA,eAAA;AdgvFV;Ac9uFQ;EACE,cAAA;AdgvFV;Ac7uFM;EACE,mDAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;Ad+uFR;Ac9uFQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AdgvFV;Ac9uFQ;EACE,cAAA;AdgvFV;Ac1uFI;;EAEE,iCAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,yDAAA;Ad4uFN;Ac3uFM;;EACE,iBAAA;Ad8uFR;Ac5uFM;;EACE,WAAA;EACA,mDAAA;Ad+uFR;AczuFQ;;EACE,6CAAA;EACA,4BAAA;EACA,wBAAA;Ad4uFV;Ac3uFU;;EACE,gCAAA;EACA,4BAAA;Ad8uFZ;;AcruFE;EACE,iBAAA;EACA,iBAAA;AdwuFJ;ActuFM;EACE,8BAAA;AdwuFR;;Ael2FA;EACI,YAAA;Afq2FJ;;Aen2FA;EACI,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,qBAAA;Afs2FJ;;Aen2FA;EACI,YAAA;EACA,gBAAA;Afs2FJ;;Aen2FA;EACI,2BAAA;Afs2FJ;Aer2FI;EACI,aAAA;Afu2FR;Aer2FI;EACI,gBAAA;Afu2FR;;Aen2FA;EACI,gCAAA;EACA,gCAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;Afs2FJ;Aeh2FI;EACI,YAAA;EACA,gCAAA;EACA,cAAA;Afk2FR;Aej2FQ;EACI,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;Afm2FZ;Ael2FY;EACI,qBAAA;Afo2FhB;Aen2FgB;EACI,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gCAAA;EACA,8BAAA;Afq2FpB;Aep2FoB;EAAe,gCAAA;Afu2FnC;Aet2FoB;EACI,gCAAA;EACA,mCAAA;EACA,6BAAA;EACA,iBAAA;EACA,gCAAA;Afw2FxB;Aev2FwB;EAAe,gCAAA;Af02FvC;Aex2FoB;EACI,gCAAA;EACA,gBAAA;Af02FxB;Aep2FY;EACI,iBAAA;Afs2FhB;Aex1FY;EACI,aAAA;EACA,qBAAA;EACA,kBAAA;Af01FhB;Aez1FgB;EACI,iBAAA;Af21FpB;Aet0FgB;EACI,SAAA;EACA,uBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;Afw0FpB;Aet0FwB;EACI,4BAAA;EACA,sBAAA;EACA,yBAAA;Afw0F5B;Aep0FwB;EACI,4BAAA;EACA,sBAAA;EACA,yBAAA;Afs0F5B;Aen0FoB;EACI,aAAA;Afq0FxB;AehxFQ;EACI,eAAA;AfkxFZ;AgB78FA;EAAmC,cAAA;AhBg9FnC;;AgB/8FA;EACI,gDAAA;EACA,uBAAA;AhBk9FJ;AgBj9FI;EACI,eAAA;EACA,gCAAA;EACA,cAAA;AhBm9FR;AgBl9FQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AhBo9FZ;AgBl9FQ;EACI,gBAAA;EACA,gCAAA;AhBo9FZ;AgBn9FY;EACI,cAAA;AhBq9FhB;AgBl9FY;EACI,cAAA;AhBo9FhB;AgBh9FQ;EAEI,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AhBi9FZ;AgB/8FQ;EACI,YAAA;AhBi9FZ;AgB98FQ;EACI,YAAA;AhBg9FZ;AgB38FI;EACI,gCAAA;AhB68FR;AgB58FQ;EACI,gCAAA;AhB88FZ;AgB38FI;EApDJ;IAqDQ,gDAAA;EhB88FN;EgB78FM;IACI,qBAAA;EhB+8FV;AACF;;AgB38FA;EACI;IAEI,oBAAA;IAEA,yBAAA;IACA,UAAA;EhB88FN;EgB58FE;IAEI,oBAAA;IAEA,yBAAA;IACA,UAAA;EhB88FN;AACF;AgB58FA;EACI;IAEI,mBAAA;IACA,UAAA;EhB88FN;EgB58FE;IAEI,mBAAA;IACA,UAAA;EhB88FN;AACF;AgB38FA;EACI;IAAG,YAAA;EhB88FL;EgB78FE;IAAK,YAAA;EhBg9FP;AACF;AiB5iGA;EACI,kCAAA;AjB8iGJ;AiB7iGI;EACI,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AjB+iGR;;AkBnjGQ;EACI,kCAAA;EACA,sCAAA;AlBsjGZ;AkBnjGY;EACI,qCAAA;AlBqjGhB;AkB9iGA;EACI,mBAAA;AlBgjGJ;;AmBngGA;EACC,wDAAA;EACA,+CAAA;AnBsgGD;;AmBjgGA;EACI,aAAA;EACA,eAAA;EACA,UAAA;EAEA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACH,8CAAA;EACA,iCAAA;AnBogGD;;AmB9/FA;EACI,aAAA;AnBigGJ;;AmB5/FC;EAAuC,YAAA;AnBggGxC;;AmB3/FA;EACC,WAAA;EACG,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AnB8/FJ;;AmB3/FA;EACI,eAAA;EACA,iBAAA;AnB8/FJ;AmB7/FI;EACI,UAAA;AnB+/FR;;AmB3/FA;EACI,wCAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;EACI,YAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;EACI,kCAAA;AnB8/FJ;;AmB3/FA;;;EAGI,6BAAA;AnB8/FJ;;AmB3/FA;;;EAGI,uBAAA;AnB8/FJ;;AmB3/FA;EACI,YAAA;AnB8/FJ;;AmB3/FA;EACI,kBAAA;EACA,WAAA;AnB8/FJ;;AmB3/FA;EACI,WAAA;AnB8/FJ;;AmB3/FA;;EAEI,WAAA;EAEA,iCAAA;AnB6/FJ;;AmB1/FA;EACI,WAAA;AnB6/FJ;AmB5/FI;EACI,iBAAA;EACA,gCAAA;EACA,sBAAA;EACA,sBAAA;EACA,UAAA;AnB8/FR;AmB5/FQ;EACI,aAAA;AnB8/FZ;AmB5/FQ;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,sCAAA;EACA,iCAAA;AnB8/FZ;AmB7/FY;EACI,2CAAA;AnB+/FhB;AmB7/FY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AnB+/FhB;AmB9/FgB;EACI,gBAAA;EACA,wBAAA;EACA,iBAAA;AnBggGpB;;AmBz/FA;EACI,gBAAA;EACA,wBAAA;EACA,iBAAA;AnB4/FJ;;AAttGA;EAEC,WAAA;EACG,aAAA;EACH,eAAA;AAwtGD;;AArtGA;EACC,YAAA;AAwtGD;;AAttGA;EACI,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,qCAAA;AAytGJ;;AArtGA;EAEI,yBAAA;AAutGJ;AArtGI;EACI,WAAA;AAutGR;;AAntGA;EACC,WAAA;AAstGD;;AAjtGA;EACC,mCAAA;EACA,kCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;AAotGD;AA9sGG;EACC,mBAAA;AAgtGJ;AArsGA;EACC,mBAAA;AAusGD;;AAnsGA;EACI,6BAAA;EACA,mCAAA;AAssGJ;AArsGI;EACI,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,qCAAA;AAusGR;AAtsGQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;AAwsGZ;AAtsGQ;EACI,mCAAA;EACA,oDAAA;AAwsGZ;AArsGI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;EACA,kBAAA;AAusGR;AAtsGQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAwsGZ;AAtsGQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAwsGZ;AArsGI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAusGR;AAtsGQ;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AAwsGZ;AAvsGY;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAysGhB;AAxsGgB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AA0sGpB;AAvsGY;EACI,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAysGhB;AAxsGgB;EACI,WAAA;EACA,cAAA;AA0sGpB;AAzsGoB;EAEI,gBAAA;AA0sGxB;AApsGI;EACI,uBAAA;AAssGR;AApsGI;EACI,UAAA;EACA,aAAA;AAssGR;AApsGI;EACI,aAAA;EACA,qBAAA;AAssGR;AArsGQ;EACI,kBAAA;AAusGZ;;AAhsGA;;;;;;;;;;;;;;;;;;;;EAAA;AA4BA;EACC;wBAAA;AA6rGD;;AAzrGA;EACC;IACC,kCAAA;IACA,iBAAA;EA4rGA;AACF","sourcesContent":["@use \"sass:map\";\n@use \"sass:color\";\n@use \"sass:math\";\n\n:root{\n    --primary-color: #0255A5;\n    --primary-color-rgb:2, 85, 165; // For RGBA methods - Make sure to match value with hex code\n    --primary-color-hover:#0F3B66;\n    --primary-color-opacity: rgba(2, 85, 165, 0.1);\n    --light-grey:#F9F9F9;\n    --light-grey-rgb:249, 249, 249; // For RGBA methods - Make sure to match value with hex code\n    --dark-grey:#9A9C9F;\n    --dark-grey-rgb:154, 156, 159; // For RGBA methods - Make sure to match value with hex code\n    --darkGrey:#1b232c;\n    --hover-bg-color:#E4E8EF;\n    --white-bg-hover:#e8eff2;\n    --light-blue:#6A80A9;\n    --purple:#675081;\n    --purple-rgb:103, 80, 129;// For RGBA methods - Make sure to match value with hex code\n    --textHighlightBgColor:rgba(191, 219, 253, 0.90);\n    --textHighlightFontColor:var(--primary-font-color);\n\n\n    //Fonts\n    --primary-font-color: var(--surface-500);\n    --primary-font-color-rgb: var(--surface-500-rgb);\n    --secondary-font-color: var(--surface-700);\n    --disabled-font-color:#828b97;\n    --font:\"Open Sans\", Arial, sans-serif;\n    --h1:24px;\n    --h2:18px;\n    --h3:16px;\n    --h4:13px;\n    --bodyFontSize:14px;\n    --tableFontSize:12px;\n    --pageTitleSize:var(--h1);\n    --sectionTitleSize:var(--h2);\n    --sectionSubTitleSize:var(--tableFontSize);\n    --sectionTitleLabel:var(--h3);\n    --accordionTitleSize:var(--sectionTitleSize);\n\n    //Borders\n    --border-color: var(--surface-100);\n    --darkBorderColor: var(--textHighlightFontColor);\n    --table-border-color:#E8EFF2;\n    --table-border-style:1px solid var(--table-border-color);\n    --border-style:1px solid var(--border-color);\n    --border-lg-radius:8px;\n    --border-m-radius:4px;\n    --border-m-radius-top:4px 4px 0px 0px;\n    --border-m-radius-bottom:0px 0px 4px 4px;\n    --border-sm-radius:2px;\n    --border-radius-tab:2px 2px 0px 0px;\n\n    //Text highlight colors\n    --selected-text:#E4E8EF;\n    --selected-bg:#E4E8EF;\n\n    --table-alt-row-color: var(--light-grey);\n\n    // Alert & Notification Colors\n    --alert-warning:#D6BA17;\n    --alert-warning-rgb:214, 186, 23; // For RGBA methods - Make sure to match value with hex code\n    --alert-warning-opacity: rgba(214, 186, 23, 0.10);\n    --alert-success:#02a570;\n    --alert-success-rgb:2, 165, 112;\n    --alert-success-opacity: rgba(2, 165, 112, 0.10);\n    --alert-info: var(--primary-color);\n    --alert-info-rgb: var(--primary-color-rgb); // For RGBA methods - Make sure to match value with hex code\n    --alert-info-opacity: rgba(2, 85, 165, 0.11);\n    --alert-danger:#E02222;\n    --alert-danger-rgb:224, 34, 34;\n    --alert-danger-opacity: rgba(224, 34, 34, 0.10);\n    --alert-danger-hover: #871a1a;\n    --alert-medium:#F97031;\n    --alert-medium-rgb:249, 112, 49; // For RGBA methods - Make sure to match value with hex code\n    --brown:#5b4434;\n    --notification-warning-bg:#FAF8E7;\n    --notification-info-bg:#E5EEF6;\n    --notification-error-bg:#FBE8E8;\n    --notification-success-bg:#E5F6F0;\n\n    //Shadows\n    --shadow-color:rgba(89,101,118,0.32);\n    --shadow-sm: 0 2px 5px 0 var(--shadow-color);\n    --shadow-md: 0 0px 10px 0 var(--shadow-color);\n    --shadow-md-top: 0 -5px 10px 5px var(--shadow-color);\n\n\n    // Misc\n    --accent: $primary-color !important;\n    --primary: $primary-color!important;\n    --series-a: $primary-color !important;\n\n    // System Colors\n    --primary-0:#ebf7ff;\n    --primary-0-rgb:235, 247, 255; // For RGBA methods - Make sure to match value with hex code\n    --primary-50:#a9d3ef;\n    --primary-100:#6fb2de;\n    --primary-100-rgb:111, 178, 222; // For RGBA methods - Make sure to match value with hex code\n    --primary-200:#4093cd;\n    --primary-300:#1c74ba;\n    --primary-300-rgb:28, 116, 186; // For RGBA methods - Make sure to match value with hex code\n    --primary-400:#0255A5;\n    --primary-500:#0046aa;\n    --primary-600:#0b399c;\n    --primary-700:#102669;\n    --primary-800:#08112d;\n    --primary-900:#070a16;\n\n    --white:#ffffff;\n    --white-rgb:255, 255, 255; // For RGBA methods - Make sure to match value with hex code\n    --surface-0: #fefefe;\n    --surface-50: #d7dfe5;\n    --surface-50-rgb:215, 223, 229; // For RGBA methods - Make sure to match value with hex code\n    --surface-100: #bac4cb;\n    --surface-100-rgb:186, 196, 203; // For RGBA methods - Make sure to match value with hex code\n    --surface-200: #9ea8b1;\n    --surface-200-rgb:158, 168, 177; // For RGBA methods - Make sure to match value with hex code\n    --surface-300: #828b97;\n    --surface-400: #666f7d;\n    --surface-500: #4B5363;\n    --surface-500-rgb:75, 83, 99; // For RGBA methods - Make sure to match value with hex code\n    --surface-600: #373d4f;\n    --surface-700: #25283a;\n    --surface-700-rgb:37, 40, 58; // For RGBA methods - Make sure to match value with hex code\n    --surface-800: #151726;\n    --surface-800-rgb:21, 23, 38; // For RGBA methods - Make sure to match value with hex code\n    --surface-900: #090912;\n\n    --size-0: 2px;\n    --size-50: 4px;\n    --size-100: 6px;\n    --size-200: 8px;\n    --size-300: 10px;\n    --size-400: 16px;\n    --size-500: 32px;\n    --size-600: 48px;\n    --size-700: 54px;\n    --size-800: 70px;\n    --size-900: 86px;\n\n\n    //Media Queries\n    --media-tablet-pro: 992px;\n    --media-tablet: var(--media-tablet-pro);\n    --media-mobile: 480px;\n    --media-min: 0px;\n\n    // Priority Colors\n    --priority-pm:var(--primary-color);\n    --priority-high:var(--alert-danger);\n    --priority-hot-parts: #059ea5;\n    --priority-warranty: #e035bf;\n    --priority-overtime-approval:var(--alert-warning);\n    --priority-normal:var(--alert-success);\n    --priority-special-equipment:#675081;\n    --priority-locked-scheduled:var(--secondary-font-color);\n\n    .zuggit-base{\n        --primary-color: #323283;\n\n        --primary-0: #f2f4ff;\n        --primary-0-rgb:242, 244, 255; // For RGBA methods - Make sure to match value with hex code\n        --primary-50: #c4c5f2;\n        --primary-100: #9b9be6;\n        --primary-100-rgb:155, 155, 230; // For RGBA methods - Make sure to match value with hex code\n        --primary-200: #7b7cd9;\n        --primary-300: #5a5acb;\n        --primary-300-rgb:90, 90, 203; // For RGBA methods - Make sure to match value with hex code\n        --primary-400: #323283;\n        --primary-500: #2a2a95;\n        --primary-600: #242484;\n        --primary-700: #1d1d63;\n        --primary-800: #141441;\n        --primary-900: #0c0c22;\n\n        --surface-0: #fbfaff;\n        --surface-50: #dcd9e4;\n        --surface-50-rgb:220, 217, 228; // For RGBA methods - Make sure to match value with hex code\n        --surface-100: #c1beca;\n        --surface-100-rgb:193, 190, 202; // For RGBA methods - Make sure to match value with hex code\n        --surface-200: #a6a3b1;\n        --surface-200-rgb:166, 163, 177; // For RGBA methods - Make sure to match value with hex code\n        --surface-300: #8b8798;\n        --surface-400: #716c80;\n        --surface-500: #585166;\n        --surface-500-rgb:88, 81, 102; // For RGBA methods - Make sure to match value with hex code\n        --surface-600: #423b4f;\n        --surface-700: #2e2938;\n        --surface-700-rgb:46, 41, 56; // For RGBA methods - Make sure to match value with hex code\n        --surface-800: #1c1824;\n        --surface-800-rgb:28, 24, 36; // For RGBA methods - Make sure to match value with hex code\n        --surface-900: #0d0a12;\n\n\n\n    }\n\n}\n\n.m{\n    &-0{margin: 0;}\n    &-1{margin: var(--size-100);}\n    &-2{margin: var(--size-200);}\n    &-3{margin: var(--size-300);}\n    &-4{margin: var(--size-400);}\n    &-5{margin: var(--size-500);}\n    &-6{margin: var(--size-600);}\n    &-7{margin: var(--size-700);}\n    &-8{margin: var(--size-800);}\n    &-9{margin: var(--size-900);}\n    &t{\n        &-0{margin-top: 0;}\n        &-1{margin-top: var(--size-100);}\n        &-2{margin-top: var(--size-200);}\n        &-3{margin-top: var(--size-300);}\n        &-4{margin-top: var(--size-400);}\n        &-5{margin-top: var(--size-500);}\n        &-6{margin-top: var(--size-600);}\n        &-7{margin-top: var(--size-700);}\n        &-8{margin-top: var(--size-800);}\n        &-9{margin-top: var(--size-900);}\n    }\n    &r{\n        &-0{margin-right: 0;}\n        &-1{margin-right: var(--size-100);}\n        &-2{margin-right: var(--size-200);}\n        &-3{margin-right: var(--size-300);}\n        &-4{margin-right: var(--size-400);}\n        &-5{margin-right: var(--size-500);}\n        &-6{margin-right: var(--size-600);}\n        &-7{margin-right: var(--size-700);}\n        &-8{margin-right: var(--size-800);}\n        &-9{margin-right: var(--size-900);}\n    }\n    &b{\n        &-0{margin-bottom: 0;}\n        &-1{margin-bottom: var(--size-100);}\n        &-2{margin-bottom: var(--size-200);}\n        &-3{margin-bottom: var(--size-300);}\n        &-4{margin-bottom: var(--size-400);}\n        &-5{margin-bottom: var(--size-500);}\n        &-6{margin-bottom: var(--size-600);}\n        &-7{margin-bottom: var(--size-700);}\n        &-8{margin-bottom: var(--size-800);}\n        &-9{margin-bottom: var(--size-900);}\n    }\n    &l{\n    &-0{margin-left: 0;}\n    &-1{margin-left: var(--size-100);}\n    &-2{margin-left: var(--size-200);}\n    &-3{margin-left: var(--size-300);}\n    &-4{margin-left: var(--size-400);}\n    &-5{margin-left: var(--size-500);}\n    &-6{margin-left: var(--size-600);}\n    &-7{margin-left: var(--size-700);}\n    &-8{margin-left: var(--size-800);}\n    &-9{margin-left: var(--size-900);}\n    }\n}\n.p{\n    &-0{padding: 0;}\n    &-1{padding: var(--size-100);}\n    &-2{padding: var(--size-200);}\n    &-3{padding: var(--size-300);}\n    &-4{padding: var(--size-400);}\n    &-5{padding: var(--size-500);}\n    &-6{padding: var(--size-600);}\n    &-7{padding: var(--size-700);}\n    &-8{padding: var(--size-800);}\n    &-9{padding: var(--size-900);}\n    &t{\n        &-0{padding-top: 0;}\n        &-1{padding-top: var(--size-100);}\n        &-2{padding-top: var(--size-200);}\n        &-3{padding-top: var(--size-300);}\n        &-4{padding-top: var(--size-400);}\n        &-5{padding-top: var(--size-500);}\n        &-6{padding-top: var(--size-600);}\n        &-7{padding-top: var(--size-700);}\n        &-8{padding-top: var(--size-800);}\n        &-9{padding-top: var(--size-900);}\n    }\n    &r{\n        &-0{padding-right: 0;}\n        &-1{padding-right: var(--size-100);}\n        &-2{padding-right: var(--size-200);}\n        &-3{padding-right: var(--size-300);}\n        &-4{padding-right: var(--size-400);}\n        &-5{padding-right: var(--size-500);}\n        &-6{padding-right: var(--size-600);}\n        &-7{padding-right: var(--size-700);}\n        &-8{padding-right: var(--size-800);}\n        &-9{padding-right: var(--size-900);}\n    }\n    &b{\n        &-0{padding-bottom: 0;}\n        &-1{padding-bottom: var(--size-100);}\n        &-2{padding-bottom: var(--size-200);}\n        &-3{padding-bottom: var(--size-300);}\n        &-4{padding-bottom: var(--size-400);}\n        &-5{padding-bottom: var(--size-500);}\n        &-6{padding-bottom: var(--size-600);}\n        &-7{padding-bottom: var(--size-700);}\n        &-8{padding-bottom: var(--size-800);}\n        &-9{padding-bottom: var(--size-900);}\n    }\n    &l{\n        &-0{padding-left: 0;}\n        &-1{padding-left: var(--size-100);}\n        &-2{padding-left: var(--size-200);}\n        &-3{padding-left: var(--size-300);}\n        &-4{padding-left: var(--size-400);}\n        &-5{padding-left: var(--size-500);}\n        &-6{padding-left: var(--size-600);}\n        &-7{padding-left: var(--size-700);}\n        &-8{padding-left: var(--size-800);}\n        &-9{padding-left: var(--size-900);}\n    }\n}\n\n$primaryColor:#0255A5;\n$primaryFontColor:#4B5363;\n$white: #ffffff;\n\n//DarkMode\n$primaryDM: #2A2E3A;\n$primaryFontColorDM: #eeeeee;\n\n$colors: (\n        blue: (\n                base: $primaryColor,\n                0: #ebf7ff,\n                10: #a9d3ef,\n                20: #6fb2de,\n                30: #4093cd,\n                40: #1c74ba,\n                50: $primaryColor,\n                60: #0046aa,\n                70: #0b399c,\n                80: #102669,\n                90: #08112d,\n                100: #070a16,\n        ),\n        neutral: (\n                base: $primaryFontColor,\n                0: #fefefe,\n                10: #d7dfe5,\n                20: #bac4cb,\n                30: #9ea8b1,\n                40: #828b97,\n                50: #666f7d,\n                60: $primaryFontColor,\n                70: #373d4f,\n                80: #25283a,\n                90: #151726,\n                100: #090912,\n        ),\n        primary: (\n                base: $primaryColor,\n                light: color.scale($primaryColor, $lightness: 15%),\n                dark: color.scale($primaryColor, $blackness: 30%),\n                disabled: color.scale($primaryColor, $saturation: -90%, $lightness: 60%),\n                darkMode:$primaryDM,\n        ),\n        white: (\n                base:var(--white),\n                hover: color.scale($primaryColor, $lightness: 80%, $saturation: -82%),\n                dark: color.scale($white, $blackness: 30%),\n\n        ),\n        font:(\n                base: $primaryFontColor,\n                secondary: color.scale($primaryFontColor, $blackness: 30%),\n                disabled: color.scale($primaryFontColor, $saturation: -10%, $lightness: 20%),\n                darkMode:$primaryFontColorDM,\n        )\n);\n\n$shadow: 0 0px 10px 0 #151726;\n\n\n$fonts: (\n        \"Helvetica\": (\n                \"weights\": (\n                        \"regular\": 400,\n                        \"medium\": 500,\n                        \"bold\": 700\n                )\n        )\n);\n\n@function get-color($color, $shade: base) {\n    @return map.get(map.get($colors, $color), $shade);\n}\n\n\n\n\n///////////////////////////////////////////\n// DEPRECATED DO NOT USE THESE VARIABLES //\n///////////////////////////////////////////\n\n\n// Climate Pros Font Colors\n$primary-font-color:#1b232c; //\n$secondary-font-color:#4B5363;//\n$disabled-font-color:#8A939D;//\n$light-grey:#F9F9F9;//\n$dark-grey:#9A9C9F;//\n//var(--white):#ffffff;\n\n// Climate Pros Colors\n$primary-color:#0255A5;\n$primary-color-hover:#0F3B66;\n$primary-color-opacity:rgba(2, 85, 165, 0.1);\n$darkgrey:var(--secondary-font-color);\n$hover-bg-color:#E4E8EF;\n$white-bg-hover:#e8eff2;\n$light-blue:#6A80A9;\n$purple:#675081;\n$textHighlightBgColor:rgba(#BFDBFD, 0.90);\n$textHighlightFontColor:var(--secondary-font-color);\n\n\n// CP Borders\n//var(--border-color): #D5DDE2;\n$border-color: #bac4cb;\n$darkBorderColor: var(--textHighlightFontColor);\n$table-border-color:#E8EFF2;\n$table-border-style:1px solid var(--table-border-color);\n$border-style:1px solid var(--border-color);\n//var(--border-style):1px solid var(--border-color);var(--surface-0)\n$border-lg-radius:8px;\n$border-m-radius:4px;\n$border-m-radius-top:4px 4px 0px 0px;\n$border-m-radius-bottom:0px 0px 4px 4px;\n$border-sm-radius:2px;\n$border-radius-tab:2px 2px 0px 0px;\n\n$selected-text:#E4E8EF;\n$selected-bg:#E4E8EF;\n\n$table-alt:var(--light-grey);\n\n// Alert Colors\n$alert-warning:#D6BA17;\n$alert-warning-opacity: rgba(214, 186, 23, 0.10);\n$alert-success:#02a570;\n$alert-success-opacity: rgba(2, 165, 112, 0.10);\n$alert-info:var(--primary-color);\n$alert-info-opacity: rgba(2, 85, 165, 0.11);\n$alert-danger:#E02222;\n$alert-danger-opacity: rgba(224, 34, 34, 0.10);\n$alert-danger-hover: #871a1a;\n$alert-medium:#F97031;\n$brown:#5b4434;\n\n$notification-warning-bg:#FAF8E7;\n$notification-info-bg:#E5EEF6;\n$notification-error-bg:#FBE8E8;\n$notification-success-bg:#E5F6F0;\n\n\n//Shadows\n$shadow-color:rgba(89,101,118,0.32);\n$shadow-sm: 0 2px 5px 0 var(--shadow-color);\n$shadow-md: 0 0px 10px 0 var(--shadow-color);\n$shadow-md-top: 0 -5px 10px 5px var(--shadow-color);\n\n//Fonts\n$font:\"Open Sans\", Arial, sans-serif;\n$h1:24px;\n$h2:18px;\n$h3:16px;\n$h4:13px;\n$bodyFontSize:14px;\n$tableFontSize:12px;\n$pageTitleSize:var(--h1);\n$sectionTitleSize:var(--h2);\n$sectionSubTitleSize:var(--tableFontSize);\n$sectionTitleLabel:var(--h3);\n$accordionTitleSize:var(--sectionTitleSize);\n/*%pageTitleFont{\n    font-size:$pageTitleSize;\n    font-weight:800;\n}\n%sectionTitleFont{\n    font-size:var(--sectionTitleSize);\n    font-weight:800;\n}\n%sectionSubTitleFont{\n    font-size:var(--sectionSubTitleSize);\n    font-weight:400;\n}*/\n\n\n//Prioritys\n$priority-pm:var(--primary-color);\n$priority-high:var(--alert-danger);\n$priority-hot-parts: #059ea5;\n$priority-warranty: #e035bf;\n$priority-overtime-approval:var(--alert-warning);\n$priority-normal:var(--alert-success);\n$priority-special-equipment:#675081;\n$priority-locked-scheduled:var(--secondary-font-color);\n\n//Spacing\n$fullSpacing:30px;\n$halfSpacing:calc($fullSpacing/2);\n$quarterSpacing:calc($fullSpacing/4);\n\n\n//Media Queries\n$mediaTabletPro: 992px;\n$mediaTablet: $mediaTabletPro;\n$mediaMobile: 480px;\n$mediaMin: 0px;\n\n/* chart \nbuttons\ndate input\ndialogs\ndropdowns\niputs\ngrid\nlabel\nlayout\ntab strip\nbound bar\nmenues\npopup\nscroll view\ntoolbar\ntool tip\neditor */\n\n\n////////////////////\n//Dark Mode Colors//\n////////////////////\n$darkModeAppBg:#22252A;\n$darkModeBg1:#2A2E3A;\n$darkModeBg2:#2A2E36;\n$darkModeBg3:#15161a;\n$darkModeBorderColor:#484D5A;\n$darkModeOutlineBtnBg:#262A31;\n$darkModeInputBg:$darkModeBg1;\n$darkModePrimaryFontColor:#eeeeee;\n$darkModeSecondaryFontColor:var(--white);\n$darkModeDisabledFontColor:rgba($darkModePrimaryFontColor, .4);\n$darkModeDrawerBg:#15191d;\n\n\n\n\n// FUNCTIONS\n$browser-context: 16; // Default\n\n@function em($pixels, $context: $browser-context) {\n    @return #{$pixels/$context}em;\n}\n","@use \"./src/assets/scss/cp-kendo.scss\";\n@use \"./src/assets/scss/cp-variables.scss\" as *;\n\n.cp-row{\n\t//might need to add to global styles\n\tmargin:0px;\n    display:flex;\n\tflex-wrap: wrap;\n}\n\n.has-secondary-tabs .cp-no-padding .k-content{\n\tpadding:0px;\n}\n.highLightSave {\n    border-width: 3px !important;\n    border-color: var(--alert-danger);\n    border-style:solid;\n    border-radius: var(--border-m-radius);\n\n}\n// Test example\n.mat-expansion-panel {\n    // margin:30px;\n    background-color: #ffffff;\n\n    .cp-primary-tabs .k-content {\n        border: 0px;\n    }\n}\n\n.dqoi-transaction-btn{\n\twidth:100%;\n}\n\n\n// DQOI Search, MAY CHANGE\n.dqoi-ribbon{\n\tbackground-color:var(--light-grey);\n\tborder-bottom:var(--border-style);\n\twidth: 100%;\n\tmargin:0px;\n\theight:60px;\n\tpadding: 12px;\n\tflex-direction: row;\n\tjustify-content: flex-start;\n\tmargin:0 -1px;\n\t\n\t.dqoi-search-wrap{\n\n\t\t.dqoi-search{\n\t\t\t\n\t\t\t.dqoi-search-bar{\n\t\t\t\tmargin-right:-13px;\n\t\t\t}\n\t\t}\n\n\t\t.k-button-group{\n\t\t}\n\t}\n\t\n\t\n}\n\n.dqoi-accordion{\n\tmargin-bottom:30px;\n}\n\n\n.dqoi-expansion-panel{\n    margin-bottom:0px !important;\n    border-bottom-width: 0px !important;\n    .dqoi-logo{\n        min-height:50px;\n        min-width:50px;\n        height:50px;\n        width:50px;\n        overflow: hidden;\n        margin-left: 30px;\n        border-radius:var(--border-m-radius);\n        img{\n            width:100%;\n            height:100%;\n            object-fit: contain;\n            background-color:#ffffff;\n        }\n        .no-logo{\n            background-color: var(--light-grey);\n            box-shadow: inset 0px 0px 0px 1px var(--surface-100);\n        }\n    }\n    .dqoi-panel-customer-info{\n        max-width:326px;\n        width:100%;\n        display:flex;\n        flex-direction: column;\n        flex-wrap: nowrap;\n        padding-right:20px;\n        margin: 0px 13px 0px 20px;\n        border-right:var(--border-style);\n        align-self: center;\n        #customer-name{\n            font-size: 16px;\n            font-weight: 700;\n            max-width: 326px;\n            height: 20px;\n            line-height: 20px;\n            color:var(--primary-font-color);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n        #customer-location{\n            font-size:14px;\n            font-weight:400;\n            max-width: 326px;\n            height:20px;\n            line-height:20px;\n            color:var(--primary-font-color);\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n    .dqoi-panel-dqoi-info-wrap {\n        display: flex;\n        flex-flow: row wrap;\n        width: 100%;\n        .dqoi-panel-dqoi-info {\n            flex-grow:1;\n            margin: 0px 13px;\n            max-width: 200px;\n            .dqoi-label {\n                font-weight: 600;\n                font-size: 13px;\n                width: 100%;\n                height: 18px;\n                line-height: 18px;\n                .dqoi-panel-priority {\n                    width: 8px;\n                    height: 8px;\n                    border-radius: 50%;\n                    line-height: 18px;\n                    top: -13px;\n                    position: relative;\n                    left: 50px;\n                }\n            }\n            .dqoi-info {\n                color:var(--primary-font-color);\n                font-weight: 500;\n                font-size: 14px;\n                width: 100%;\n                height: 20px;\n                line-height: 20px;\n                span{\n                    width:100%;\n                    display: block;\n                    &:first-child{\n                        //margin-right:10px;\n                        font-weight: 600;\n                    }\n                }\n            }\n        }\n    }\n    .mat-expansion-panel-body{\n        padding:0px !important;\n    }\n    .mat-expansion-panel-header-title{\n        width:95%;\n        display: flex;\n    }\n    .dqoi-panel-controls{\n        display: flex;\n        flex-flow: row nowrap;\n        cp-loader{\n            margin-right: 20px;\n        }\n    }\n}\n\n\n\n/*.dqoi-expansion-panel{\n\tmargin-bottom:0px !important;\n\t\n\t.dqoi-logo{\n\t\theight:40px;\n\t\twidth:40px;\n\t\tposition: relative;\n\t\tmargin-left:20px;\n\t\tborder-radius:var(--border-m-radius);\n\t\t\t\n\t\timg {\n\t\t\tobject-fit: cover;\n\t\t\twidth: 40px;\n\t\t\theight: 40px;\n\t\t}\n\t}\n\t\n\t.mat-expansion-panel-body{\n\t\tpadding:0px !important;\n\t}\n}*/\n\n.reason{\n\ttextarea{\n\t\t//height:300px;\n\t}\n}\n\n.dispatch-notes .k-grid{\n\t/*height: 300px;\n    max-height: 300px;*/\n}\n\n@media only screen and (max-width: 1200px) {\n\t.cp-dqoi-sidebar{\n\t\tborder-bottom:var(--border-style);\n\t\tborder-right:0px;\n\t}\n}\n","@use \"/src/assets/scss/cp-variables.scss\";\n// Default Blue ToolTip\n.k-animation-container{\n\t.k-tooltip{\n\t\tbox-shadow: var(--shadow-sm);\n\t\tcolor: #ffffff;\n\t\tborder:var(--border-style);\n\t\tborder-radius:var(--border-m-radius);\n\t\tborder-width:0px;\n\t\tbackground-color: var(--primary-color);\n\t\tpadding: 10px;\n\t\tline-height: 1.6em;\n\t\t&:not(.k-tooltip-closable){\n\t\t\tfont-size: 12px;\n\t\t}\n\t\t.k-tooltip-content{\n            max-width:800px;\n        }\n\t\t.k-callout{\n\t\t\tposition: absolute;\n\t\t\twidth: 16px;\n\t\t\theight: 8px;\n\t\t\toverflow: hidden;\n\t\t\tborder-width: 0px;\n\t\t\t&:after{\n\t\t\t\tcontent: '';\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 8px;\n\t\t\t\theight: 8px;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%,50%) rotate(45deg);\n\t\t\t\tbackground-color: var(--primary-color);\n\t\t\t\tborder: var(--border-style);\n\t\t\t\tbox-shadow:var(--shadow-sm);\n\t\t\t\tborder-width:0px;\n\t\t\t}\n            &.k-callout-n{\n                top:-7px !important;\n            }\n            &.k-callout-s{\n                bottom:-7px;\n                transform: rotateX(180deg) !important;\n            }\n\t\t}\n\t}\n}\n.k-callout-n {\n    margin-left: -8px;\n    top: -8px !important;\n\tbottom: -8px !important;\n}\n// Alt ToolTip Styles\n.k-animation-container{\n\t// Light(white) ToolTip\n\t&.cp-light-tooltip, &.cp-light-tooltip-no-padding{\n\t\t.k-tooltip{\n\t\tcolor: var(--primary-font-color);\n\t\tborder:var(--border-style);\n\t\tborder-width:0px;\n\t\tbackground-color: #ffffff;\n\t\t\t.k-callout{\n\t\t\t\tborder: none;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: #ffffff;\n\t\t\t\t\tborder: var(--border-style);\n\t\t\t\t\tbox-shadow:var(--shadow-sm);\n\t\t\t\t\tborder-width:0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t// Dark (grey) ToolTip\n\t&.cp-dark-tooltip, &.cp-dark-tooltip-no-padding{\n\t\t.k-tooltip{\n\t\t\tcolor: #ffffff;\n\t\t\tborder:var(--border-style);\n\t\t\tborder-width:0px;\n\t\t\tbackground-color: var(--secondary-font-color);\n\t\t\t.k-callout{\n\t\t\t\tborder: none;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: var(--secondary-font-color);\n\t\t\t\t\tborder: var(--border-style);\n\t\t\t\t\tbox-shadow:var(--shadow-sm);\n\t\t\t\t\tborder-width:0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n    // Alert (red) ToolTip\n    &.cp-alert-tooltip, &.cp-alert-tooltip-no-padding{\n        .k-tooltip{\n            color: #ffffff;\n            //border:var(--border-style);\n            border-width:0px;\n            background-color: var(--alert-danger);\n            .k-callout{\n                border: none;\n                &:after{\n                    background-color: var(--alert-danger);\n                    border: var(--alert-danger);\n                    box-shadow:var(--shadow-sm);\n                    border-width:0px;\n                }\n            }\n        }\n    }\n}\n.cp-light-tooltip-no-padding .k-tooltip{padding: 0px;}\n.cp-dark-tooltip-no-padding .k-tooltip{padding: 0px;}\n.k-popup{\n\t&.cp-light-popup{\n\t\tborder-color: #ffffff;\n\t\tbackground: #ffffff;\n        &.alert{\n            border-color: var(--alert-danger);\n            color:var(--alert-danger);\n        }\n\t}\n\t&.cp-dark-popup{\n\t\tborder-color: var(--primary-400);\n        background: var(--primary-400);\n\t\tcolor: var(--surface-0);\n\t}\n    &.padding15{padding: 15px}\n    &.width300{width:300px;}\n    &.small{\n        border-radius:0.25rem;\n        font-size:0.625rem;\n        padding:0.25rem;\n    }\n    &.copyFieldPopUp{\n        margin-top:4px;\n    }\n}\n\n.k-item i {\n    margin-right: 10px;\n}\n","@use '/src/assets/scss/cp-variables' as *;\n\n.cp-input-container{\n    width: 100%;\n    &.withButton{\n        width: 100%;\n        .k-textbox, .k-dropdown, .k-combobox, .k-numerictextbox, .k-picker{\n            width:calc(100% - 34px);\n            height: 30px;\n        }\n        .k-button{\n            width:34px;\n            height:30px;\n        }\n    }\n    &.dqoiItemSelection{\n        flex-flow: row wrap;\n        .cp-label{width:100%;}\n        &.twoButtons{\n            .k-textbox, .k-dropdown{\n                width: calc(100% - 69px);\n                margin-right: -1px;\n            }\n        }\n        .k-textbox, .k-dropdown, .k-combobox{\n            width: calc(100% - 35px);\n            margin-right: -1px;\n        }\n        .k-button{\n            width:34px;\n            height:30px;\n        }\n        &.multiItem{\n            .cp-list-button-dropdown{\n                transform: scale(1);\n                background: var(--primary-color);\n                box-shadow: 0 0 0 0 var(--primary-color);\n                animation: pulse-blue 2s 10;\n            }\n        }\n    }\n    &.excededValue {\n        input {\n            color: var(--alert-danger) !important;\n        }\n    }\n}\n\n\n\n.k-input, .k-picker-wrap, .k-numeric-wrap, .k-dropdown-wrap, .k-textbox, .k-textarea, .k-popup, .k-combobox, .k-datepicker, .k-multiselect, .k-numerictextbox, .k-picker, .k-dropdownlist {\n    &.ng-invalid:not(form), &:required {\n        border-color: var(--alert-danger) !important;\n        .k-dropdown-wrap {\n            border-color: var(--alert-danger) !important;\n        }\n    }\n    &.ng-valid:not(form) & & {\n    }\n    &.ng-valid:not(form){\n        border-color: var(--border-color) !important;\n        &.k-datetimepicker.required{\n            border-color: var(--alert-danger) !important;\n        }\n    }\n    &.k-readonly{\n        color:var(--surface-400);\n        .k-input-inner{\n            background:rgba( var(--surface-50-rgb), 0.4) !important;\n        }\n    }\n}\n\n.requiredInput, .requiredInput .p-search-window-launcher {\n    .cp-label {\n        color: var(--alert-danger) !important;\n    }\n\n    &.validInput {\n        .cp-label {\n            color: var(--secondary-font-color) !important;\n        }\n    }\n}\n\n.in-finance {\n    .k-input, .k-dropdownlist, .k-picker, .k-combobox, .k-checkbox {\n        border-color: var(--alert-success);\n        box-shadow: 0px 0px 0 1px rgba(2,165,112,0.2);\n    }\n}\n\n.cp-label{\n    margin:0;\n    font-size:0.75rem;\n    font-weight:500;\n    color: var(--secondary-font-color);\n    width:100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: -0.3em;\n    position:relative;\n    .characterCount{\n        font-size:0.75rem;\n        color:var(--alert-danger);\n        position:absolute;\n        display:flex;\n        justify-content:flex-end;\n        align-items:center;\n        top:0;\n        height:100%;\n        right:1rem;\n        padding:0;\n        outline:none;\n        border:none;\n        background:transparent;\n    }\n    .additionalLabelInfo{\n        font-size:0.75rem;\n        position:absolute;\n        display:flex;\n        justify-content:flex-end;\n        align-items:center;\n        top:0;\n        height:100%;\n        right:0;\n        padding:0;\n        outline:none;\n        border:none;\n        background:transparent;\n        i{\n            margin-left:0.5rem;\n        }\n    }\n}\n\n%sharedInput{\n    border:1px solid var(--surface-100);\n    color:var(--primary-font-color);\n    .k-input-button, .k-input-spinner{\n        border-width: 0 !important;\n        border:none !important;\n        background:var(--white);\n    }\n    .k-input-inner{background:var(--white);}\n    &:focus-within, &:focus, .k-focus{\n        border-color:var(--surface-200);\n        box-shadow: none;\n        color:var(--primary-font-color);\n    }\n    &:hover{\n        border-color:var(--surface-200);\n        box-shadow: none;\n        color:var(--primary-font-color);\n    }\n    .k-input-values{\n        flex-flow: row nowrap;\n    }\n}\n\n%readOnly{\n    &.read-only{\n        color:var(--surface-400);\n        background:rgba( var(--surface-50-rgb), 0.4) !important;\n        cursor:default;\n        &:focus, &:focus-within, &.k-state-focus, &.k-state-focused{\n            color:var(--surface-400);\n            background:rgba( var(--surface-50-rgb), 0.4);\n            cursor:default;\n        }\n        &:hover,{\n            border:1px solid var(--surface-100);\n        }\n        .k-searchbar .k-input-inner{\n            color:var(--surface-400);\n            background:rgba( var(--surface-50-rgb), 0.4) !important;\n        }\n        .k-button{\n            &.k-button-outline, &:hover{\n                background:rgba( var(--surface-50-rgb), 0.4) !important;\n            }\n        }\n    }\n}\ninput.k-input, textarea.k-textarea, .k-input-md .k-input-inner, .k-picker-md .k-input-inner {\n    padding-inline: 0.4em;\n}\n\n.k-input, .k-dropdownlist, .k-picker, .k-combobox{\n    @extend %sharedInput;\n    @extend %readOnly;\n    &.k-input-solid, &.k-picker-solid{\n    }\n    &.k-input-outline, &.k-picker-outline{\n        &:hover{background:transparent;}\n    }\n    &.cp-list-button-dropdown {\n        width:36px !important;\n        height:30px;\n        .k-input-inner{\n            display: none;\n        }\n        .k-input-button{\n            padding: 10px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width:auto;\n            border-radius: var(--border-sm-radius);\n            border-color: var(--border-color);\n            &:hover{\n                background-color:var(--table-border-color);\n            }\n            .k-icon {\n                width:auto;\n                height:auto;\n                line-height:auto;\n                &:before {\n                    content: \"\\f03a\";\n                    font-family: FontAwesome;\n                    font-size: 1.75em;\n                }\n            }\n        }\n    }\n}\n\n.k-picker{\n    height:30px;\n}\n\n.k-popup {\n    border-color: var(--surface-100);\n    color: var(--primary-font-color);\n    background-color: var(--white);\n    box-shadow: 0 2px 4px 0 rgba( var(--surface-700-rgb), 0.03), 0 4px 5px 0 rgba( var(--surface-700-rgb), 0.04);\n    margin: 0;\n    padding: 0;\n    border-width: 1px;\n    border-style: solid;\n    box-sizing: border-box;\n    font-size: 1em;\n    line-height: 1.4285714286;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    .k-menu-group .k-item>.k-link:active{\n        background-color: var(--primary-color);\n    }\n    .k-list-item{\n        //border-bottom:var(--border-style);\n        //padding:6px 8px;\n        color:var(--primary-font-color);\n        &:hover{\n            background:var(--primary-0);\n            &.k-selected{\n                background:var(--surface-100);\n                color:var(--surface-900);\n            }\n        }\n        &.k-selected{\n            background:var(--surface-50);\n        }\n        &.k-focused{\n            background:var(--surface-50);\n            box-shadow:none;\n        }\n    }\n    .tableLegend &{\n        padding:15px;\n        background-color:var(--white);\n        border: var(--border-style);\n        border-radius: var(--border-sm-radius);\n        display: flex;\n        flex-flow: row wrap;\n        margin:10px 30px;\n        z-index: 100;\n        box-shadow: var(--shadow-md);\n    }\n    .filters-popup &{\n        border-radius: var(--border-m-radius);\n        box-shadow: var(--shadow-md);\n        border-bottom: var(--border-style);\n        background-color: #ffffff;\n        padding:16px;\n        width:320px;\n    }\n    .two-columns.filters-popup &{\n        width:480px;\n    }\n}\n.k-timeselector{\n    border-color:none;\n    color:var(--primary-font-color);\n    .k-time-header, .k-time-selector-header{\n        .k-time-now{\n            &:hover{\n                background:var(--surface-50);\n                color:var(--primary-font-color);\n            }\n        }\n    }\n    .k-time-highlight{\n        background:var(--white);\n    }\n    .k-time-list-wrapper{\n        &.k-focus{\n            background:var(--surface-0);\n        }\n        .k-title{\n            color:var(--primary-font-color);\n        }\n        .k-time-list{\n            .k-item{\n                cursor:pointer;\n                &:hover{\n                    color:var(--primary-600);\n                }\n            }\n        }\n    }\n}\n\n.k-calendar .k-content .k-state-selected.k-today .k-link, .k-calendar .k-state-selected .k-link{\n    border-color:var(--primary-color);\n    color:var(--white);\n    background-color:var(--primary-color);\n}\n\n.dqoi-search-input{\n    .k-animation-container{\n        .k-popup, .cpdiSearch{\n            #mainGrid{\n                .k-grid-norecords, .k-grid-container{\n                    .k-table-td{\n                    }\n                }\n                &:has(.k-loading-mask){\n                    .k-grid-norecords, .k-grid-container{\n                        min-height:40px;\n                    }\n                }\n                .noRecords{\n                    min-height: 100px;\n                    display: flex;\n                    font-size: 1rem;\n                    justify-content: center;\n                    align-items: center;\n                }\n            }\n            .k-list{display:none;}\n            .k-no-data{display:none;}\n        }\n    }\n}\n","@use '/src/assets/scss/cp-variables' as *;\n\n%button-shared{\n\tfont-weight:400;\n    color:var(--primary-font-color);\n    transition:background .1s ease-in-out;\n    box-shadow:none;\n}\n\n%loadingButton{\n    display:flex;\n    justify-content:center;\n    align-items:center;\n    cursor:default;\n    &:before{\n        content:'';\n        display:block;\n        box-sizing:border-box;\n        position:relative;\n        background-color:transparent;\n        width:1.125em;\n        height:1.125em;\n        margin-right:0.4em;\n        opacity:1;\n        transition:opacity .2s ease-in-out;\n        border:2px solid var(--surface-0);\n        border-radius:50%;\n        border-right-color:transparent;\n        border-top-color:transparent;\n        animation:spin-animation 400ms infinite linear;\n    }\n}\n\n.cp-input-container{\n    .k-button:is(:only-child){width:100%;}\n}\n\n.k-button{\n    @extend %button-shared;\n    &.k-button-solid{\n        color:var(--surface-0);\n        background:var(--primary-color);\n        border-color:var(--primary-color);\n        .k-icon{color:var(--surface-0);}\n        &:hover, &.k-hover, &:focus, &.k-focus{\n            background:var(--primary-600);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &:active, &.k-active{\n            background:var(--primary-300);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &:focus{\n            box-shadow:0 0 0 2px rgba(var(--primary-300), 0.5);\n        }\n        &.k-disabled{\n            color:var(--disabled-font-color);\n            background:var(--surface-50);\n            font-style:italic;\n            cursor:default;\n            border-color:var(--surface-50);\n            @media (prefers-color-scheme:dark){\n            }\n            &:hover{\n                background:var(--surface-100) !important;\n            }\n        }\n        &.k-loading{\n            @extend %loadingButton;\n            &:hover{\n                background:var(--primary-color) !important;\n            }\n        }\n    }\n    &.k-button-flat{\n        color:var(--primary-font-color);\n        background:none;\n        .k-icon{color:var(--primary-font-color);}\n        &:hover, &.k-hover, &:focus, &.k-focus{\n            background:var(--surface-50);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &:active, &.k-active{\n            color: var(--secondary-font-color);\n            background:var(--surface-50);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &.k-disabled{\n            color:var(--disabled-font-color);\n            font-style:italic;\n            cursor:default;\n            @media (prefers-color-scheme:dark){\n            }\n            &:hover{\n                background:none !important;\n            }\n        }\n        &.k-loading{\n            @extend %loadingButton;\n            &:before{\n                border-left-color: var(--surface-500);\n                border-bottom-color: var(--surface-500);\n            }\n        }\n        &-inverse{\n            color: var(--surface-0);\n        }\n    }\n    &.k-button-outline{\n        color:var(--primary-font-color);\n        background:var(--white);\n        border:1px solid var(--surface-100);\n        .k-icon{color:var(--primary-font-color);}\n        &:hover, &.k-hover, &:focus, &.k-focus{\n            background:var(--surface-50);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &:active, &.k-active{\n            color:var(--primary-font-color);\n            background:var(--surface-50);\n            border-color:var(--surface-100);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &:focus{\n            box-shadow:0 0 0 2px rgba( var(--primary-0-rgb), 0.5);\n        }\n        &.k-selected{\n            background:var(--primary-color);\n            color:var(--white);\n        }\n        &.k-disabled{\n            background:none;\n            color:var(--disabled-font-color);\n            font-style:italic;\n            cursor:default;\n            @media (prefers-color-scheme:dark){\n            }\n            &:hover{\n                background:none !important;\n            }\n        }\n        &.k-loading{\n            @extend %loadingButton;\n            &:before{\n                border-left-color: var(--surface-500);\n                border-bottom-color: var(--surface-500);\n            }\n        }\n        &-light{\n            color:var(--surface-0);\n            background:transparent;\n            border:var(--border-style);\n            &:hover, &.k-hover, &:focus, &.k-focus{\n                background:var(--border-color);\n                color:var(--primary-font-color);\n                @media (prefers-color-scheme:dark){\n                }\n            }\n        }\n        &.buttonError{\n            border:1px solid var(--alert-danger);\n            position:relative;\n            .k-icon{color: var(--alert-danger);}\n            &::after{\n                content:\"\";\n                display: inline-block;\n                width: 0.75rem;\n                height: 0.75rem;\n                border-radius: 100%;\n                position:absolute;\n                z-index:100;\n                left:unset;\n                opacity:100;\n                background:var(--alert-danger);\n                top:-0.375rem;\n                right:-0.375rem;\n            }\n        }\n    }\n    .k-spin-button &, .k-picker-outline &{\n        background:var(--white);\n        border-color:var(--surface-100);\n        &:hover, &.k-hover, &:focus, &.k-focus{\n            background:var(--surface-50);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &:active, &.k-active{\n            color:var(--surface-0);\n            background:var(--surface-50);\n            border-color:var(--surface-100);\n            @media (prefers-color-scheme:dark){\n            }\n        }\n        &.k-disabled{\n            background:none;\n            color:var(--disabled-font-color);\n            font-style:italic;\n            cursor:default;\n            @media (prefers-color-scheme:dark){\n            }\n            &:hover{\n                background:none !important;\n            }\n        }\n        .k-icon{\n            color:var(--primary-font-color);\n        }\n    }\n    .k-button-text{\n        /*&:first-child{margin-left:0.4em;}\n        &:only-child{margin:0;}*/\n        &:not(:only-child){\n            margin-left:0.4em;\n            &:empty{\n                margin-left:0em;\n            }\n        }\n    }\n    &.k-button-sm{\n        //font-size: 0.625em;\n        font-size: 1em;\n    }\n    &.k-button-md{\n        font-size:0.75rem;\n        line-height: 1.667;\n    }\n    &.k-button-lg{font-size:0.875rem;}\n}\n\n.k-button-group{\n    .cp-input-container &{\n        width:100%;\n        .k-button{flex-grow: 1;}\n    }\n}\n\n@keyframes spin-animation{\n    from{ transform:rotate(0deg); }\n    to{ transform:rotate(360deg); }\n}\n","@use '/src/assets/scss/cp-variables' as *;\n\n.k-grid{\n    color:var(--primary-font-color);\n    font-size:0.75rem;\n    border-color: var(--surface-50);\n    a{\n        color:var(--primary-color);\n        &:focus{\n            outline: 1px solid var(--surface-50);\n            .k-icon{\n                margin-top:-1px;\n            }\n        }\n    }\n    .k-grid-header, .k-grouping-header, .k-grid-add-row, .k-grid-footer, .k-table-thead, .k-grid-toolbar{\n        color:var(--primary-font-color);\n        font-size:0.75rem;\n        background-color:var(--surface-0);\n        border-color: var(--surface-50);\n        th, .k-table-th{\n            color:var(--primary-color);\n            font-size:0.75rem;\n            border-color: var(--surface-50);\n            overflow: hidden;\n            text-overflow: ellipsis;\n            min-height:28px;\n            .k-link{\n                padding-block: 4px;\n                padding-inline: 5px;\n            }\n            .k-grid-header-menu{\n                opacity:0;\n            }\n            &:hover .k-grid-header-menu{\n                opacity:1;\n                max-width:40px;\n            }\n            .k-sort-icon{\n                color:var(--primary-color);\n            }\n        }\n        tr{\n            .grid-footer-title{\n                font-size:10px;\n                font-weight: 600;\n                color:var(--primary-font-color);\n            }\n            .grid-footer-total{\n                font-size:12px;\n                font-weight: 900;\n                color:var(--secondary-font-color);\n                margin-bottom: 2px;\n            }\n        }\n        .k-cell-inner > .k-link > .k-grid-column-menu{\n            margin:0;\n            .k-icon{\n                margin-left:0.5rem;\n                background-color:var(--primary-color)\n            }\n        }\n        .k-filterable{\n            .k-grid-filter-menu{\n                opacity: 0;\n                color: var(--primary-font-color);\n                position: absolute;\n                top: 0;\n                right: 0;\n                height: 100%;\n                &:hover{\n                    background-color: var(--surface-100);\n                    color: var(--primary-font-color);\n                }\n                &:focus {\n                    box-shadow:none;\n                }\n                &.k-active{\n                    opacity: 1;\n                    background-color:var(--primary-color);\n                    position: relative;\n                    .k-icon{\n                        color:var(--white);\n                    }\n                }\n            }\n            &:hover{\n                .k-grid-filter-menu{\n                    opacity: 1;\n                    &.k-active{\n                        opacity: 1;\n                        background-color:var(--primary-color);\n                        position: relative;\n                        .k-icon{\n                            color:var(--white);\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .k-table, .k-data-table{\n        color:var(--primary-font-color);\n        font-size:0.75rem;\n    }\n    td, .k-table-td, .k-grid-md .k-grid-edit td{\n        border-color: var(--surface-50);\n        border-width: 0 0 1px 1px;\n        padding-block: 2px;\n        padding-inline: 5px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        &.k-grid-edit-row{\n            padding-block: 4px;\n            padding-inline: 5px;\n        }\n        .cp-input-container{\n\n        }\n    }\n    &.gridHeaderTextWrap{\n        .k-column-title{\n            vertical-align: middle;\n            white-space: pre-line;\n            text-overflow: clip;\n        }\n        .k-header{\n            vertical-align: middle;\n        }\n        .k-table-th > .k-link{\n            white-space: pre-line;\n        }\n    }\n    .k-column-title{\n        width:calc(100% - 6px);\n    }\n    .k-table-row{\n        &.k-state-selected, &.k-selected > .k-table-td{\n            color:var(--primary-font-color);\n            background-color:var(--surface-50) !important;\n            box-shadow:inset 0 0 4px 0 var(--light-blue);\n        }\n        &.mgrApprovedCol .approveCol {\n            background: var(--alert-success-opacity);\n        }\n        &.isPartiallyApprovedCol .approveCol {\n            background-color: var(--alert-warning-opacity);\n        }\n        &.zeroHourHighlight {\n            background: var(--alert-danger-opacity);\n        }\n        &.inFinanceCol .approveCol {\n            background: var(--alert-success-opacity);\n        }\n        &.isBeingApprovedCol .approveCol {\n            background: var(--alert-warning-opacity);\n        }\n        &.k-table-alt-row{\n            background:var(--surface-0);;\n        }\n        &.readonly{\n            background:rgba( var(--surface-200-rgb), 0.4) !important;\n            cursor:default;\n            &:focus, &:focus-within, &.k-state-focus, &.k-state-focused{\n                background:rgba( var(--surface-200-rgb), 0.4);\n                cursor:default;\n            }\n            &:hover{\n                border:1px solid var(--surface-300);\n            }\n        }\n    }\n\n    tr{\n        &:hover, &.k-state-hover{\n            color:var(--primary-font-color);\n            background-color:var(--surface-50) !important;\n        }\n        &.k-state-selected > td {\n            color:var(--primary-font-color);\n            background-color:transparent !important;\n        }\n        &.k-state-selected, &.k-selected > .k-table-td{\n            color:var(--primary-font-color);\n            background-color:var(--surface-50) !important;\n            box-shadow:inset 0 0 4px 0 var(--light-blue);\n        }\n        &.k-alt, .k-alt:hover{\n            background-color:#ffffff;\n        }\n        &.drover{\n            box-shadow: inset 0px 2px 0px 0px var(--primary-color) !important;\n            &.inFinance{\n                box-shadow:\n                inset 0px 2px 0px 0px  blue,\n                inset 0px  0px  0px  1px  green,\n                inset 0px  0px  0px  1px  green,\n                inset 0px  0px  0px  1px  green !important;\n            }\n        }\n    }\n    .k-hierarchy-cell{\n        .k-i-plus{\n            font-size:14px;\n            &::before{\n                content:'\\f067';\n            }\n        }\n        .k-iminus{\n            font-size:14px;\n            &::before{\n                content:'\\f068';\n            }\n        }\n        &+td{\n            border-left-width: 1px;\n        }\n    }\n    .k-detail-row{\n        .k-hierarchy-cell{\n            background-color: var(--light-grey);\n            &+td{\n                border-left-width: 0px;\n            }\n            &:hover{background-color:#ffffff;}\n        }\n        &:hover{background-color:#ffffff !important;}\n        .k-state-hover{background-color:#ffffff !important;}\n        .k-detail-cell{\n            padding:0px;\n            &:hover{background-color:#ffffff;}\n        }\n    }\n    .col-checkbox{\n        min-width:40px;\n        max-width:40px;\n        width: 40px;\n        text-align: center !important;\n        align-items: center;\n        justify-content: center;\n    }\n    .col-i-button{\n        min-width:40px;\n        max-width:40px;\n        width: 40px;\n        text-align: center !important;\n        align-items: center;\n        justify-content: center;\n        .k-button{\n            line-height:0;\n        }\n    }\n    .col-i-double-button{\n        min-width:90px;\n        max-width:90px;\n        width: 90px;\n        text-align: center !important;\n        align-items: center;\n        justify-content: center;\n        .dataWrap{\n            white-space:nowrap;\n            overflow:hidden;\n            text-overflow:ellipsis;\n            &.gridButtons{\n                .k-button{\n                    margin:0 5px;\n                    &:first-child{\n                        margin:0;\n                    }\n                }\n            }\n        }\n    }\n    &.forceGridWrap {\n        .k-table-td{\n            white-space:normal !important;\n            overflow:auto !important;\n            text-overflow:revert !important;\n            .k-input{\n                .k-input-values{\n                    flex-flow: row wrap !important;\n                }\n            }\n        }\n    }\n    &.forceGridWrap {\n        .k-table-td{\n            white-space:normal !important;\n            overflow:auto !important;\n            text-overflow:revert !important;\n        }\n    }\n}\n\n\n//Grid Row Colors\n\n.color-label, .k-grid tr, .k-item span {\n    &.green {\n        background-color: rgba( var(--alert-success-rgb), 0.3) !important;\n\n        &.k-state-selected > td, &:hover {\n            background-color: rgba( var(--alert-success-rgb), 0.5) !important;\n            color: var(--secondary-font-color);\n        }\n    }\n    &.yellow {\n        background-color: rgba( var(--alert-warning-rgb), 0.35) !important;\n\n        &.k-state-selected > td, &:hover {\n            background-color: rgba( var(--alert-warning-rgb), 0.6) !important;\n            color: var(--secondary-font-color);\n        }\n    }\n    &.blue {\n        background-color:rgba( var(--alert-info-rgb), 0.3) !important;\n        &.k-state-selected > td, &:hover{\n            background-color:rgba( var(--alert-info-rgb), 0.6) !important;\n            color:var(--white);\n        }\n    }\n    &.grey {\n        background-color: rgba( var(--dark-grey-rgb), 0.35) !important;\n\n        &.k-state-selected > td, &:hover {\n            background-color: rgba( var(--dark-grey-rgb), 0.5) !important;\n            color: var(--secondary-font-color);\n        }\n    }\n    &.red {\n        background-color: rgba( var(--alert-danger-rgb), 0.3) !important;\n\n        &.k-state-selected > td, &:hover {\n            background-color: rgba( var(--alert-danger-rgb), 0.5) !important;\n            color: var(--secondary-font-color);\n        }\n    }\n}\n\n.gridDetailReasonWrap{\n    left: 0;\n    width: 100%;\n    padding:10px 5px;\n    .gridDetailReason{\n        width:100%;\n        padding:5px 5px 5px 0;\n        white-space:pre-line;\n        font-size:11px;\n        overflow-wrap: break-word;\n        word-wrap: break-word;\n        hyphens: auto;\n        background-color: var(--light-grey);\n    }\n}\n\n\n.gridToolBarWrap{\n    width:100%;\n    display:flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    & > * {\n        margin-right:10px;\n    }\n    & > *:last-child{\n        margin-right:0 !important;\n    }\n    h1{\n        flex-grow:1;\n        font-size:1rem;\n        font-weight:800;\n        margin:0;\n        padding:0;\n        color:var(--primary-font-color);\n        &.requiredGrid {\n            color: var(--alert-danger);\n        }\n    }\n    .gridToolbarSubtitle{\n        flex-grow:1;\n        font-size:0.875rem;\n        font-weight:500;\n        margin:0 0 0 10px;\n        padding:0;\n        color:var(--primary-font-color);\n    }\n    .buttons{\n        flex-grow:2;\n        display:flex;\n        flex-flow:row nowrap;\n        align-items:center;\n        justify-content:flex-end;\n        & > *{\n            margin-right:10px;\n        }\n        & > *:last-child{\n            margin-right:0 !important;\n        }\n        .left{\n            margin-right:auto !important;\n        }\n        .k-button:is(:only-child){\n            width:auto !important;\n        }\n\n    }\n    .separator{\n        width:1px;\n        height:30px;\n        background-color:#d5dde2;\n    }\n    @media only screen and (min-width:var(--media-min)) and (max-width:var(--media-tablet)){\n        flex-flow:row wrap;\n    }\n}\n\n// * Globally removes extra upload action buttons when in used in a grid.\n.k-grid {\n    .k-upload .k-actions {\n        display: none;\n    }\n\n    .k-upload-files {\n        display: none !important;\n    }\n\n    .k-dropzone-hint {\n        display: none !important;\n    }\n\n    .dropZoneElement {\n        width: 1px !important;\n        height: 1px !important;\n        text-align: center !important;\n    }\n}\n\n// Grid Loader\n.k-grids{\n    .k-loading-mask{\n        .k-loading-text{}\n        .k-loading-image{}\n        .k-loading-color{\n            background-color: var(--surface-50);\n            opacity: .3;\n            backdrop-filter: blur(2px);\n        }\n    }\n}\n\n.newGridStyles{\n    .k-grid{\n        .k-grid-edit-row{\n            .k-table-td{\n                position:relative;\n                padding-block: 0;\n                padding-inline: 0;\n                .k-input{\n                    border-radius:0;\n                }\n                input{\n                    padding-block: 0;\n                    padding-inline: 0;\n                }\n                .dateOverlap{\n                    position: absolute;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    height: 28px;\n                    width: 20px;\n                    right: 20px;\n                    top: 1px;\n                    color: #E02222 !important;\n                    z-index: 2;\n                    background: var(--white);\n                    cursor:pointer;\n                }\n            }\n        }\n    }\n}\n.grid-link{\n    font-size:0.625rem;\n    font-style: italic;\n    display:flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    & i {\n        font-size:0.5rem;\n    }\n}\n","@use '/src/assets/scss/cp-variables' as *;\n\n.k-calendar{\n    border-color:var(--surface-200);\n    .k-calendar-navigation{\n        background:var(--surface-50);\n        color:var(--primary-font-color);\n        box-shadow: inset -1px 0 var(--surface-200);\n        li:hover{color:var(--primary-color);}\n        .k-calendar-navigation-highlight{\n            border-color:var(--surface-200);\n            color:var(--primary-color);\n        }\n    }\n    .k-calendar-infinite {\n        .k-calendar-header{\n           .k-button{\n               color:var(--primary-color);\n           }\n        }\n        .k-calendar-weekdays{\n            color:var(--primary-font-color);\n        }\n    }\n    .k-calendar-view{\n\n    }\n    .k-calendar-td{\n        color:var(--primary-color);\n        &:hover, &.k-hover, &:focus, &.k-focus{\n            background:var(--surface-50);\n        }\n        .k-link{\n            color:var(--primary-font-color);\n        }\n        &.k-today{\n            color:var(--primary-color);\n        }\n        &.k-selected{\n            .k-link{\n                background:var(--primary-color);\n                color:var(--surface-0);\n                &:hover, &.k-hover, &:focus, &.k-focus{\n                    background:var(--primary-600);\n                }\n            }\n        }\n        &.k-range-mid{\n            background:var(--primary-0);\n        }\n\n    }\n}\n\n.tech-panel-calendar{\n    .k-calendar, k-calendar-infinite{\n        .k-calendar-view{\n            padding-inline: 6px;\n        }\n    }\n}\n","@use \"./src/assets/scss/cp-variables.scss\" as *;\n.k-window{\n    position: fixed !important;\n    top: 5% !important;\n    max-width:90% !important;\n    background-color: #ffffff;\n    border-radius:var(--border-m-radius);\n    max-height: 90vh;\n    left: calc(-50vw + 50%) !important;\n    right: calc(-50vw + 50%) !important;\n    margin-left: auto !important;\n    margin-right: auto !important;\n    &.k-window-maximized {\n        max-width: 100vw !important;\n        max-height: 100vh !important;\n        box-shadow: none !important;\n        top: 0% !important;\n        .k-window-titlebar{\n            height:40px;\n            .k-icon{\n                font-size:14px;\n                height:34px;\n                width:34px;\n            }\n        }\n    }\n    .k-dialog-titlebar, .k-window-titlebar{\n        background-color:#ffffff;\n        padding:0px;\n        border-color: var(--border-color);\n        border-width:0px 0px 1px 0px;\n        border-radius:var(--border-m-radius-top);\n        color:var(--primary-font-color);\n        padding-left: 20px;\n        height:60px;\n        .k-window-title, .k-dialog-title{\n            line-height:2;\n        }\n        h1{\n            width:100%;\n            letter-spacing: -1px;\n            font-size: 24px;\n            margin: 10px 0;\n            font-weight: 300;\n        }\n        .dispatchInfo{\n        }\n        .k-icon{\n            font-size: 18px;\n            height:60px;\n            width:60px;\n            text-align: center;\n            line-height:60px;\n            color:var(--primary-font-color);\n        }\n        i{\n            position: relative;\n            height:60px;\n            width:60px;\n            font-size:18px;\n            color:var(--primary-font-color);\n            text-align: center;\n            line-height:60px;\n        }\n        .cp-lightox-search{\n            position: relative;\n            width:calc(100% - 120px);\n            height:59px;\n            font-size:18px;\n            border-radius:0px;\n            border-color: #ffffff;\n            &.ng-valid{\n                border-color: #ffffff !important;\n            }\n        }\n        .cp-lightox-search:focus{\n            border-color: #ffffff;\n        }\n        .windowActionBtn{\n            max-height:32px !important;\n        }\n        .k-button{\n            height:60px;\n            width:60px;\n            color:var(--primary-font-color);\n            text-align: center;\n            line-height:60px;\n            max-height:60px;\n            &:hover, &:active{\n                background-color:var(--surface-50) !important;\n                background:var(--surface-50)!important;\n                color:var(--primary-font-color);\n            }\n            i{\n            }\n            &.k-toggle-button.k-selected{\n                color:var(--white) !important;\n                &:hover, &:active{\n                    background-color:var(--primary-color)-hover;\n                    background:var(--primary-color)-hover;\n                }\n            }\n        }\n    }\n    .k-window-content{\n        padding:0px !important;\n        .k-dialog-actions{\n            border:none;\n            margin-top:1rem;\n        }\n        .attachmentWrap{\n            height:100%;\n            display: flex;\n            flex-direction: column;\n            position:relative;\n            iframe{\n                overflow:hidden;\n                height:100%;\n                min-height: 79vh;\n                width:100%;\n                flex-grow: 1;\n            }\n            img{\n                padding:30px;\n                max-width: 100%;\n                width:auto;\n                margin:0 auto;\n            }\n            .imageControls{\n                position: sticky;\n                display: flex;\n                flex-flow: row nowrap;\n                justify-content: center;\n                width:100%;\n                bottom:30px;\n                .wrap{\n                    box-shadow: var(--shadow-sm);\n                    button{\n                        width:50px;\n                        height:50px;\n                        border:none;\n                        background-color:var(--white);\n                        color:var(--primary-font-color);\n                        border:var(--border-style);\n                        &:hover{\n                            background-color:var(--light-grey);\n                        }\n                        &:first-child{\n                            border-radius:4px 0 0 4px;\n                        }\n                        & > *{\n                            border-right:none;\n                        }\n                        &:last-child{\n                            border-top-right-radius:0 4px 4px 0;\n                            border:var(--border-style);\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.k-dialog{\n    }\n    .cp-window-content{\n        padding:0px;\n        width:100%;\n        position: relative;\n    }\n    .cp-content-wrap{\n        padding:0px;\n        display:block;\n    }\n}\n\n.overflow-reset{\n    &.k-window .k-window-content{\n        overflow:unset;\n    }\n}\n\n//dialog\n.k-dialog-wrapper{\n}\n.k-dialog-buttongroup{\n    padding:0;\n    gap:0;\n    border-color:var(--border-color);\n    .k-button{\n        max-height:45px;\n        height:45px;\n        flex-grow:1;\n        margin:-1px;\n        border:var(--border-style);\n        color:var(--primary-font-color);\n        background-color:var(--white);\n        background:var(--white);\n        &:hover{\n            color:var(--primary-font-color);\n            background-color:var(--surface-50);\n            background:var(--surface-50);\n            border:var(--border-style);\n        }\n        &:focus::after{\n            border-color:var(--border-color);\n            box-shadow:none;\n        }\n        &.k-primary{\n            &:hover{\n                background-color: var(--primary-color);\n                border-color: var(--primary-color);\n                color:var(--white);\n            }\n        }\n    }\n}\n\n.k-overlay{\n    background-color: var(--secondary-font-color);\n    opacity:0.6;\n    pointer-events: none;\n}\n\n//Specific Window Sizes\n.assign-tech-window .k-window{\n    max-width:900px !important;\n}\n.dispatch-add-note-window{\n    max-width:720px !important;\n    .cp-content-wrap{\n        padding:30px;\n    }\n}\n.change-status-window{\n    max-width:400px !important;\n}\n.schedule-dispatches, .schedule-invoices{\n    max-width:90% !important;\n}\n.save-quote-template{\n    max-width:500px !important;\n}\n.receiving-window, .bills-window, .vendor-credits-window, .vendor-returns-window{\n    max-width:1080px !important;\n}\n.invoice-checklist-window{\n    max-width:720px !important;\n}\n.new-widget-window{\n    max-width:500px !important;\n}\n.save-dashboard-window{\n    max-width:500px !important;\n}\n.assignTechDialog{\n    z-index:99999;\n    .k-dialog{\n        max-width:400px !important;\n        @media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet)), only screen and (min-width: var(--media-min)) and (max-device-width: var(--media-tablet-pro)){\n            max-width:100% !important;\n        }\n    }\n}\n.confirmDialog{\n    z-index:199999;\n}\n.deleteAssignmentWindow, .changeStatusWindow{\n    .k-window{\n        max-width:600px !important;\n        @media only screen and (min-width:var(--media-min)) and (max-width:var(--media-tablet)), only screen and (min-width:var(--media-min)) and (max-device-width:var(--media-tablet-pro)){\n            max-width:100% !important;\n        }\n    }\n}\n\n\n//Responsive\n@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet)), only screen and (min-width: var(--media-min)) and (max-device-width: var(--media-tablet-pro)){\n    .k-window{\n        top:0 !important;\n        max-width:100% !important;\n        width:100% !important;\n        background-color:#ffffff;\n        border-radius:0;\n        height:100%;\n        max-height:100%;\n        left:0 !important;\n        right:0 !important;\n        margin-left:0 !important;\n        margin-right:0 !important;\n    }\n}\n",".cp-primary-tabs{\n    .k-tabstrip-items-wrapper{\n        border-bottom-width:0;\n        .k-tabstrip-items{\n            gap:4px;\n            .k-tabstrip-item{\n                color:var(--surface-0);\n                border-width:1px;\n                background:var(--primary-color);\n                &:hover{\n                    background:var(--primary-600);\n                }\n                &.k-active{\n                    border-color:var(--surface-100);\n                    border-width:1px;\n                    border-bottom-color:var(--white);\n                    color:var(--primary-color);\n                    background:var(--white);\n                    &:hover{\n                        background:var(--white);\n                        color:var(--primary-font-color);\n                    }\n                }\n            }\n        }\n    }\n    &.hideTabs{\n        .k-tabstrip-items-wrapper{\n            display:none;\n        }\n        .cp-secondary-tabs{\n            .k-tabstrip-items-wrapper{\n                display:flex;\n            }\n        }\n    }\n}\n.cp-secondary-tabs, .cp-small-tabs{\n    .k-tabstrip-items-wrapper{\n        border-bottom-width:1px;\n        border-color:var(--surface-100);\n        .k-tabstrip-items{\n            gap:4px;\n            .k-tabstrip-item{\n                border-radius: var(--border-m-radius-top);\n                border-width:0 0 1px 0;\n                color:var(--primary-font-color);\n                border-color:var(--surface-100);\n                background-color:var(--surface-0);\n                border-style: solid;\n                margin-bottom: -1px;\n                &.k-active, &:hover{\n                    border-width:0 0 2px 0;\n                    background:var(--white);\n                    border-color:var(--primary-color);\n                    border-bottom-color:var(--primary-color) !important;\n                    color:var(--primary-color);\n                }\n            }\n        }\n    }\n    .k-tabstrip-content{\n        padding-block: 1rem 0;\n        padding-inline: 0;\n    }\n}\n\n.k-tabstrip-content{\n    border-width: 0;\n}\n","@use \"/src/assets/scss/cpi-kendo/cp-kendo-buttons\";\n.k-editor {\n    border: var(--border-style);\n\tborder-radius:var(--border-m-radius);\n\t\n\t.k-toolbar, .k-editor-toolbar {\n\t\tborder:0px;\n\t\tborder-bottom: var(--border-style);\n\t\tcolor: var(--primary-font-color);\n\t\tbackground-color: var(--light-grey);\n    \tborder-radius: var(--border-m-radius-top);\n\t}\n\t.k-button{\n\t\t@extend %button-shared;\n\t\tborder:var(--border-style);\n\t\tbackground-color:#ffffff;\n\t\tpadding:0px;\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t&:hover{\n\t\t\tcolor:var(--primary-font-color);\n\t\t\tbackground-color: var(--surface-50);\n\t\t\tbackground: var(--surface-50);\n\t\t}\n\t\t.k-button-icon{\n            font-size: 10px;\n            color:var(--primary-font-color);\n        }\n\t}\n\t.k-dropdown .k-dropdown-wrap{\n\t\tcolor: var(--primary-font-color);\n\t\tborder: var(--border-style);\n\t\tbackground: #ffffff;\n\t}\n    .k-editor-content {\n        font-family: var(--font);\n    }\n}\n\n.k-editor-dialog{\n    .k-edit-form-container{\n        padding:30px !important;\n        .k-edit-label{\n            width:100%;\n            text-align: left;\n            margin:0px;\n            padding:0px;\n            label{\n                margin:0px;\n                font-size:12px;\n                font-weight:500;\n                color: var(--secondary-font-color);\n            }\n        }\n        .k-edit-field{\n            width:100%;\n            .k-input{\n                border:var(--border-style);\n                border-radius:var(--border-sm-radius);\n                color:var(--primary-font-color);\n                transition:none;\n                background-color:var(--white);\n                &:focus, &:focus-within, &.k-state-focus, &.k-state-focused{\n                    background-color:#ffffff;\n                    box-shadow:none;\n                }\n            }\n        }\n    }\n}\n","@use '/src/assets/scss/cp-variables' as *;\n:root{\n    --checkbox-size: 2em;\n    --radio-size-sm: calc(var(--checkbox-size) * 0.5);\n    --radio-size: calc(var(--checkbox-size) * 0.825);\n    --radio-size-lg: calc(var(--checkbox-size) * 1.125);\n}\n\n.k-checkbox{\n    border-color: var(--surface-100);\n    background-color: var(--white);\n    height:var(--checkbox-size);\n    width:var(--checkbox-size);\n    position:relative;\n    &:checked{\n        border-color: var(--primary-color);\n        color: white;\n        background-color: var(--white);\n        background-image:none;\n        &:focus{\n            box-shadow:none;\n            outline: none;\n            background:var(--surface-50);\n        }\n        &:before{\n            font-family: \"Font Awesome 5 Pro\";\n            font-weight: 900;\n            content: \"\\f00c\";\n            width: calc(var(--checkbox-size) - 2px);\n            height: calc(var(--checkbox-size) - 2px);\n            font-size: 1em;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: var(--primary-color);\n            position: absolute;\n        }\n    }\n    &:indeterminate, .k-checkbox.k-indeterminate{\n        color: var(--primary-color);\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%230255A5' stroke-linecap='square' stroke-linejoin='square' stroke-width='2' d='M4,8 h8'/%3e%3c/svg%3e\");\n    }\n    .gridCheckBox &{\n        width: calc(var(--checkbox-size) * 0.65);\n        min-width: calc(var(--checkbox-size) * 0.65);\n        height: calc(var(--checkbox-size) * 0.65);\n        margin:0;\n        &:before{\n            width: calc((var(--checkbox-size) * 0.85) - 2px);\n            height: calc((var(--checkbox-size) * 0.85) - 2px);\n            font-size: 0.8em;\n        }\n    }\n}\n\n\n.k-checkbox-label{\n    line-height:1;\n}\n\ninput[type=checkbox]:focus, input[type=file]:focus, input[type=radio]:focus{\n    box-shadow:none;\n    outline: none;\n    background:var(--surface-50);\n}\n.cp-checkbox{\n    display: inline-flex;\n    flex-flow: row;\n    align-items: center;\n    align-self: center;\n    label{\n        font-weight: 400;\n    }\n    &.cp-input-container{\n        margin: 13px 0 0 0;\n    }\n    &.gridCheckBox{\n        width: 100%;\n        justify-content: center;\n    }\n    &.rightAlignCheckbox{\n        gap: 1rem;\n    }\n}\n.gridToolBarWrap{\n    .cp-checkbox{\n        &.gridCheckBox{\n            width: auto;\n        }\n    }\n}\n\n.k-radio{\n    border-color: var(--surface-100);\n    background-color: var(--white);\n    position:relative;\n    &:before{\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        mask-size: calc(var(--current-size) + 6px) calc(var(--current-size) + 6px);\n        mask-repeat: no-repeat;\n        mask-position: center;\n        -webkit-mask-repeat: no-repeat;\n        -webkit-mask-position: center;\n    }\n    &-sm {\n        --current-size: var(--radio-size-sm);\n        height: var(--current-size);\n        width: var(--current-size);\n    }\n    &-md {\n        --current-size: var(--radio-size);\n        height: var(--current-size);\n        width: var(--current-size);\n    }\n    &-lg {\n        --current-size: var(--radio-size-lg);\n        height: var(--current-size);\n        width: var(--current-size);\n    }\n    &:checked, &.k-checked{\n        border-color: var(--primary-color);\n        color: var(--primary-color);\n        background-color: var(--surface-0);\n    }\n    &:focus, &:checked:focus, &.k-checked:focus{\n        box-shadow: 0 0 0 2px\n        color-mix(in srgb, var(--primary-color) 10%, transparent);\n    }\n    .k-disabled, .read-only{}\n}\n\n//Resets some bootstrap overrides.\ninput[type=checkbox], input[type=radio] {\n    margin: 0 !important;\n}\n",".k-icon{\n    font-size:0.875rem;\n\tfont-family: 'Font Awesome\\ 5 Pro', 'Font Awesome 5 Free', 'WebComponentsIcons' !important;\n\t&:before{\n\t\t//font-family: 'Font Awesome\\ 5 Free';\n\t\tfont-family: 'Font Awesome\\ 5 Pro', 'Font Awesome 5 Free', 'WebComponentsIcons' !important;\n\t}\n\t&.lg-icon{\n\t\tfont-size:20px;\n\t}\n\t&.md-icon{\n\t\tfont-size:16px;\n\t}\n\t&.sm-icon{\n\t\tfont-size:8px;;\n\t}\n    .k-input-button &, .k-input &, .k-combobox &{\n        font-size:0.625rem !important;\n    }\n}\n\n//Chevron Arrow - Up\n.k-i-arrow-60-up::before, .k-i-arrow-n::before, .k-i-sarrow-n::before, .k-i-expand-n::before, .k-i-caret-alt-up:before {\n    content: \"\\f077\";\n}\n//Chevron Arrow - Down\n.k-i-arrow-60-down::before, .k-i-arrow-s::before, .k-i-sarrow-s::before, .k-i-collapse::before, .k-i-expand-s::before, .k-i-caret-alt-down:before {\n    content: \"\\f078\";\n}\n//Chevron Arrow - Left\n.k-i-arrow-60-left::before, .k-i-arrow-w::before, .k-i-sarrow-w::before, .k-i-expand-w::before, .k-i-arrow-chevron-left::before, .k-i-arrowhead-w::before, .k-i-caret-alt-left:before {\n    content: \"\\f104\";\n}\n//Chevron Arrow - Right\n.k-i-arrow-60-right::before, .k-i-arrow-e::before, .k-i-sarrow-e::before, .k-i-expand::before, .k-i-expand-e::before, .k-i-arrow-chevron-right::before, .k-i-arrowhead-e::before, .k-i-caret-alt-right:before {\n    content: \"\\f105\";\n}\n\n\n\n//Close Icon (X)\n.k-i-close, .k-i-group-delete, .k-i-x{\n\t&::before{\n\t\tcontent: \"\\f00d\";\n\t}\n}\n.k-i-x-circle{\n    &::before{\n        content: \"\\f057\";\n    }\n}\n\n\n//Calendar\n.k-i-calendar::before {\n    content: \"\\f073\"; \n\tfont-weight: 500;\n}\n\n//Bold\n.k-i-bold::before {\n    content: \"\\f032\";\n}\n//Italic\n.k-i-italic::before {\n    content: \"\\f033\";\n}\n//Underline\n.k-i-underline::before {\n    content: \"\\f0cd\";\n}\n//Align Left\n.k-i-align-left::before {\n    content: \"\\f036\";\n}\n//Align Center\n.k-i-align-center::before {\n    content: \"\\f037\";\n}\n//Align Right\n.k-i-align-right::before {\n    content: \"\\f038\";\n}\n//Align Justify\n.k-i-align-justify::before {\n    content: \"\\f039\";\n}\n//Link\n.k-i-link-horizontal::before {\n    content: \"\\f0c1\";\n}\n//Unlink\n.k-i-unlink-horizontal::before {\n    content: \"\\f127\";\n}\n//Unlink\n.k-i-image::before {\n    content: \"\\f03e\";\n}\n//Unordered List Icon\n.k-i-list-unordered::before, .k-i-insert-unordered-list::before {\n    content: \"\\f03a\";\n}\n//Ordered List Icon\n.k-i-list-ordered::before, .k-i-insert-ordered-list::before {\n    content: \"\\f0cb\";\n}\n\n//Indent\n.k-i-indent-increase::before {\n    content: \"\\f03c\";\n}\n//Indent Decrease\n.k-i-indent-decrease::before {\n    content: \"\\f03c\";\n\ttransform: scale(1, -1);\n}\n\n//Save\n.k-i-save::before {\n    content: \"\\f0c7\";\n}\n//Edit\n.k-i-edit::before {\n    content: \"\\f044\";\n}\n\n//Square Plus [+]\n.k-i-plus::before, .k-plus::before, .k-i-add::before {\n    content: \"\\f0fe\";\n}\n\n//Square Minus [-]\n.k-i-minus::before, .k-minus::before, .k-i-subtract::before {\n    content: \"\\f146\";\n}\n\n\n//Cancle, Ban, No!\n.k-i-cancel::before {\n    content: \"\\f05e\";\n}\n\n//Reset Arrow Circle\n.k-i-reset::before {\n    content: \"\\f2f1\";\n}\n\n\n//Clock\n.k-i-clock::before {\n    content: \"\\f017\";\n\tfont-weight: 500;\n}\n\n//Start\n.k-i-play::before {\n    content: \"\\f144\";\n\tfont-weight: 500;\n}\n\n//Stop\n.k-i-stop::before {\n    content: \"\\f28d\";\n\tfont-weight: 500;\n}\n\n//Window Minimize _\n.k-i-window-minimize::before, .k-i-minimize::before {\n    content: \"\\f2d1\";\n}\n//Window Maximize [``]\n.k-i-window-maximize::before, .k-i-maximize::before {\n    content: \"\\f2d0\";\n}\n//Window Restore [] [ ]\n.k-i-window-restore::before, .k-i-restore::before {\n    content: \"\\f2d2\";\n}\n\n//Download\n.k-i-download::before{\n    content: \"\\f019\";\n}\n\n//Double Chevron Arrow - Left\n.k-i-arrow-end-left::before, .k-i-seek-w::before, .k-i-caret-alt-to-left:before {\n    content: \"\\f100\";\n}\n//Double Chevron Arrow - Right\n.k-i-arrow-end-right::before, .k-i-seek-e::before, .k-i-caret-alt-to-right:before {\n    content: \"\\f101\";\n}\n\n// Search\n.k-i-search::before {\n\tcontent: \"\\f002\";\n}\n\n//Arrors Alt\n.k-i-arrows-alt::before{\n\tcontent:\"\\f0b2\";\n}\n\n// Eye\n.k-i-eye::before{\n\tcontent:\"\\f06e\";\n}\n\n// Eye Slash\n.k-i-eye-slash::before{\n\tcontent:\"\\f070\";\n}\n\n// TH\n.k-i-th::before{\n\tcontent:\"\\f00a\";\n}\n\n// User Plus\n.k-i-user-plus::before{\n\tcontent:\"\\f234\";\n}\n\n// exchange\n.k-i-exchange::before{\n\tcontent:\"\\f362\";\n}\n\n// Globe\n.k-i-global::before{\n\tcontent:\"\\f0ac\";\n}\n\n// Star\n.k-i-star::before{\n\tcontent:\"\\f058\";\n}\n\n// Success\n.k-i-success::before{\n    content:\"\\f058\";\n    color:var(--alert-success) !important;\n}\n// Fail\n.k-i-error::before{\n    content:\"\\f057\";\n    color:var(--alert-danger) !important;\n}\n// Warning\n.k-i-warning::before{\n    content:\"\\f071\";\n    color:var(--alert-warning) !important;\n}\n// Info\n.k-i-info::before{\n    content:\"\\f05a\";\n}\n.k-i-filter::before {\n    content:\"\\f0b0\";\n}\n// Sort Ascending\n.k-i-sort-asc-sm {\n    color:var(--primary-color) !important;\n    &::before {\n    content: \"\\f161\";\n    }\n}\n// Sort Descending\n.k-i-sort-desc-sm{\n    color:var(--primary-color) !important;\n    &::before {\n        content: \"\\f160\";\n    }\n}\n// Vertical Dots Menu\n.k-i-more-vertical{\n    color:var(--primary-color) !important;\n    text-align: center;\n    &::before {\n        content: \"\\f142\";\n    }\n}\n// Columns\n.k-i-columns{\n    color:var(--primary-color) !important;\n    text-align: center;\n    &::before {\n        content: \"\\f0db\";\n    }\n}\n\n////////File Types///////////\n//Image\n.k-i-file-image::before{\n    content:\"\\f03e\";\n}\n//Text\n.k-i-file-txt::before{\n    content:\"\\f15c\";\n}\n//PDF\n.k-i-file-pdf::before, .k-i-pdf::before{\n    content:\"\\f1c1\";\n}\n//Excel\n.k-i-excel::before{\n    content:\"\\f1c3\";\n}\n\n//paste\n.k-i-paste-plain-text::before, .k-i-paste::before{\n    content:\"\\f0ea\";\n}\n\n//copy\n.k-i-copy::before{\n    content:\"\\f0c5\";\n}\n\n//briefcase\n.k-i-briefcase::before{\n    content:\"\\f0b1\";\n}\n//hard-hat\n.k-i-hard-hat::before{\n    content:\"\\f807\";\n    font-family: 'Font Awesome 5 Free' !important;\n    font-weight: 900;\n}\n\n//quote\n.k-i-quote::before{\n    content:\"\\f10e\";\n}\n\n//cart\n.k-i-cart::before{\n    content:\"\\f07a\";\n}\n\n//invoice\n.k-i-invoice::before{\n    content:\"\\f571\";\n}\n\n//Sync\n.k-i-sync::before{\n    content:\"\\f021\";\n}\n.iconStack {\n    display: grid;\n    grid-template: 1fr;\n    place-items: center;\n\n    i {\n        grid-column: 1;\n        grid-row: 1;\n        z-index: 1;\n        font-size: 8px;\n\n        &:last-child {\n            font-size: 16px;\n            z-index: 2;\n        }\n    }\n}\n",".k-splitter{\n\tbackground-color: transparent;\n\tborder-width: 0px;\n\t.k-splitbar{\n\t\tcolor: var(--primary-font-color);\n\t\tbackground-color: #D8D8D8;\n\t\t&.k-ghost-splitbar-vertical, &.k-splitbar-vertical{\n\t\t\theight:8px;\n\t\t}\n\t\t&:active, &.k-state-focused{\n\t\t\tcolor:var(--primary-color);\n\t\t\tbackground-color: #D8D8D8;\n\t\t}\n\t}\n}\n",".k-upload{\n    .k-action-buttons{\n        padding:8px;\n        border:none;\n        .k-button{\n            &:focus{\n            }\n            &.k-clear-selected{\n                color:var(--primary-font-color);\n                background-color:var(--white);\n                border:var(--border-style);\n                &:hover{\n                    background-color: var(--surface-50);\n                }\n            }\n        }\n    }\n    &.gridUpload {\n        .k-dropzone, .k-upload-dropzone{\n            border-color:transparent;\n            color:var(--primary-font-color);\n            background-color:transparent;\n            padding:0;\n            margin:0;\n            border-width:0;\n            .k-dropzone-hint{\n                display:none;\n            }\n        }\n        &:has(.k-upload-files){\n            .k-dropzone, .k-upload-dropzone{\n                display:none;\n            }\n            .k-upload-files{\n                border-width: 0;\n                li{\n                    font-size:0.75rem;\n                    padding: 0px;\n                    margin: 0px;\n                    overflow: hidden;\n                }\n            }\n        }\n        .k-actions{\n            display:none;\n        }\n    }\n}\n\n.imageUpload{\n    position: absolute;\n    top:0;\n    bottom:0;\n    left:0;\n    width:100%;\n    height:100%;\n    .k-widget, .k-upload{\n        border:none;\n        background-color: transparent;\n        height:100%;\n        .k-dropzone{\n            background:transparent;\n            .k-dropzone-hint{\n                display:none;\n            }\n            .k-button{\n                &.k-upload-button{\n                    border:var(--border-style);\n                    color:var(--primary-font-color);\n                    background-color:#ffffff;\n                    min-width:initial;\n                    margin:0px;\n                    span{\n                        font-family: 'Font Awesome\\ 5 Pro' !important;\n                        font-size:12px;\n                        font-weight: 900;\n                        line-height:12px;\n                        &:after{\n                            content: \"\\f093\";\n                        }\n                    }\n                    &:hover{\n                        color:var(--primary-font-color);\n                        background-color: var(--surface-50);\n                        background: var(--surface-50);\n                        border:var(--border-style);\n                    }\n                    &:focus::after{\n                        border-color:var(--primary-color);\n                        box-shadow:none;\n                    }\n                }\n            }\n        }\n        .k-action-buttons{\n            padding:0;\n            position: absolute;\n            width:100%;\n            bottom:0;\n            left:0;\n            border:none;\n            .k-button{\n                flex-grow: 1;\n                &:focus{\n                }\n                &.k-clear-selected{\n                    color:var(--primary-font-color);\n                    background-color:var(--white);\n                    border:var(--border-style);\n                    &:hover{\n                        background-color: var(--surface-50);\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n.upload-icon-btn{\n    .k-upload{\n        border-width: 0px;\n        background-color: transparent;\n        .k-dropzone{\n            .k-dropzone-hint{\n                display:none;\n                color:red;\n            }\n            .k-button{\n                &.k-upload-button{\n                    border:var(--border-style);\n                    color:var(--primary-font-color);\n                    background-color:#ffffff;\n                    min-width:initial;\n                    margin:0px;\n                    input{\n                        width:auto;\n                    }\n                    span{\n                        font-family:'Font Awesome\\ 5 Pro' !important;\n                        font-size:12px;\n                        font-weight:900;\n                        line-height:12px;\n                        cursor:pointer;\n                        &:after{\n                            content:\"\\f093\";\n                        }\n                    }\n                    &:hover{\n                        color:var(--primary-font-color);\n                        background-color: var(--surface-50);\n                        background: var(--surface-50);\n                        border:var(--border-style);\n                    }\n                    &:focus::after{\n                        border-color:var(--primary-color);\n                        box-shadow:none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n#image-upload.hideFile{\n    .k-upload .k-upload-files{\n        display:none;\n    }\n}\n\n.customUploads{\n    .upload{\n        flex-grow:1;\n        margin:15px;\n        cursor:pointer;\n        .k-upload{\n            .k-dropzone{\n                border:none;\n                padding:0px;\n                cursor:pointer;\n                .k-upload-button-wrap{\n                    width:100%;\n                    height:40px;\n                    .k-button{\n                        cursor:pointer;\n                        &.k-upload-button{\n                            position:relative;\n                            width:100%;\n                            height: 100%;\n                            color:var(--white);\n                            min-width:initial;\n                            margin:0px;\n                            cursor:pointer;\n                            span{\n                                font-family: var(--font) !important;\n                                font-size:12px;\n                                font-weight:900;\n                                line-height:12px;\n                                cursor:pointer;\n                                &:after{\n                                    content:\"Upload\";\n                                    cursor:pointer;\n                                }\n                            }\n                            &:hover{\n                                background-color:var(--primary-color)-hover;\n                                background:var(--primary-color)-hover;\n                            }\n                            &:focus::after{\n                                border-color:var(--primary-color)-hover;\n                                box-shadow:none;\n                            }\n                        }\n                    }\n                    .k-dropzone-hint{display:none;}\n                }\n            }\n        }\n    }\n}\n",".k-notification-group{\n    z-index:9999999;\n    padding:1rem;\n    gap: 1rem;\n    .k-notification{\n        border-radius: var(--border-m-radius);\n        padding: 1rem;\n        border-width: 1px;\n        border-style: solid;\n        font-size: 1rem;\n        line-height: 1.4285714286rem;\n        position: relative;\n        gap:0.625rem;\n        box-shadow:var(--shadow-md);\n        .k-notification-status{\n            font-size:1.5rem;\n            width: 1.5rem;\n        }\n        .k-notification-actions{\n            .k-notification-action{\n                .k-icon{\n                    font-size:1.25rem;\n                }\n            }\n        }\n        .k-notification-wrap{\n           /* display: flex;\n            flex-direction: row;\n            flex-wrap: nowrap;\n            font-size: 16px;\n            line-height: 20px;\n            padding: 10px 5px;\n            min-width: 220px;*/\n            .k-notification-content{\n                margin-right: 1rem;\n                flex: 1 1 auto;\n            }\n        }\n        .k-notification-content{\n            flex: 1 1 fit-content;\n        }\n        &-success{\n            border-color: var(--alert-success);\n            color: var(--primary-font-color);\n            background-color: var(--notification-success-bg);\n        }\n        &-warning{\n            border-color: var(--alert-warning);\n            color: var(--primary-font-color);\n            background-color: var(--notification-warning-bg);\n        }\n        &-error{\n            border-color: var(--alert-danger);\n            color: var(--primary-font-color);\n            background-color: var(--notification-error-bg);\n        }\n        &-info{\n            border-color: var(--border-color);\n            color: var(--primary-font-color);\n            background-color: #ffffff;\n        }\n    }\n}\n",".k-scrollview {\n  .k-scrollview-wrap {\n    //border:var(--border-style);\n    li {\n      display: flex;\n      min-height: 100%;\n      width: 100% !important;\n      background-color: rgba( var(--surface-800-rgb), 0.5);\n      overflow: hidden;\n      position: absolute;\n      top: 0;\n      left: 0;\n      img {\n        object-fit: contain;\n        min-width: 100%;\n        min-height: 100%;\n        width: 100%;\n      }\n      .placeholder {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        font-size: 1rem;\n        text-align: center;\n        color: transparent;\n        &:before {\n          text-indent: auto;\n          content: \"\\f03e\";\n          margin: 4rem 0 0 0;\n          font-size: 8rem;\n          font-family: \"Font Awesome 5 Pro\", \"Font Awesome 5 Free\" !important;\n          color: #ffffff;\n          height: 50%;\n          justify-content: center;\n          align-items: flex-end;\n          display: flex;\n        }\n        &:after {\n          text-indent: auto;\n          margin: 1rem 0;\n          content: \"There was an error loading the image. Contact support if this issue persists.\";\n          color: #ffffff;\n        }\n        i {\n          margin: 4rem 0;\n          font-size: 8rem;\n        }\n        p {\n          margin: 1rem 0;\n        }\n      }\n      .header {\n        background-color: rgba( var(--surface-800-rgb), 0.8);\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        margin: 0;\n        padding: 15px;\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        align-content: center;\n        .title {\n          color: #ffffff;\n          text-align: left;\n          font-size: 24px;\n          font-weight: 500;\n          margin: 0;\n        }\n        .removeBtn {\n          color: #ffffff;\n        }\n      }\n    }\n  }\n  .k-scrollview-elements {\n    .k-scrollview-next,\n    .k-scrollview-prev {\n      text-shadow: rgb(0 0 0 / 100%) 0 0 5px;\n      height: calc(100% - 60px);\n      top: 60px;\n      width: 3rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: rgba( var(--surface-700-rgb), 0.2);\n      transition: all 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n      .k-icon {\n        font-size: 2.2rem;\n      }\n      &:hover {\n        width: 4rem;\n        background-color: rgba( var(--surface-700-rgb), 0.6);\n      }\n    }\n    .k-scrollview-nav-wrap {\n      .k-scrollview-pageable,\n      .k-scrollview-nav {\n        .k-button {\n          box-shadow: inset 0 0 2px rgb(0 0 0 / 8%);\n          background: var(--surface-0);\n          border: var(--surface-0);\n          &.k-primary {\n            background: var(--primary-color);\n            border: var(--primary-color);\n          }\n        }\n      }\n    }\n  }\n}\n\n.partImage {\n  .k-scrollview {\n    min-height: 220px;\n    max-height: 220px;\n    .k-scrollview-wrap {\n      li {\n        background-color: var(--white);\n      }\n    }\n  }\n}\n\n.k-dialog-content {\n  .scrollViewWrap {\n  }\n}\n",".myClass{\n    width: 150px;\n}\n.timeText {\n    font-size:0.75rem;\n    color:var(--primary-font-color);\n    opacity: 0.5;\n    margin: -6px 0 0 -6px\n}\n\n.k-event-drag-hint{\n    opacity: 0.8;\n    z-index:9999999;\n}\n\n.k-event{\n    min-height: 34px !important;\n    .k-event-actions{\n        display:none\n    }\n    &.k-selected{\n        box-shadow: none;\n    }\n}\n\n.k-scheduler{\n    border-color: var(--surface-100);\n    color: var(--primary-font-color);\n    background-color: var(--white);\n    border-width: 0;\n    outline: none;\n    font-size: 0.875rem;\n    table{\n        td{\n        }\n    }\n\n    .k-scheduler-toolbar{\n        padding:4px;\n        border-color:var(--surface-100);\n        flex-flow: row;\n        .dispatchSchedulerHeader{\n            display:flex;\n            flex-flow: row nowrap;\n            justify-content: space-between;\n            align-items: center;\n            position:fixed;\n            .k-scheduler-navigation{\n                margin-right:0.75rem;\n                .k-nav-today, .k-nav-prev, .k-nav-next {\n                    font-size:0.75rem;\n                    color:var(--primary-font-color);\n                    border:1px solid;\n                    border-color:var(--surface-100);\n                    background-color:var(--white);\n                    .k-button-icon{color:var(--primary-font-color);}\n                    &:hover{\n                        color:var(--primary-font-color);\n                        background-color:var(--surface-50);\n                        background:var(--surface-50);\n                        border:1px solid;\n                        border-color:var(--surface-100);\n                        .k-button-icon{color:var(--primary-font-color);}\n                    }\n                    &:focus::after{\n                        border-color:var(--surface-100);\n                        box-shadow:none;\n                    }\n                }\n                .k-i-calendar{\n                }\n            }\n            .k-scheduler-views{\n                background:green;\n                li{\n                    &:hover{\n                    }\n                    &:focus::after{\n                    }\n                    &.k-state-selected{\n                        a{\n                            &:focus{\n                            }\n                        }\n                    }\n                }\n            }\n            .viewChangeWrap{\n                display: flex;\n                flex-flow: row nowrap;\n                margin: 0 1rem 0 0;\n                .viewChange{\n                    margin-left:1rem;\n                }\n            }\n        }\n        ul{\n            &.k-scheduler-navigation{\n                .k-scheduler-navigation{\n\n                }\n            }\n            &.k-scheduler-views{\n                li{\n                    &.k-state-selected{\n                    }\n                }\n            }\n        }\n    }\n    .k-scheduler-layout{\n        .k-scheduler-pane{\n            .k-scheduler-header, .k-scheduler-content{\n                .k-scheduler-header-wrap .k-event, .k-event{\n                    margin:0;\n                    height:36px !important;\n                    background-color: var(--white);\n                    box-shadow:none;\n                    overflow:default;\n                    &:hover{\n                        .dispatch{\n                            box-shadow: var(--shadow-sm);\n                            transform: scale(1.02);\n                            transition-duration: 0.2s;\n                        }\n                    }\n                    &.k-selected{\n                        .dispatch{\n                            box-shadow: var(--shadow-sm);\n                            transform: scale(1.02);\n                            transition-duration: 0.2s;\n                        }\n                    }\n                    .k-event-delete{\n                        display:none;\n                    }\n                }\n            }\n\n\n            .k-scheduler-table{\n                .k-event{\n                }\n            }\n            .k-scheduler-times{\n                tr{\n                    th{\n                    }\n                }\n            }\n            .k-scheduler-header{\n                .k-scheduler-header-wrap{\n                    .k-scheduler-header-all-day{\n                    }\n                }\n                th{\n                }\n            }\n            .k-scheduler-content{\n                .k-scheduler-table{\n                    td{\n                    }\n                }\n            }\n            .k-event{\n                .k-state-selected{\n                }\n                & > div, .k-event > div {\n                }\n            }\n        }\n        &.k-scheduler-workWeekview{\n            .k-scheduler-pane{\n                .k-scheduler-table{\n                    th{\n                    }\n                }\n                .k-scheduler-times{\n                    tr{\n                        th{\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .k-scheduler-footer{\n        .k-scheduler-navigation{\n            position:fixed;\n            .k-scheduler-fullday{\n            }\n        }\n    }\n}\n.techPanelContainer {\n    .k-scheduler{\n        .k-scheduler-layout{\n            .k-scheduler-pane{\n                .k-event{\n                    .k-event-actions{\n                        .k-event-delete{\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.weekViewWrap{\n    .hide-all-day .k-scheduler-table tr:nth-of-type(0),\n    .k-scheduler-times-all-day,\n    .k-scheduler-table.k-scheduler-header-all-day{\n    }\n}\n","@use '/src/assets/scss/cp-variables' as *;\n.cp-widget .k-tilelayout-item-body{padding-top:0;}\n.k-tilelayout{\n    grid-template-columns: repeat(2, 1fr) !important;\n    background:transparent;\n    .k-tilelayout-item{\n        border-width: 0;\n        color:var(--primary-font-color);\n        z-index:unset;\n        .k-tilelayout-item-header{\n            display: inherit;\n            font-size:14px;\n            font-weight: 400;\n            border-width: 0;\n            color:var(--primary-font-color);\n        }\n        .k-tilelayout-item-body{\n            display: inherit;\n            color:var(--primary-font-color);\n            &:has(.maximized) {\n                display: block;\n                //animation: scale-in-ver-top 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n            }\n            &:has(.minimized){\n                display: block;\n                //animation: scale-in-ver-top 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) reverse both;\n            }\n        }\n        &:has(.fullscreen-widget){\n            //animation: scale-in-center 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n            position: fixed;\n            background:#ffffff;\n            width: 100%;\n            height: 100%;\n            top: 0px;\n            left: 0px;\n            z-index: 999;\n        }\n        &:has(.minimized){\n            height:54px;\n            //animation: heightChange 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n        }\n        &:has(.maximized){\n            height:auto;\n            //animation: heightChange 0.2s cubic-bezier(0.250, 0.460, 0.450, 0.940) reverse both;\n        }\n\n    }\n    .dispatchStatusGauge-widget, .dispatchRefTrack-widget{\n        background:var(--primary-color);\n        .k-tilelayout-item-header, .k-tilelayout-item-body{\n            background:var(--primary-color);\n        }\n    }\n    @media only screen and (min-width: var(--media-min)) and (max-width: var(--media-tablet-pro)){\n        grid-template-columns: repeat(1, 1fr) !important;\n        .k-tilelayout-item{\n            grid-column: 1 / span 1;\n        }\n    }\n}\n\n@keyframes scale-in-ver-top {\n    0% {\n        -webkit-transform: scaleY(0);\n        transform: scaleY(0);\n        -webkit-transform-origin: 100% 0%;\n        transform-origin: 100% 0%;\n        opacity: 1;\n    }\n    100% {\n        -webkit-transform: scaleY(1);\n        transform: scaleY(1);\n        -webkit-transform-origin: 100% 0%;\n        transform-origin: 100% 0%;\n        opacity: 1;\n    }\n}\n@keyframes scale-in-center {\n    0% {\n        -webkit-transform: scale(0);\n        transform: scale(0);\n        opacity: 1;\n    }\n    100% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes heightChange{\n    0%{height:auto;}\n    100%{height:54px;}\n}\n","@use '/src/assets/scss/cp-variables' as *;\n\n.k-chip {\n    color: var(--secondary-font-color);\n    &.k-chip-sm{\n        padding-block: 0.2rem;\n        padding-inline: 0.2rem;\n        font-size: 0.75rem;\n        line-height: 1;\n    }\n}\n","@use '/src/assets/scss/cp-variables' as *;\n\n.k-switch{\n    &.k-switch-on{\n        .k-switch-track{\n            border-color:var(--primary-color);\n            background-color:var(--primary-color);\n        }\n        &:focus, &.k-focus {\n            .k-switch-track{\n                outline: 2px solid var(--primary-100);\n            }\n        }\n    }\n    &.k-switch-off{}\n}\n\nkendo-label .k-switch{\n    margin-left:0.5rem;\n}\n","@use \"./src/assets/scss/cp-variables.scss\" as *;\n//@use './src/assets/scss/fontawesome-pro-master/scss/fontawesome.scss';\n\n//Tool Tip\n@use \"../scss/cpi-kendo/cp-kendo-tooltip\";\n\n//Inputs\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-input.scss\";\n\n\n//Buttons\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-buttons.scss\";\n\n//Grid\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-grid.scss\";\n\n//Calendar\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-calendar.scss\";\n\n//Pop Up\n//@use \"./src/assets/scss/cpi-kendo/cp-kendo-.scss\";\n\n//Window\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-window.scss\";\n\n//Tabstrip\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-tabstrip.scss\";\n\n//Editor\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-editor.scss\";\n\n//Radio Buttons/Check Boxes\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-checkRadio.scss\";\n\n//Icons\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-icons.scss\";\n\n//Split Panel\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-splitpanel.scss\";\n\n//Upload\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-upload.scss\";\n\n//Toasts\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-toasts.scss\";\n\n//Scroll View\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-scrollView.scss\";\n\n//Scheduler\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-scheduler\";\n\n//TileLayout\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-tileLayout\";\n\n//Chips\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-chips\";\n\n//Switch\n@use \"./src/assets/scss/cpi-kendo/cp-kendo-switch\";\n\n@import url('https://use.fontawesome.com/releases/v5.8.1/css/all.css');\n\n.k-textbox::selection, .k-input::selection, .k-textarea::selection, .k-widget ::selection, .k-block ::selection, .k-panel ::selection{\n\tbackground-color: var(--textHighlightBgColor) !important;\n\tcolor: var(--textHighlightFontColor) !important;\n}\n\n\n\n.k-state-disabled, .k-widget[disabled] {\n    outline: none;\n    cursor: default;\n    opacity: 1.0;\n    -webkit-filter: grayscale(0.0);\n    filter: grayscale(0.0);\n    pointer-events: none;\n    box-shadow: none;\n\tbackground-color:var(--light-grey) !important;\n\tcolor:var(--disabled-font-color);\n}\n\n\n\n\n.k-content > .ProseMirror {\n    padding: 20px;\n}\n\n    //TODO: BW, confirm if this is duplicate\n.cp-search-lightbox{\n\t.k-dialog-titlebar, .k-window-titlebar{padding:0px;}\n}\n\n\n// Chart\n.chart-center{\n\twidth: 140%;\n    height: 140%;\n    border-radius: 50%;\n    background-color: #ffffff;\n    position: absolute;\n}\n\n.k-chart, .k-stockchart {\n    font-size: 12px;\n    min-height: 450px;\n    .k-chart-overlay {\n        z-index: 1;\n    }\n}\n\n.k-var--chart-inactive {\n    background-color: rgba(101, 101, 101, 0.0);\n}\n\n.k-var--chart-major-lines {\n    background-color: rgba(0, 0, 0, 0.00);\n}\n\n.k-var--chart-minor-lines {\n    background-color: rgba(0, 0, 0, 0.0);\n}\n\n.k-var--chart-area-opacity {\n    opacity: .8;\n}\n\n.k-var--chart-notes-background {\n    background-color: rgba(0, 0, 0, 0.0);\n}\n\n.k-var--chart-notes-border {\n    background-color: rgba(0, 0, 0, 0.0);\n}\n\n.k-var--chart-notes-lines {\n    background-color: rgba(0, 0, 0, 0.0);\n}\n\n.k-var--chart-crosshair-background {\n    background-color: rgba(0, 0, 0, 0.0);\n}\n\n.k-var--chart-error-bars-background {\n    background-color: rgba(0, 0, 0, 0.0);\n}\n\n.k-chart,\n.k-sparkline,\n.k-stockchart {\n    background-color: transparent;\n}\n\n.k-chart .k-popup,\n.k-sparkline .k-popup,\n.k-stockchart .k-popup {\n    background: transparent;\n}\n\n.k-chart-tooltip-wrapper{\n    z-index:900;\n}\n\n.k-chart-tooltip {\n    border-radius: 2px;\n    color: #fff;\n}\n\n.k-chart-tooltip-inverse {\n    color: #000;\n}\n\n.k-chart-crosshair-tooltip,\n.k-chart-shared-tooltip {\n    color: pink;\n    //background-color: #pink;\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\n.cp-list-button-dropdown {\n    width: auto;\n    .k-dropdown-wrap{\n        border-width:0px;\n        color:var(--primary-font-color);\n        background-image: none;\n        background-clip: unset;\n        width:0px;\n\n        .k-input{\n            display: none;\n        }\n        .k-select{\n            padding: 10px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width:auto;\n            background-color:#ffffff;\n            border-radius: var(--border-sm-radius);\n            border-color: var(--border-color);\n            &:hover{\n                background-color:var(--table-border-color);\n            }\n            .k-icon {\n                width:auto;\n                height:auto;\n                line-height:auto;\n                &:before {\n                    content: \"\\f03a\";\n                    font-family: FontAwesome;\n                    font-size: 1.75em;\n                }\n            }\n        }\n    }\n}\n\n.kendo-ddlist .k-dropdown-wrap .k-icon:before {\n    content: \"\\f03a\";\n    font-family: FontAwesome;\n    font-size: 1.75em;\n}\n\n.kendo-ddlist {\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
